const database =[
    {
        "id": 11215,
        "date": "2023-09-06T18:31:10",
        "date_gmt": "2023-09-06T18:31:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=11215"
        },
        "modified": "2023-09-11T18:29:02",
        "modified_gmt": "2023-09-11T18:29:02",
        "slug": "pcn-new-cervix-self-screening",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/pcn-new-cervix-self-screening/",
        "title": {
            "rendered": "New Cervix Self-Screening HPV Test"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            212
        ],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "It is expected that starting in January of 2024, people in BC can complete cervix self-screening to test for HPV.",
            "related_resources": [
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/11215"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11215"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11215"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=11215"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11157,
        "date": "2023-08-28T19:11:40",
        "date_gmt": "2023-08-28T19:11:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=11157"
        },
        "modified": "2023-08-28T19:13:59",
        "modified_gmt": "2023-08-28T19:13:59",
        "slug": "but-i-dont-do-maternity-care-cme-series",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/but-i-dont-do-maternity-care-cme-series/",
        "title": {
            "rendered": "But I Don’t Do Maternity Care CME series"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "The Division is proud to be collaborating with UBC CPD to create the But I Don’t Do Maternity Care CME series",
            "related_resources": [
                148
            ],
            "related_campaigns": [
                91
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/11157"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11157"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11157"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=11157"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6410,
        "date": "2023-08-22T09:49:33",
        "date_gmt": "2023-08-22T09:49:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=6410"
        },
        "modified": "2023-09-18T21:37:37",
        "modified_gmt": "2023-09-18T21:37:37",
        "slug": "agm",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/agm/",
        "title": {
            "rendered": "Annual General Meeting 2023"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            179
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Important information about your 2023 Annual General Meeting (AGM) and the membership vote, to be held Thursday October 19th.",
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/6410"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6410"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6410"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6410"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10953,
        "date": "2023-08-10T23:53:09",
        "date_gmt": "2023-08-10T23:53:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=10953"
        },
        "modified": "2023-08-10T23:53:09",
        "modified_gmt": "2023-08-10T23:53:09",
        "slug": "a-day-in-the-life-of-a-preceptor-cme",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/a-day-in-the-life-of-a-preceptor-cme/",
        "title": {
            "rendered": "A Day in the Life of a Preceptor CME"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Learn about being a preceptor",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/10953"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10953"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10953"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=10953"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10195,
        "date": "2023-05-09T17:50:39",
        "date_gmt": "2023-05-09T17:50:39",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=10195"
        },
        "modified": "2023-08-16T23:21:55",
        "modified_gmt": "2023-08-16T23:21:55",
        "slug": "community-of-practice-supporting-chinese-speaking-patients",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/community-of-practice-supporting-chinese-speaking-patients/",
        "title": {
            "rendered": "CoP Supporting Chinese-speaking Patients"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Resources from community partners that provide translation, social prescribing, patient navigation",
            "related_resources": [
                196,
                119
            ],
            "related_campaigns": [],
            "related_events": [
                173
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/10195"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10195"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10195"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=10195"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9701,
        "date": "2023-03-21T19:31:02",
        "date_gmt": "2023-03-21T19:31:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=9701"
        },
        "modified": "2023-05-24T23:33:03",
        "modified_gmt": "2023-05-24T23:33:03",
        "slug": "clinical-management-of-alcohol-use-disorder",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/clinical-management-of-alcohol-use-disorder/",
        "title": {
            "rendered": "Clinical Management of Alcohol Use Disorder"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Information and resources on the Clinical Management of Alcohol Use Disorder.",
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/9701"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9701"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9701"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=9701"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8847,
        "date": "2023-03-20T17:12:50",
        "date_gmt": "2023-03-20T17:12:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8847"
        },
        "modified": "2023-05-24T16:01:38",
        "modified_gmt": "2023-05-24T16:01:38",
        "slug": "understanding-the-access-assessment-centre",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/understanding-the-access-assessment-centre/",
        "title": {
            "rendered": "Understanding the Access &#038; Assessment Centre"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            117
        ],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Details on how to effectively use the AAC in Vancouver.",
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8847"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8847"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8847"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8847"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8734,
        "date": "2023-03-03T20:06:42",
        "date_gmt": "2023-03-03T20:06:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8734"
        },
        "modified": "2023-08-18T16:20:44",
        "modified_gmt": "2023-08-18T16:20:44",
        "slug": "membership-pins",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/membership-pins/",
        "title": {
            "rendered": "Membership Pins"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2668,
            "post-excerpt": "The Vancouver Division is proud to recognize long term members with a commemorative Years of Membership pin.",
            "related_resources": [
                111
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8734"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8734"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/111"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8734"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8734"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8707,
        "date": "2023-02-07T23:28:27",
        "date_gmt": "2023-02-07T23:28:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8707"
        },
        "modified": "2023-05-24T23:27:18",
        "modified_gmt": "2023-05-24T23:27:18",
        "slug": "physician-peer-support",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/physician-peer-support/",
        "title": {
            "rendered": "Physician Peer Support"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            165
        ],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Supporting physician colleagues in a 1:1 setting to improve coping and self-management skills.",
            "related_resources": [
                195,
                129
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8707"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8707"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8707"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8707"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8601,
        "date": "2023-01-13T23:10:30",
        "date_gmt": "2023-01-13T23:10:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8601"
        },
        "modified": "2023-09-12T22:11:05",
        "modified_gmt": "2023-09-12T22:11:05",
        "slug": "pcn-ipt-engagement-series",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/pcn-ipt-engagement-series/",
        "title": {
            "rendered": "PCN Interprofessional Team (IPT) Engagement Series"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            152
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "A new online series to connect Interprofessional Team (IPT) clinicians and primary care providers working together in PCNs.",
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152
            ],
            "related_events": [
                205
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8601"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8601"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/205"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8601"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8601"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8270,
        "date": "2022-11-30T10:28:16",
        "date_gmt": "2022-11-30T10:28:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8270"
        },
        "modified": "2023-06-02T22:37:40",
        "modified_gmt": "2023-06-02T22:37:40",
        "slug": "grow-your-practice-pai",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/grow-your-practice-pai/",
        "title": {
            "rendered": "Grow Your Practice &#8211; Patient Attachment Initiative"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Growing Your Practice: Accepting patients through the Vancouver Division",
            "related_resources": [
                162
            ],
            "related_campaigns": [
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8270"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8270"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8270"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8270"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8084,
        "date": "2022-11-24T13:26:41",
        "date_gmt": "2022-11-24T13:26:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8084"
        },
        "modified": "2023-06-02T22:49:09",
        "modified_gmt": "2023-06-02T22:49:09",
        "slug": "grow-your-practice-batch-rate-matching",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/grow-your-practice-batch-rate-matching/",
        "title": {
            "rendered": "Grow Your Practice &#8211; Batch-Rate Matching Program"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Growing Your Practice: Accepting patients through the Vancouver Division",
            "related_resources": [
                162
            ],
            "related_campaigns": [
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8084"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8084"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8084"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8084"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8077,
        "date": "2022-11-24T12:01:08",
        "date_gmt": "2022-11-24T12:01:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8077"
        },
        "modified": "2023-08-10T19:48:20",
        "modified_gmt": "2023-08-10T19:48:20",
        "slug": "retirement-support",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/retirement-support/",
        "title": {
            "rendered": "Retirement Support"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Retirement Support – access support in preparing for and during your transition to retirement.",
            "related_resources": [
                72
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8077"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8077"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8077"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8077"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8071,
        "date": "2022-11-24T11:22:58",
        "date_gmt": "2022-11-24T11:22:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=8071"
        },
        "modified": "2023-05-10T12:39:25",
        "modified_gmt": "2023-05-10T12:39:25",
        "slug": "ntp-pcn-contracts",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/ntp-pcn-contracts/",
        "title": {
            "rendered": "New To Practice (NTP) Primary Care Network (PCN) Contracts"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "NTP PCN Contracts initiative to help recruit family physicians in BC.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/8071"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8071"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8071"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8071"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7530,
        "date": "2022-11-04T18:10:47",
        "date_gmt": "2022-11-04T18:10:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=7530"
        },
        "modified": "2022-11-09T00:40:13",
        "modified_gmt": "2022-11-09T00:40:13",
        "slug": "engagement-project",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/engagement-project/",
        "title": {
            "rendered": "New to Practice &#038; Resident Engagement Project"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Engaging and understanding what attracts new-to-practice and resident physicians to primary care, and how to retain them.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/7530"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7530"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7530"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=7530"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6789,
        "date": "2022-10-12T10:09:21",
        "date_gmt": "2022-10-12T10:09:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=6789"
        },
        "modified": "2022-11-17T09:45:14",
        "modified_gmt": "2022-11-17T09:45:14",
        "slug": "clinic-grants-2022-23",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/clinic-grants-2022-23/",
        "title": {
            "rendered": "Clinic Grants 2022/23"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            185
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "VDOFP Grants for PMH Practice Improvement and Building Primary Care Networks",
            "related_resources": [
                186
            ],
            "related_campaigns": [
                168
            ],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/6789"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6789"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6789"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6789"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6030,
        "date": "2022-09-28T09:56:49",
        "date_gmt": "2022-09-28T09:56:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=6030"
        },
        "modified": "2022-12-21T19:05:46",
        "modified_gmt": "2022-12-21T19:05:46",
        "slug": "flu-vaccine-2022",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/flu-vaccine-2022/",
        "title": {
            "rendered": "Flu Vaccine 2022/23"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            168
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "Important information on influenza vaccine delivery and availability.",
            "related_resources": [
                169
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/6030"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6030"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6030"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6030"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6583,
        "date": "2022-09-27T16:31:09",
        "date_gmt": "2022-09-27T16:31:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=initiative&#038;p=6583"
        },
        "modified": "2022-10-12T16:57:20",
        "modified_gmt": "2022-10-12T16:57:20",
        "slug": "primary-care-crisis",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/primary-care-crisis/",
        "title": {
            "rendered": "Primary Care Crisis"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            184
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "The Vancouver Division of Family Practice and partner organizations support for the current Primary Care Crisis in Vancouver.",
            "related_resources": [
                170
            ],
            "related_campaigns": [
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/6583"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6583"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6583"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6583"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2859,
        "date": "2022-06-16T04:17:03",
        "date_gmt": "2022-06-16T04:17:03",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=campaign&#038;p=2859"
        },
        "modified": "2023-03-21T21:17:43",
        "modified_gmt": "2023-03-21T21:17:43",
        "slug": "cbt-skills-group",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/cbt-skills-group/",
        "title": {
            "rendered": "CBT Skills Groups"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            79,
            117
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "CBT Skills Groups is a MSP-covered skills training program designed by psychiatrists and taught by physicians.",
            "related_resources": [
                119,
                118
            ],
            "related_campaigns": [
                79,
                117,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/2859"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=2859"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2859"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=2859"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2588,
        "date": "2022-06-15T14:10:09",
        "date_gmt": "2022-06-15T14:10:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=campaign&#038;p=2588"
        },
        "modified": "2023-03-06T21:38:12",
        "modified_gmt": "2023-03-06T21:38:12",
        "slug": "easi-maternity-care-project",
        "status": "publish",
        "type": "initiative",
        "link": "https://van-division.yarko.dev/initiative/easi-maternity-care-project/",
        "title": {
            "rendered": "EASI Maternity Care Project"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "campaign_topic": [
            91
        ],
        "acf": {
            "post-icon": 2240,
            "post-excerpt": "The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.",
            "related_resources": [
                148
            ],
            "related_campaigns": [
                91,
                184
            ],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative/2588"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/initiative"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=2588"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2588"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "campaign_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=2588"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11323,
        "date": "2023-09-12T21:46:54",
        "date_gmt": "2023-09-12T21:46:54",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=11323"
        },
        "modified": "2023-09-12T22:09:39",
        "modified_gmt": "2023-09-12T22:09:39",
        "slug": "ipt-engagement-series-a-multidisciplinary-approach-to-managing-substance-use-marijuana-dependency",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-substance-use-marijuana-dependency/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Managing Substance Misuse (marijuana dependency)"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "This series helps to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/11323"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11323"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11323"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11323"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10657,
        "date": "2023-08-22T15:00:50",
        "date_gmt": "2023-08-22T15:00:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10657"
        },
        "modified": "2023-08-22T22:29:53",
        "modified_gmt": "2023-08-22T22:29:53",
        "slug": "vancouver-division-2023-annual-general-meeting",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/vancouver-division-2023-annual-general-meeting/",
        "title": {
            "rendered": "Vancouver Division 2023 Annual General Meeting"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "The Vancouver Division of Family Practice Annual General Meeting (AGM) will take place on Thursday October 19, 2023 at 6:00pm",
            "related_resources": [
                167
            ],
            "related_campaigns": [],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10657"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10657"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10657"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10657"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11118,
        "date": "2023-08-21T19:22:28",
        "date_gmt": "2023-08-21T19:22:28",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=11118"
        },
        "modified": "2023-08-21T19:22:28",
        "modified_gmt": "2023-08-21T19:22:28",
        "slug": "bc-echo-on-substance-use-session",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/bc-echo-on-substance-use-session/",
        "title": {
            "rendered": "BC Echo on Substance Use Session"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Care Guidance for Benzodiazepine Prescribing\r\n",
            "related_resources": [
                119
            ],
            "related_campaigns": [],
            "related_events": [
                197
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/11118"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11118"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11118"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11118"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11116,
        "date": "2023-08-21T18:31:38",
        "date_gmt": "2023-08-21T18:31:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=11116"
        },
        "modified": "2023-08-21T18:31:38",
        "modified_gmt": "2023-08-21T18:31:38",
        "slug": "therapeutics-initiative-annual-course",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/therapeutics-initiative-annual-course/",
        "title": {
            "rendered": "Therapeutics Initiative Annual Course"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "This year’s TI conference will be offered virtually on Saturday, October 14th, 2023, from 8:30 am-12:45 pm.",
            "related_resources": [
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/11116"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11116"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11116"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11116"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11114,
        "date": "2023-08-21T18:17:18",
        "date_gmt": "2023-08-21T18:17:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=11114"
        },
        "modified": "2023-08-21T18:17:18",
        "modified_gmt": "2023-08-21T18:17:18",
        "slug": "35th-annual-diabetes-directors-seminar",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/35th-annual-diabetes-directors-seminar/",
        "title": {
            "rendered": "35th Annual Diabetes Directors Seminar"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "An annual gathering of leading diabetes experts and caregivers across British Columbia.",
            "related_resources": [
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/11114"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11114"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11114"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11114"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11120,
        "date": "2023-08-20T19:32:06",
        "date_gmt": "2023-08-20T19:32:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=11120"
        },
        "modified": "2023-08-22T22:27:18",
        "modified_gmt": "2023-08-22T22:27:18",
        "slug": "vlat-learning-session-pillars-of-harm-reduction-for-youth",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/vlat-learning-session-pillars-of-harm-reduction-for-youth/",
        "title": {
            "rendered": "VLAT Learning Session: Pillars of Harm Reduction for Youth"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "This session is organized by the Vancouver LAT, a coalition of organizations (including the VDoFP) ",
            "related_resources": [
                119
            ],
            "related_campaigns": [],
            "related_events": [
                197
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/11120"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11120"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11120"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11120"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10967,
        "date": "2023-08-11T00:15:38",
        "date_gmt": "2023-08-11T00:15:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10967"
        },
        "modified": "2023-08-11T00:15:38",
        "modified_gmt": "2023-08-11T00:15:38",
        "slug": "healthy-minds-healthy-distractions",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/healthy-minds-healthy-distractions/",
        "title": {
            "rendered": "Healthy Minds, Healthy Distractions"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "In this hands-on workshop, participants can try cedar bark weaving and learn ways to support Indigenous Cultural Safety.",
            "related_resources": [
                129
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10967"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10967"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10967"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10967"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10405,
        "date": "2023-05-16T16:18:40",
        "date_gmt": "2023-05-16T16:18:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10405"
        },
        "modified": "2023-05-16T16:18:40",
        "modified_gmt": "2023-05-16T16:18:40",
        "slug": "bccsu-session-on-considerations-for-stimulant-use-disorder-care",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/bccsu-session-on-considerations-for-stimulant-use-disorder-care/",
        "title": {
            "rendered": "BCCSU Session on Considerations for Stimulant Use Disorder Care"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join the upcoming CME accredited BC ECHO on Substance Use session on Considerations for Stimulant Use Disorder Care",
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10405"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10405"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10405"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10405"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10258,
        "date": "2023-05-02T19:27:25",
        "date_gmt": "2023-05-02T19:27:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10258"
        },
        "modified": "2023-08-16T23:35:44",
        "modified_gmt": "2023-08-16T23:35:44",
        "slug": "but-i-dont-do-maternity-care-cme-series-online",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/but-i-dont-do-maternity-care-cme-series-online/",
        "title": {
            "rendered": "But I Don’t Do Maternity Care CME series (Online)"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Focus on maternity care and deliveries for a workshop focused on preconception and early prenatal care.",
            "related_resources": [
                148
            ],
            "related_campaigns": [
                91
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10258"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10258"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10258"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10258"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10257,
        "date": "2023-05-02T19:26:43",
        "date_gmt": "2023-05-02T19:26:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10257"
        },
        "modified": "2023-05-02T19:27:54",
        "modified_gmt": "2023-05-02T19:27:54",
        "slug": "but-i-dont-do-maternity-care-cme-series-in-person",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/but-i-dont-do-maternity-care-cme-series-in-person/",
        "title": {
            "rendered": "But I Don’t Do Maternity Care CME series (In-Person)"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Focus on maternity care and deliveries for a workshop focused on preconception and early prenatal care.",
            "related_resources": [
                148,
                71
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10257"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10257"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10257"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10257"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10090,
        "date": "2023-04-18T17:18:18",
        "date_gmt": "2023-04-18T17:18:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10090"
        },
        "modified": "2023-08-16T23:37:29",
        "modified_gmt": "2023-08-16T23:37:29",
        "slug": "implants-and-iuds-comparing-and-inserting-long-acting-reversible-contraceptives-larc",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/implants-and-iuds-comparing-and-inserting-long-acting-reversible-contraceptives-larc/",
        "title": {
            "rendered": "Implants and IUDs: Comparing and Inserting Long Acting Reversible Contraceptives"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join us in person at Morris J Wosk Centre for Dialogue in Vancouver, BC to discover the contraceptive landscape",
            "related_resources": [
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10090"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10090"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10090"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10090"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10082,
        "date": "2023-04-17T22:27:31",
        "date_gmt": "2023-04-17T22:27:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10082"
        },
        "modified": "2023-04-18T17:10:57",
        "modified_gmt": "2023-04-18T17:10:57",
        "slug": "bcaccs-matters-of-the-mind-understanding-eating-disorders",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/bcaccs-matters-of-the-mind-understanding-eating-disorders/",
        "title": {
            "rendered": "BCACC&#8217;s Matters of the Mind: Understanding Eating Disorders"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Causes, contributing factors, common myths, and how to support someone in recovery.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10082"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10082"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10082"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10082"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10081,
        "date": "2023-04-17T22:24:16",
        "date_gmt": "2023-04-17T22:24:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10081"
        },
        "modified": "2023-08-16T23:38:29",
        "modified_gmt": "2023-08-16T23:38:29",
        "slug": "understanding-the-new-health-professions-and-occupations-act-webinar",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/understanding-the-new-health-professions-and-occupations-act-webinar/",
        "title": {
            "rendered": "Understanding the new Health Professions and Occupations Act Webinar"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Understand what the HPOA will mean for physicians, patients, and the profession as whole",
            "related_resources": [
                163
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10081"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10081"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10081"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10081"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10650,
        "date": "2023-04-04T19:49:57",
        "date_gmt": "2023-04-04T19:49:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10650"
        },
        "modified": "2023-08-16T17:27:28",
        "modified_gmt": "2023-08-16T17:27:28",
        "slug": "vancouver-division-summer-block-party",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/vancouver-division-summer-block-party/",
        "title": {
            "rendered": "Vancouver Division Summer Block Party"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join for our Summer Block Party at St James' Community Square!",
            "related_resources": [
                129
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10650"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10650"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10650"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10650"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9997,
        "date": "2023-04-04T19:05:30",
        "date_gmt": "2023-04-04T19:05:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9997"
        },
        "modified": "2023-04-04T19:05:30",
        "modified_gmt": "2023-04-04T19:05:30",
        "slug": "acute-care-of-at-risk-newborns-acorn-workshop",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/acute-care-of-at-risk-newborns-acorn-workshop/",
        "title": {
            "rendered": "Acute Care of At-Risk Newborns (ACoRN) Workshop"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "",
            "related_resources": [
                148
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9997"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9997"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9997"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9997"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9962,
        "date": "2023-03-29T23:25:20",
        "date_gmt": "2023-03-29T23:25:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9962"
        },
        "modified": "2023-05-03T20:27:46",
        "modified_gmt": "2023-05-03T20:27:46",
        "slug": "ipt-engagement-series-a-multidisciplinary-approach-to-intimate-partner-violence",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-intimate-partner-violence/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Intimate Partner Violence"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "A new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [
                153
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9962"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9962"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9962"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9962"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9961,
        "date": "2023-03-29T21:52:58",
        "date_gmt": "2023-03-29T21:52:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9961"
        },
        "modified": "2023-05-03T20:20:25",
        "modified_gmt": "2023-05-03T20:20:25",
        "slug": "ipt-engagement-series-a-multidisciplinary-approach-to-patients-with-low-socio-economic-status",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-patients-with-low-socio-economic-status/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Patients with Low Socio-economic Status"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "A new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [
                153
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9961"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9961"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9961"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9961"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9833,
        "date": "2023-03-21T22:00:21",
        "date_gmt": "2023-03-21T22:00:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9833"
        },
        "modified": "2023-04-26T22:44:30",
        "modified_gmt": "2023-04-26T22:44:30",
        "slug": "first-nations-community-longhouse-experiential-learning-session",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/first-nations-community-longhouse-experiential-learning-session/",
        "title": {
            "rendered": "First Nations Community &#038; Longhouse Experiential Learning Session"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "A cultural experiential learning session for physicians held by JCCs, Musqueam First Nation and Len Pierre Consulting",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9833"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9833"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9833"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9833"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9822,
        "date": "2023-03-21T20:30:24",
        "date_gmt": "2023-03-21T20:30:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9822"
        },
        "modified": "2023-08-16T23:42:26",
        "modified_gmt": "2023-08-16T23:42:26",
        "slug": "bccsu-session-on-opioid-use-disorder-and-continuity-of-care-when-transitioning-between-settings-from-acute-care-to-community",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/bccsu-session-on-opioid-use-disorder-and-continuity-of-care-when-transitioning-between-settings-from-acute-care-to-community/",
        "title": {
            "rendered": "BCCSU Session on Opioid Use Disorder and Continuity of Care"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Session covers Opioid Use Disorder and Continuity of Care Transitioning Between Settings: From Acute Care to Community",
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9822"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9822"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9822"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9822"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9819,
        "date": "2023-03-21T20:01:38",
        "date_gmt": "2023-03-21T20:01:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9819"
        },
        "modified": "2023-05-12T21:08:59",
        "modified_gmt": "2023-05-12T21:08:59",
        "slug": "22nd-annual-bc-endocrine-day",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/22nd-annual-bc-endocrine-day/",
        "title": {
            "rendered": "22nd Annual BC Endocrine Day"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "The Endocrine Research Society is hosting an interactive case-based review of common endocrine problems.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9819"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9819"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9819"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9819"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9696,
        "date": "2023-03-21T18:04:36",
        "date_gmt": "2023-03-21T18:04:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9696"
        },
        "modified": "2023-03-27T20:40:54",
        "modified_gmt": "2023-03-27T20:40:54",
        "slug": "ipt-engagement-series-a-multidisciplinary-approach-to-managing-obesity",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-obesity/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Managing Obesity"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9696"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9696"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9696"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9696"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9642,
        "date": "2023-03-08T16:53:42",
        "date_gmt": "2023-03-08T16:53:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9642"
        },
        "modified": "2023-04-14T22:23:21",
        "modified_gmt": "2023-04-14T22:23:21",
        "slug": "career-options-explorations",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/career-options-explorations/",
        "title": {
            "rendered": "Career Options &#038; Explorations Event"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "Career Options and Explorations Event will help family physicians prepare for the many professional decisions they will face.",
            "related_resources": [
                163,
                162,
                70
            ],
            "related_campaigns": [
                185
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9642"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9642"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9642"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9642"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10553,
        "date": "2023-03-07T16:15:59",
        "date_gmt": "2023-03-07T16:15:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=10553"
        },
        "modified": "2023-08-16T17:33:15",
        "modified_gmt": "2023-08-16T17:33:15",
        "slug": "2023-physician-clinic-owners-forum-clinic-culture-hr",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/2023-physician-clinic-owners-forum-clinic-culture-hr/",
        "title": {
            "rendered": "2023 Physician Clinic Owners Forum &#8211; Clinic Culture &#038; HR"
        },
        "featured_media": 0,
        "comment_status": "closed",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Register for the 2023 Physician Clinic Owners Forum by no later than Friday, June 16th.\r\n\r\n",
            "related_resources": [
                186,
                190,
                163
            ],
            "related_campaigns": [],
            "related_events": [
                205
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/10553"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10553"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/205"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/190"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10553"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10553"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9293,
        "date": "2023-02-23T19:29:24",
        "date_gmt": "2023-02-23T19:29:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=9293"
        },
        "modified": "2023-04-18T20:04:26",
        "modified_gmt": "2023-04-18T20:04:26",
        "slug": "ipt-engagement-series-a-multidisciplinary-approach-to-managing-pain",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-pain/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Managing Pain"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/9293"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9293"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9293"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9293"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8599,
        "date": "2023-01-13T22:43:25",
        "date_gmt": "2023-01-13T22:43:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=8599"
        },
        "modified": "2023-04-18T20:10:10",
        "modified_gmt": "2023-04-18T20:10:10",
        "slug": "a-multidisciplinary-approach-to-managing-anxiety",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/a-multidisciplinary-approach-to-managing-anxiety/",
        "title": {
            "rendered": "IPT Engagement Series: A Multidisciplinary Approach to Managing Anxiety"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            205
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.",
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/8599"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8599"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8599"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8599"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8349,
        "date": "2022-12-12T16:47:51",
        "date_gmt": "2022-12-12T16:47:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=8349"
        },
        "modified": "2023-01-25T18:31:19",
        "modified_gmt": "2023-01-25T18:31:19",
        "slug": "clinical-management-of-alcohol-use-disorder-workshop",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/clinical-management-of-alcohol-use-disorder-workshop/",
        "title": {
            "rendered": "Clinical Management of Alcohol Use Disorder Workshop"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            173,
            198,
            172
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Need support for clinical management of alcohol use disorder? Join Dr. Olivia Brooks for a CME-accredited workshop.",
            "related_resources": [
                119,
                195
            ],
            "related_campaigns": [
                165,
                117
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/8349"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8349"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8349"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8349"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8039,
        "date": "2022-11-22T22:43:05",
        "date_gmt": "2022-11-22T22:43:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=8039"
        },
        "modified": "2022-11-22T22:43:05",
        "modified_gmt": "2022-11-22T22:43:05",
        "slug": "58th-annual-family-practice-review",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/58th-annual-family-practice-review/",
        "title": {
            "rendered": "58th Annual Family Practice Review"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join Drs Marnie Wilson and Emily G. McDonald on December 14 at 12 pm for a Best Evidence Webinar. ",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/8039"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8039"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8039"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8039"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8037,
        "date": "2022-11-22T22:25:33",
        "date_gmt": "2022-11-22T22:25:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=8037"
        },
        "modified": "2022-11-22T22:36:41",
        "modified_gmt": "2022-11-22T22:36:41",
        "slug": "best-evidence-webinar-drug-drug-interactions-in-older-adults-with-polypharmacy-prescribed-nirmatrelvir-ritonavir",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/best-evidence-webinar-drug-drug-interactions-in-older-adults-with-polypharmacy-prescribed-nirmatrelvir-ritonavir/",
        "title": {
            "rendered": "Best Evidence Webinar: Drug-drug interactions in older adults with polypharmacy prescribed nirmatrelvir-ritonavir"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join Drs Marnie Wilson and Emily G. McDonald on December 14 at 12 pm for a Best Evidence Webinar. ",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/8037"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8037"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8037"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8037"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7621,
        "date": "2022-11-09T00:48:49",
        "date_gmt": "2022-11-09T00:48:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=7621"
        },
        "modified": "2022-11-09T00:48:49",
        "modified_gmt": "2022-11-09T00:48:49",
        "slug": "best-evidence-webinar-climate-conscious-inhaler-prescribing",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/best-evidence-webinar-climate-conscious-inhaler-prescribing/",
        "title": {
            "rendered": "Best Evidence Webinar: Climate-Conscious Inhaler Prescribing"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Climate-Conscious Inhaler Prescribing: Tackling Climate Change, One Pen Stroke at a Time will take place November 16.",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/7621"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7621"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7621"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=7621"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7594,
        "date": "2022-11-08T01:45:46",
        "date_gmt": "2022-11-08T01:45:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=7594"
        },
        "modified": "2022-11-08T01:49:37",
        "modified_gmt": "2022-11-08T01:49:37",
        "slug": "icon-virtual-chinese-health-forum",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/icon-virtual-chinese-health-forum/",
        "title": {
            "rendered": "iCON Virtual Chinese Health Forum"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "iCON Chinese Health Forum: “Take Charge of Your Health: Living Well Together with Diabetes” will take place November 19 & 20.",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/7594"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7594"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7594"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=7594"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6740,
        "date": "2022-10-06T22:01:07",
        "date_gmt": "2022-10-06T22:01:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6740"
        },
        "modified": "2022-10-13T16:50:39",
        "modified_gmt": "2022-10-13T16:50:39",
        "slug": "celebrating-indigenous-physicians-in-bc-cultural-safety-and-anti-racism-from-indigenous-physicians-perspectives",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/celebrating-indigenous-physicians-in-bc-cultural-safety-and-anti-racism-from-indigenous-physicians-perspectives/",
        "title": {
            "rendered": "Celebrating Indigenous Physicians in BC: Cultural Safety and Anti-Racism"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Celebrate the 20th anniversary of the UBC Faculty of Medicine’s Indigenous Pathway program with this webinar.",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                152,
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6740"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6740"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6740"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6740"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6739,
        "date": "2022-10-06T21:24:59",
        "date_gmt": "2022-10-06T21:24:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6739"
        },
        "modified": "2022-10-06T21:24:59",
        "modified_gmt": "2022-10-06T21:24:59",
        "slug": "fast-evidence-in-person-workshop",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/fast-evidence-in-person-workshop/",
        "title": {
            "rendered": "FAST Evidence: In-Person Workshop"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Learn how to find accurate evidence-based medical information fast!",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                152,
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6739"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6739"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6739"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6739"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6738,
        "date": "2022-10-06T21:18:48",
        "date_gmt": "2022-10-06T21:18:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6738"
        },
        "modified": "2022-10-13T16:52:39",
        "modified_gmt": "2022-10-13T16:52:39",
        "slug": "communication-course-navigating-challenging-conversations-across-the-system",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/communication-course-navigating-challenging-conversations-across-the-system/",
        "title": {
            "rendered": "Communication: Navigating Challenging Conversations Across the System"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "In this one-day workshop you will learn a simple four-stage framework to navigate difficult conversations.",
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                152,
                165
            ],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6738"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6738"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6738"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6738"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6259,
        "date": "2022-09-01T02:10:34",
        "date_gmt": "2022-09-01T02:10:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6259"
        },
        "modified": "2022-09-01T02:11:35",
        "modified_gmt": "2022-09-01T02:11:35",
        "slug": "68th-annual-st-pauls-family-medicine-conference",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/68th-annual-st-pauls-family-medicine-conference/",
        "title": {
            "rendered": "68th Annual St. Paul’s Family Medicine Conference"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            178
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Register to attend virtually or in-person at the Vancouver Convention Centre (West).",
            "related_resources": [
                125
            ],
            "related_campaigns": [
                152
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6259"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6259"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6259"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6259"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6258,
        "date": "2022-09-01T02:03:32",
        "date_gmt": "2022-09-01T02:03:32",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6258"
        },
        "modified": "2022-09-01T02:04:47",
        "modified_gmt": "2022-09-01T02:04:47",
        "slug": "considerations-for-alcohol-use-disorder-care-among-youth",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/considerations-for-alcohol-use-disorder-care-among-youth/",
        "title": {
            "rendered": "Considerations for Alcohol Use Disorder Care Among Youth"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            176
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "This session will include a didactic lecture, case presentation, and participant discussion.",
            "related_resources": [
                71,
                170
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6258"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6258"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6258"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6258"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6025,
        "date": "2022-08-31T08:05:38",
        "date_gmt": "2022-08-31T08:05:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6025"
        },
        "modified": "2022-09-08T17:48:45",
        "modified_gmt": "2022-09-08T17:48:45",
        "slug": "membership-voting",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/membership-voting/",
        "title": {
            "rendered": "Membership Voting"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            166
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "The voting for the Vancouver Division of Family Practice Board of Directors will take place from October 6-20, online.",
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6025"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6025"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6025"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6025"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5869,
        "date": "2022-08-31T08:00:11",
        "date_gmt": "2022-08-31T08:00:11",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=5869"
        },
        "modified": "2023-07-13T15:54:49",
        "modified_gmt": "2023-07-13T15:54:49",
        "slug": "2022-agm",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/2022-agm/",
        "title": {
            "rendered": "2022 Elections &#038; Annual General Meeting"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            166
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "The 2022 Annual General Meeting (AGM) and the membership vote will be held Thursday October 27th.",
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/5869"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=5869"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5869"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=5869"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6072,
        "date": "2022-08-30T03:11:27",
        "date_gmt": "2022-08-30T03:11:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6072"
        },
        "modified": "2022-09-15T15:21:03",
        "modified_gmt": "2022-09-15T15:21:03",
        "slug": "healthy-minds-healthy-distractions-series",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/healthy-minds-healthy-distractions-series/",
        "title": {
            "rendered": "Healthy Minds Healthy Distractions Series"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            172
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "Join us for our Healthy Minds Healthy Distractions Series",
            "related_resources": [
                129
            ],
            "related_campaigns": [
                165
            ],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6072"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6072"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6072"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6072"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6070,
        "date": "2022-08-30T02:49:28",
        "date_gmt": "2022-08-30T02:49:28",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=6070"
        },
        "modified": "2022-10-26T23:00:10",
        "modified_gmt": "2022-10-26T23:00:10",
        "slug": "coffee-with-colleagues",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/coffee-with-colleagues/",
        "title": {
            "rendered": "Coffee with Colleagues"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            171
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "An opportunity to learn from and connect with your colleagues.",
            "related_resources": [
                153,
                129
            ],
            "related_campaigns": [
                152,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/6070"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6070"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6070"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6070"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 4320,
        "date": "2022-07-07T16:29:17",
        "date_gmt": "2022-07-07T16:29:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=event&#038;p=4320"
        },
        "modified": "2023-01-13T03:29:06",
        "modified_gmt": "2023-01-13T03:29:06",
        "slug": "primary-care-crisis",
        "status": "publish",
        "type": "event",
        "link": "https://van-division.yarko.dev/event/primary-care-crisis/",
        "title": {
            "rendered": "Summer Engagement Event"
        },
        "featured_media": 0,
        "comment_status": "open",
        "ping_status": "closed",
        "template": "",
        "event_topic": [
            156
        ],
        "acf": {
            "post-icon": 2271,
            "post-excerpt": "An event discussing the state of primary care and providing valuable updates for family physicians in Vancouver.",
            "related_resources": [
                170
            ],
            "related_campaigns": [
                79,
                91
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event/4320"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/event"
                }
            ],
            "replies": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/comments?post=4320"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4320"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "event_topic",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=4320"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11129,
        "date": "2023-08-22T18:54:18",
        "date_gmt": "2023-08-22T18:54:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=11129"
        },
        "modified": "2023-08-23T22:05:47",
        "modified_gmt": "2023-08-23T22:05:47",
        "slug": "how-to-choose-a-maternity-care-provider-pdf",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/how-to-choose-a-maternity-care-provider-pdf/",
        "title": {
            "rendered": "How to Choose a Maternity Care Provider PDF"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Patients can use this guide to find a maternity care provider",
            "resource-introduction": "",
            "resource-text": "Choosing a maternity care provider is an important personal decision to make as patients begin their pregnancy and parenting journey.\r\n\r\nThis PDF provides advice on choosing a maternity care provider. More information can be found at <a href=\"https://pregnancyvancouver.ca/home/#/\">PregnancyVancouver.ca</a>.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/08/How-to-Choose-a-Maternity-Care-Provider-Final.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                148
            ],
            "related_campaigns": [
                91
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/11129"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11129"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11129"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11129"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11129"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11113,
        "date": "2023-08-18T21:17:56",
        "date_gmt": "2023-08-18T21:17:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=11113"
        },
        "modified": "2023-08-18T21:18:37",
        "modified_gmt": "2023-08-18T21:18:37",
        "slug": "doctors-of-bc-new-locum-registration-form",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/doctors-of-bc-new-locum-registration-form/",
        "title": {
            "rendered": "Doctors of BC New Locum Registration Form"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "The new Doctors of BC LFP Locum registration form is ready",
            "resource-introduction": "",
            "resource-text": "<p data-pm-slice=\"1 1 []\">The new Doctors of BC LFP Locum registration form is ready to be completed as soon as possible by all physicians who are/will be billing under the LFP Payment Model for locum services.</p>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Locum Registration Form",
            "resource-button_link": "https://www.doctorsofbc.ca/lfp/locum-registration-form",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/11113"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11113"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11113"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11113"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11113"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11042,
        "date": "2023-08-15T17:09:12",
        "date_gmt": "2023-08-15T17:09:12",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=11042"
        },
        "modified": "2023-08-15T17:09:12",
        "modified_gmt": "2023-08-15T17:09:12",
        "slug": "2023-heatwave-advice",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/2023-heatwave-advice/",
        "title": {
            "rendered": "2023 Heatwave Advice"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Advice for Coping with Extreme Heat",
            "resource-introduction": "",
            "resource-text": "VCH have put together a collection of resources for coping with the current heatwave affecting Metro Vancouver.\r\n\r\nThese resources include a registration for MOSAIC's wellness checks for seniors who do not speak English or French, a guide on creating cooling spaces during hot weather, information on wildfire smoke etc.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "New VCH Heat Resources",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "Extreme Heat Resource List",
                    "resource-acc-item-content": "Access VCH's full list of heat resources <a href=\"https://www.vch.ca/en/extreme-heat\">here</a>. "
                },
                {
                    "resource-acc-item-title": "2023 Heat Season Preparedness For Community Organizations",
                    "resource-acc-item-content": "Download this guide <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/08/2023-Heat-Season-Preparedness-and-Updates.pdf\">here</a>. "
                },
                {
                    "resource-acc-item-title": "Creating Cooling Spaces During Hot Weather: Guidance for Community Organizations",
                    "resource-acc-item-content": "Download this guide <a href=\"https://www.vch.ca/en/media/19776\">here</a>. "
                },
                {
                    "resource-acc-item-title": "BCCDC's Wildfire Fact Sheet",
                    "resource-acc-item-content": "Download this resource <a href=\"http://www.bccdc.ca/resource-gallery/Documents/Guidelines%20and%20Forms/Guidelines%20and%20Manuals/Health-Environment/BCCDC_WildFire_FactSheet_HotWeather.pdf\">here</a>. "
                },
                {
                    "resource-acc-item-title": "MOSAIC Registration ",
                    "resource-acc-item-content": "MOSAIC is running heat wellness checks for seniors who do not speak English or French. Seniors\r\ncan opt-in or family, friends or organizations can refer them.\r\n\r\nRegister <a href=\"https://forms.office.com/pages/responsepage.aspx?id=oYLp8z13YUiPvD8CoJr6MKH-tf2pxt9MnhYRJqmYWzxUQUVWUEtDRlA1T0xSOFc3NUVYM0dJRFA5Sy4u6\">here</a>. "
                }
            ],
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/11042"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11042"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11042"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11042"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11042"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10891,
        "date": "2023-08-02T19:58:44",
        "date_gmt": "2023-08-02T19:58:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10891"
        },
        "modified": "2023-08-02T21:16:23",
        "modified_gmt": "2023-08-02T21:16:23",
        "slug": "division-bylaws",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/division-bylaws/",
        "title": {
            "rendered": "Division Bylaws"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Official PDF copy of the Vancouver Division of Family Practice bylaws, updated in 2016 by the membership.",
            "resource-introduction": "",
            "resource-text": "This is a copy of the Vancouver Division of Family Practice bylaws, which were updated in 2016 as part of the overall update of the organization's constitution and bylaws to coincide with changes to the BC Societies Act.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "View the Division Bylaws",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/08/BC-Society-Act-Bylaw-2016.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10891"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10891"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10891"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10891"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10891"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10890,
        "date": "2023-08-02T19:56:48",
        "date_gmt": "2023-08-02T19:56:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10890"
        },
        "modified": "2023-08-02T21:18:30",
        "modified_gmt": "2023-08-02T21:18:30",
        "slug": "division-constitution",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/division-constitution/",
        "title": {
            "rendered": "Division Constitution"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Official PDF copy of the Vancouver Division of Family Practice constitution, updated in 2016 by the membership.",
            "resource-introduction": "",
            "resource-text": "This is a copy of the Vancouver Division of Family Practice constitution, which was updated in 2016 as part of the overall update of the organization's constitution and bylaws to coincide with changes to the BC Societies Act.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "View the Division Constitution",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/08/BC-Society-Act-Constitution-2016.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10890"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10890"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10890"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10890"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10890"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10809,
        "date": "2023-07-10T23:56:22",
        "date_gmt": "2023-07-10T23:56:22",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10809"
        },
        "modified": "2023-07-11T16:33:39",
        "modified_gmt": "2023-07-11T16:33:39",
        "slug": "checklist-pdfs-for-physicians-closing-or-transitioning-out-of-practice",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/checklist-pdfs-for-physicians-closing-or-transitioning-out-of-practice/",
        "title": {
            "rendered": "PDF Checklists for Physicians Closing or Transitioning Out of Practice"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "Recruitment and Retention provide physicians two different resources depending on their situation",
            "resource-introduction": "",
            "resource-text": "As part of supporting physicians closing practice and transitioning out of their clinic, Vancouver Division's Recruitment and Retention give them two different resources depending on their situation.\r\n\r\nBelow are PDF Checklists for physicians to use in these situations:\r\n<ul>\r\n \t<li>Closing their Practice</li>\r\n \t<li>Practice Takeover</li>\r\n</ul>\r\nLog in to access.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "PDF Checklists",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "Checklist to Close",
                    "resource-acc-item-content": "Find the checklist <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/07/20230710-Checklist-to-Close-V2.pdf\">here</a>."
                },
                {
                    "resource-acc-item-title": "Checklist for Practice Takeover",
                    "resource-acc-item-content": "Find the checklist <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/07/20230710-Practice-Takeover-v2.pdf\">here</a>"
                }
            ],
            "related_resources": [
                72
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10809"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10809"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10809"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10809"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10809"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10629,
        "date": "2023-06-20T16:44:15",
        "date_gmt": "2023-06-20T16:44:15",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10629"
        },
        "modified": "2023-06-27T22:13:14",
        "modified_gmt": "2023-06-27T22:13:14",
        "slug": "icon-intercultural-online-health-network-health-resources-for-the-chinese-and-south-asian-communities",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/icon-intercultural-online-health-network-health-resources-for-the-chinese-and-south-asian-communities/",
        "title": {
            "rendered": "iCON &#8211; Health Resources for the Chinese and South Asian Communities"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "UBC’s iCON works to advance person- and family-centred care in B.C. through a community-driven approach.",
            "resource-introduction": "",
            "resource-text": "UBC’s InterCultural Online Health Network (iCON) works to advance person- and family-centred care in B.C. through a community-driven approach.\r\n\r\nThey do this by working with multicultural communities (Chinese and South Asian) to tailor health information in a way that empowers patients and family caregivers with the knowledge to better manage chronic diseases, navigate primary care and use digital tools to support their health.\r\n\r\niCON has provided <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/06/2023-03-02_iCON-poster-Chinese-EN-version.pdf\">Chinese</a> and <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/06/2023-03-08_iCON-poster-Punjabi-EN-version.pdf\">Punjabi</a>-language posters for doctors to share with patients and family caregivers .",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                195,
                71,
                73
            ],
            "related_campaigns": [],
            "related_events": [
                173,
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10629"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10629"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10629"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10629"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10629"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10605,
        "date": "2023-06-13T00:20:07",
        "date_gmt": "2023-06-13T00:20:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10605"
        },
        "modified": "2023-08-01T18:02:05",
        "modified_gmt": "2023-08-01T18:02:05",
        "slug": "frailty-roadmap-for-families",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/frailty-roadmap-for-families/",
        "title": {
            "rendered": "Frailty Roadmap for Families"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10133,
            "post-excerpt": "A guide to help ensure safety, provide comfort, and improve the quality of life for you or your loved one",
            "resource-introduction": "",
            "resource-text": "This brochure is a basic roadmap of the territory, to help families orient themselves on the journey they are traveling, and see what’s coming farther along the road.\r\n\r\nThe frailty journey can be roughly divided into early, middle, and late stages, then end of life. This guide outlines the features of each stage, the signposts that tell you where you are on this road, and what may be coming up next. Included are questions that can help you clarify where you are, and suggestions about things we can do as a family and care team to give you or your loved one the best possible quality of life where they are right now",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Frailty Roadmap Here",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/06/Frailty-Roadmap-For-Families-Digital-_-Print.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                180,
                71
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10605"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10605"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10605"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10605"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10605"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10591,
        "date": "2023-06-12T18:29:46",
        "date_gmt": "2023-06-12T18:29:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10591"
        },
        "modified": "2023-06-12T18:29:46",
        "modified_gmt": "2023-06-12T18:29:46",
        "slug": "vch-hip-or-knee-osteoarthritis-resource-collection",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/vch-hip-or-knee-osteoarthritis-resource-collection/",
        "title": {
            "rendered": "VCH Hip or Knee Osteoarthritis Resource Collection"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10133,
            "post-excerpt": "It is important to learn more about your osteoarthritis and take an active part in your treatment.",
            "resource-introduction": "",
            "resource-text": "Vancouver Coastal Health have put together a collection of resources on the management of Hip or Knee Osteoarthritis.\r\n<p data-pm-slice=\"1 1 []\">This resource provides advice on:</p>\r\n<p data-pm-slice=\"1 1 []\">This resource provides advice on:</p>\r\n\r\n<ul>\r\n \t<li data-pm-slice=\"1 1 []\">education,</li>\r\n \t<li data-pm-slice=\"1 1 []\">physical activity,</li>\r\n \t<li data-pm-slice=\"1 1 []\">pain management,</li>\r\n \t<li data-pm-slice=\"1 1 []\">healthy eating and weight loss,</li>\r\n \t<li data-pm-slice=\"1 1 []\">self care,</li>\r\n \t<li data-pm-slice=\"1 1 []\">social support</li>\r\n \t<li data-pm-slice=\"1 1 []\">and other services for patients with osteoarthritis.</li>\r\n</ul>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Resource here",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/06/OA-Hip-and-Knee-OA-FB.340.M36-1-2.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                180,
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10591"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10591"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10591"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10591"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10591"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10291,
        "date": "2023-05-05T19:37:47",
        "date_gmt": "2023-05-05T19:37:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10291"
        },
        "modified": "2023-05-05T19:37:47",
        "modified_gmt": "2023-05-05T19:37:47",
        "slug": "physician-health-program",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/physician-health-program/",
        "title": {
            "rendered": "Physician Health Program"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "The PHP helpline for confidential, personalized assistance is open 24/7",
            "resource-introduction": "",
            "resource-text": "<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">Physician Health Program is a responsive, high quality care provider and community services navigator for physicians, trainees and their families. The PHP helpline for confidential, personalized assistance with issues such as mental health, relationship stress, career and life transitions, substance use and concern for colleague is open 24/7.</p>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Learn more here",
            "resource-button_link": "https://www.physicianhealth.com/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129,
                119
            ],
            "related_campaigns": [
                165,
                117
            ],
            "related_events": [
                172,
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10291"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10291"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10291"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10291"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10291"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10290,
        "date": "2023-05-05T19:28:46",
        "date_gmt": "2023-05-05T19:28:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10290"
        },
        "modified": "2023-05-05T19:28:46",
        "modified_gmt": "2023-05-05T19:28:46",
        "slug": "get-attached-to-a-family-doctor",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/get-attached-to-a-family-doctor/",
        "title": {
            "rendered": "Get Attached to a Family Doctor"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "Physician Health Program believes that all physicians should establish a relationship with a primary care provider",
            "resource-introduction": "",
            "resource-text": "<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">The Physician Health Program (PHP) believes that all physicians should establish a long-term, trusting relationship with a primary care provider (PCP). Complete the form through this link to be matched with a PCP.</p>\r\n<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">PCPs can be in short supply. Given the constraints, there are program policies that can be found through the link below.</p>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Access the Form Here",
            "resource-button_link": "https://www.physicianhealth.com/gp/d4d/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129,
                119
            ],
            "related_campaigns": [
                165,
                117
            ],
            "related_events": [
                172,
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10290"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10290"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10290"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10290"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10290"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10289,
        "date": "2023-05-05T19:09:33",
        "date_gmt": "2023-05-05T19:09:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10289"
        },
        "modified": "2023-05-05T19:09:33",
        "modified_gmt": "2023-05-05T19:09:33",
        "slug": "cma-wellness-hub",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cma-wellness-hub/",
        "title": {
            "rendered": "CMA Wellness Hub"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 10158,
            "post-excerpt": "The CMA Wellness Hub provides reliable wellness tools and resources to empower physicians",
            "resource-introduction": "",
            "resource-text": "The 2017 CMA National Physician Health Survey found that the stigma associated with mental health issues remains a relevant barrier to accessing physician health program services.\r\n<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">The CMA Wellness Hub provides reliable wellness tools and resources to empower physicians, medical learners, leaders and educators to create change in the culture of medicine through a multi-pronged approach.</p>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "View this Resource ",
            "resource-button_link": "https://www.cma.ca/physician-wellness-hub",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129,
                119
            ],
            "related_campaigns": [
                117,
                165
            ],
            "related_events": [
                172,
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10289"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10289"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10289"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10289"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10289"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10256,
        "date": "2023-05-02T15:19:29",
        "date_gmt": "2023-05-02T15:19:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10256"
        },
        "modified": "2023-05-03T22:48:33",
        "modified_gmt": "2023-05-03T22:48:33",
        "slug": "access-for-ct-scans-in-the-lower-mainland",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/access-for-ct-scans-in-the-lower-mainland/",
        "title": {
            "rendered": "Access for CT Scans in the Lower Mainland"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "Non-urgent outpatients wait times for CT services in the Lower Mainland are above wait time bench marks and increasing. ",
            "resource-introduction": "",
            "resource-text": "There continues to be significant demand for Computed Tomography (CT) services across all Lower Mainland Medical Imaging (LMMI) sites. LMMI continues to see increased demand for inpatient and emergency imaging which is affecting our ability to perform non-urgent outpatient exams. While wait times for urgent outpatients continue to remain stable, LMMI sites are receiving more requisitions than they are able to complete.\r\n\r\nTo improve patient access, CT requisitions may be sent to other surrounding sites with shorter outpatient wait lists. Redistributed patients are slotted into queues at t he new sit e based on the original requisition received date.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide Here",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/05/KYI_MI_Access-for-CT-Scans-LMMI-April-2023.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                180,
                71
            ],
            "related_campaigns": [],
            "related_events": [
                176
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10256"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10256"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10256"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10256"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10256"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10188,
        "date": "2023-04-26T23:15:56",
        "date_gmt": "2023-04-26T23:15:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10188"
        },
        "modified": "2023-08-01T17:54:27",
        "modified_gmt": "2023-08-01T17:54:27",
        "slug": "honouring-our-babies-safer-sleep-toolkit",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/honouring-our-babies-safer-sleep-toolkit/",
        "title": {
            "rendered": "Honouring Our Babies Safer Sleep Toolkit"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Honouring Our Babies Safer Sleep Toolkit: Facilitator Guide and Cards 3rd Edition 2023",
            "resource-introduction": "",
            "resource-text": "Perinatal Services BC have put together the Honouring Our Babies Safer Sleep Toolkit: Facilitator Guide and Cards 3<sup>rd</sup> Edition 2023, including important information and recommendations on how to facilitate conversations with Indigenous parents/caregivers on safer sleep options. It encourages informed shared decision making on safer sleep with a focus on the strengths of Indigenous knowledge, cultural values and practices using a two-eyed seeing approach.\r\n\r\nThe refreshed toolkit has a number of updates and key alignments:\r\n<ul>\r\n \t<li>It was informed by Indigenous family members, Elders, and a variety of health-care providers including midwives, registered nurses, birth workers and Doulas.</li>\r\n \t<li>It is an update from the Honouring Our Babies: Safe Sleep Cards: Facilitator Guide 2017.</li>\r\n \t<li>It aligns with <em>PSBC's Safer Infant Sleep</em> resource, which was updated in 2022.</li>\r\n \t<li>It aligns with best practice recommendations and current clinical guidelines.</li>\r\n \t<li>It provides key messages for infants at increased risk of sleep-related infant death.</li>\r\n \t<li>It consists of 21 illustrated cards, four of which have been newly developed, and a facilitator's guide.</li>\r\n</ul>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Find the toolkit here",
            "resource-button_link": "http://www.perinatalservicesbc.ca/health-professionals/professional-resources/indigenous-resources/safe-sleep-toolkit",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                148
            ],
            "related_campaigns": [
                91
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10188"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10188"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10188"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10188"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10188"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10177,
        "date": "2023-04-25T16:55:13",
        "date_gmt": "2023-04-25T16:55:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10177"
        },
        "modified": "2023-08-01T17:57:38",
        "modified_gmt": "2023-08-01T17:57:38",
        "slug": "accessing-a-telephone-interpreter",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/accessing-a-telephone-interpreter/",
        "title": {
            "rendered": "Accessing a Telephone Interpreter"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "How to access telephone interpreters for your patients",
            "resource-introduction": "",
            "resource-text": "The Provincial Language Service (a <a href=\"http://www.phsa.ca/interpreting\" target=\"_blank\" rel=\"noopener\">service of the Provincial Health Services Authority</a>) can provide interpreting services to any BC primary health care provider and can be accessed over the phone on demand within minutes.\r\n\r\nBC Providers who use telephone interpreting in their offices report it to be timely, helpful and reasonable to use, even on a busy day. Professional interpreters (for more than 200 languages) convey a message's content, meaning and ton, which can improve clinical outcomes and help to reduce errors. Patient and family satisfaction with care can increase, as a professional interpreter can allow them to focus solely on understand their illness or to support a loved one.\r\n\r\nProfessional interpreters abide by confidentiality standards and help meet Personal Information Protection Act (PIPA) standards.\r\n\r\nVancouver Division members and primary care providers within Vancouver PCNs can access this services free-of-charge using the access code provided.\r\n\r\nLogin to access the code and access information.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/04/NewPoster_TelephoneInterpreting_April2018-1.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                71,
                195
            ],
            "related_campaigns": [],
            "related_events": [
                176,
                173
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10177"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10177"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10177"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10177"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10177"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10099,
        "date": "2023-04-20T00:03:36",
        "date_gmt": "2023-04-20T00:03:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10099"
        },
        "modified": "2023-04-28T22:55:58",
        "modified_gmt": "2023-04-28T22:55:58",
        "slug": "vsb-student-health-information-sharing-form",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/vsb-student-health-information-sharing-form/",
        "title": {
            "rendered": "VSB Student Health Information Sharing Form"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Vancouver School Board and Vancouver Division fillable Student Health Information Sharing Form",
            "resource-introduction": "",
            "resource-text": "The Vancouver Division and the Vancouver School Board (VSB) brought together 20 family physicians (FPs) and 20 VSB staff to identify challenges in sharing the right information between each other. Key lesson from the discussion was that often information is shared that inadvertently creates barriers to provide timely and appropriate feedback and perspective.\r\n\r\nThe result the creation of following fillable forms that lay out the key information that either primary care providers or school staff specifically find most helpful. The first is for FPs to use and the second is for VSB staff.\r\n<ul>\r\n \t<li><strong>From Primary Care Providers to School Staff -</strong> This 2-page fillable form is a communication tool for primary care providers to share student information with the student’s school staff. The categories in the form identify key information that the school staff are interested in learning about the student. Download the fillable PDF for <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/cymhsu-doc.-physician-to-vsb-staff-v6.pdf\">here.</a></li>\r\n \t<li><strong><strong>From School Staff to Primary Care Providers - </strong></strong>If you are working with a school teacher, counsellor, or any school staff, you can share this form with them for any young patient you have. VSB staff can use this form to share relevant information to a student's family physician that they have concerns or questions about the student’s behaviour. Download the fillable PDF form <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/cymhsu-doc.-vsb-staff-to-physician-v6.pdf\">here</a>.</li>\r\n</ul>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "",
            "resource-faq_accordion_content": null,
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10099"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10099"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10099"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10099"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10099"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10279,
        "date": "2023-04-19T18:52:44",
        "date_gmt": "2023-04-19T18:52:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10279"
        },
        "modified": "2023-05-03T19:02:34",
        "modified_gmt": "2023-05-03T19:02:34",
        "slug": "fast-facts-april-19-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-april-19-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; April 19, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9574281",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129,
                74,
                174
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10279"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10279"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10279"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10279"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10279"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10092,
        "date": "2023-04-18T17:51:13",
        "date_gmt": "2023-04-18T17:51:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10092"
        },
        "modified": "2023-05-11T21:39:58",
        "modified_gmt": "2023-05-11T21:39:58",
        "slug": "dementia-resource-collection",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/dementia-resource-collection/",
        "title": {
            "rendered": "Dementia Resource Collection"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 9438,
            "post-excerpt": "The purpose of the tool is to assist FPs in managing their patients' dementia journey and to provide resources",
            "resource-introduction": "",
            "resource-text": "Through this Shared Care project, patients, caregivers, and HCPs created a Coordinating Dementia Tool and Dementia Companion Handbook. The purpose of the tool is to assist FPs in managing their patients' dementia journey and to provide resources, referrals and associated billing codes in appointment-size pieces.\r\n\r\n&nbsp;\r\n\r\nIf you would like hard copies of the handbook for your patients, please contact <a href=\"mailto:mdefer@providencehealth.bc.ca\">Miranda</a> for info.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Coordinating Dementia Tool and The Dementia Companion Handbook",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "The Dementia Companion Handbook",
                    "resource-acc-item-content": "Download your Dementia Companion Book <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/Dementia-Companion-Handbook_online.pdf\">here</a>. "
                },
                {
                    "resource-acc-item-title": "Coordinating Dementia Tool ",
                    "resource-acc-item-content": "Download the fillable physician tool <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/Dementia-Companion-Handbook_online.pdf\">here</a>."
                }
            ],
            "related_resources": [
                119,
                180
            ],
            "related_campaigns": [],
            "related_events": [
                198
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10092"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10092"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10092"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10092"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10092"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10278,
        "date": "2023-04-05T18:43:53",
        "date_gmt": "2023-04-05T18:43:53",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=10278"
        },
        "modified": "2023-05-03T18:54:44",
        "modified_gmt": "2023-05-03T18:54:44",
        "slug": "fast-facts-april-5-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-april-5-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; April 5, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9571381",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129,
                74,
                174
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/10278"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10278"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10278"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10278"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10278"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9874,
        "date": "2023-03-22T23:09:59",
        "date_gmt": "2023-03-22T23:09:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9874"
        },
        "modified": "2023-08-01T18:13:36",
        "modified_gmt": "2023-08-01T18:13:36",
        "slug": "fast-facts-march-22-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-march-22-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; March 22, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9568141",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9874"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9874"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9874"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9874"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9874"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9853,
        "date": "2023-03-21T23:33:27",
        "date_gmt": "2023-03-21T23:33:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9853"
        },
        "modified": "2023-08-01T18:16:35",
        "modified_gmt": "2023-08-01T18:16:35",
        "slug": "intentionality-starts-with-compassion-dr-derek-chang",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/intentionality-starts-with-compassion-dr-derek-chang/",
        "title": {
            "rendered": "Intentionality Starts with Compassion &#8211; Dr. Derek Chang"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            195
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "Dr. Derek Chang outlines how intentionality and compassion are key for JEDI",
            "resource-introduction": "Dr. Derek Chang outlines how intentionality and compassion are key for JEDI",
            "resource-text": "<div class=\"page\" data-page-number=\"1\" data-loaded=\"true\">\r\n<div><img class=\"alignnone size-medium wp-image-9855\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/03/DC_photo_copy-300x300.jpg\" alt=\"\" width=\"300\" height=\"300\" /></div>\r\n<div></div>\r\n<div></div>\r\n<div class=\"textLayer\">\r\n\r\n<span style=\"font-weight: 400;\">As family physicians, we have been experiencing enormous pressure; the pandemic and multiple crises have added even more weight to our shoulders. We are doing our best to meet our patients’ needs with limited resources and constrained systems. In recent years, the discussion around Justice, Equity, Diversity, and Inclusion (JEDI) has been front and centre in our society, particularly in healthcare. The In Plain Sight report is a prominent example. I recognize the importance of JEDI and its beneficial and critical role for our patients and our profession. However, with so many competing priorities, my bandwidth often becomes limited.</span>\r\n\r\n<span style=\"font-weight: 400;\">In </span><i><span style=\"font-weight: 400;\">Thinking, Fast and Slow</span></i><span style=\"font-weight: 400;\">, Daniel Kahneman described two modes of thinking: system 1 is fast and automatic, while system 2 is slow and deliberate. It’s not that one system is better than the other; the two systems complement each other and are both crucial for our survival as human beings.</span>\r\n\r\n<span style=\"font-weight: 400;\">When stressed or tired, our system 1 kicks in more readily. We operate in a fast and automatic mode where our unconscious biases can dominate how we think and what we do. I’ve noticed that in my clinical practice and daily life: when my bandwidth decreases, I tend to make up stories or jump to conclusions based on my assumptions or biases.</span>\r\n\r\n<span style=\"font-weight: 400;\">I’ve been thinking about how to foreground system 2 in my thoughts and actions—How can I be more intentional in how I think and what I do? I haven’t quite figured out how to navigate this tension effectively, but one surprising tool I found helpful is practicing compassion.</span>\r\n\r\n<span style=\"font-weight: 400;\">As I was reading more about compassion, I came across the teaching by Joan Halifax, a Zen Buddhist teacher, anthropologist, ecologist, civil rights activist, hospice caregiver, and author. In her book Standing at the Edge, she wrote, “Compassion is defined as feeling genuine concern about the suffering of another and desiring to improve that one’s welfare. Compassion also helps us meet our own suffering, and that of others, with an appropriate response.”</span>\r\n\r\n<span style=\"font-weight: 400;\">Compassion is a complex and messy concept, and I don’t want to pretend I’ve fully grasped it. However, I do find the practice of compassion helps me slow down and be more intentional in my thoughts and actions. Compassion reminds me to recognize when my bandwidth is becoming limited and pay attention to my needs. Compassion also motivates me to meet the suffering of others and improve their welfare, which includes the work of JEDI.</span>\r\n\r\n<span style=\"font-weight: 400;\">For me, intentionality is key for JEDI, and it starts with compassion. I want to end with the wisdom of Joan Halifax, which I use as the background on my phone screen to remind myself to practice compassion:</span>\r\n\r\n<i><span style=\"font-weight: 400;\">May I offer my care and presence unconditionally, knowing that it may be met by gratitude, indifference, anger, or anguish.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I offer love, knowing that Icannot control the course of life, suffering, or death.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I find the inner resources to truly be able to give.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I be peaceful and let go of expectations.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I accept things as they are.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I see my limits compassionately, just as I view the suffering of others.</span></i>\r\n\r\n&nbsp;\r\n\r\n<span style=\"font-weight: 400;\">References:</span>\r\n\r\n<a href=\"https://engage.gov.bc.ca/app/uploads/sites/613/2020/11/In-Plain-Sight-Summary-Report.pdf\"><span style=\"font-weight: 400;\">https://engage.gov.bc.ca/app/uploads/sites/613/2020/11/In-Plain-Sight-Summary-Report.pdf</span></a>\r\n\r\n<span style=\"font-weight: 400;\">Kahneman, D. (2012). Thinking, fast and slow. Penguin Books.</span>\r\n\r\n<span style=\"font-weight: 400;\">Halifax, J. (2018). </span><i><span style=\"font-weight: 400;\">Standing at the edge: Finding freedom where fear and courage meet</span></i><span style=\"font-weight: 400;\"> (First edition). Flatiron Books.</span>\r\n\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                195
            ],
            "related_campaigns": [],
            "related_events": [
                173
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9853"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9853"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9853"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9853"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9853"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9824,
        "date": "2023-03-21T23:04:50",
        "date_gmt": "2023-03-21T23:04:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9824"
        },
        "modified": "2023-03-21T23:04:50",
        "modified_gmt": "2023-03-21T23:04:50",
        "slug": "vancouver-clinics-seeing-benefits-of-colocated-pharmacists",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/vancouver-clinics-seeing-benefits-of-colocated-pharmacists/",
        "title": {
            "rendered": "Vancouver Clinics Seeing Benefits of Colocated Pharmacists"
        },
        "featured_media": 9826,
        "template": "",
        "resource_type": [],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "Read about one pharmacist's experience with colocation to clinics in Vancouver",
            "resource-introduction": "Read about one pharmacist's experience with colocation to clinics in Vancouver",
            "resource-text": "<img class=\"alignnone wp-image-9825\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/03/217a5395_52342984522_o-300x200.jpg\" alt=\"\" width=\"371\" height=\"247\" />\r\n\r\n<span style=\"font-weight: 400;\">Clinics in Vancouver are beginning to take advantage of a program that allows utilization of the services of clinical pharmacists in their clinic on a rotational basis</span><span style=\"font-weight: 400;\">. Allied health resources have been centralized in the Interprofessional Team (IPT) structure, and pharmacists can also be colocated within clinics, if requested. The result has been a win-win scenario, welcomed by both doctors and patients. </span>\r\n<h2><b>How the Colocation Program Works </b></h2>\r\n<span style=\"font-weight: 400;\">Clinics with the necessary space can have the pharmacists within their physical clinic, while those who can’t accommodate this arrangement are still able to participate. </span>\r\n\r\n<span style=\"font-weight: 400;\">“You can colocate virtually,” explains Saori Yamamoto, CNM for PCN 3 of the Vancouver Division. “Your pharmacist would be at a different location, but their time would be dedicated to you.” </span>\r\n\r\n<span style=\"font-weight: 400;\">In addition to facilitating the colocation, the program provides assistance with overhead, orientation and training. </span>\r\n<h2><b>Family Doctors are Extremely Busy</b></h2>\r\n<span style=\"font-weight: 400;\">Ruby Sangha has been a pharmacist for 26 years, spending most of that time doing clinical work at VGH. She transferred to primary care about a year ago, and has spent each Wednesday since December working at Fraser Street Medical. She believes that the program provides value to clinics. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Family doctors are extremely busy and there’s not always enough time in the day to tackle some of the issues that patients are bringing up,” says Sangha. “We can answer some of those questions, we can do the lit search.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha’s hospital work has prepared her for any challenges that may arise. </span>\r\n\r\n<span style=\"font-weight: 400;\">“I can do this,” she says. “I’ve done it for 19 years.”</span><span style=\"font-weight: 400;\"> </span>\r\n<h2><b>A Day in the Life of a Colocated Clinical Pharmacist  </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha says that on a typical day at Fraser Street Medical she’ll see five or six patients. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Initial appointments are usually around an hour, with pre-emptive work being done beforehand,” she says.</span>\r\n\r\n<span style=\"font-weight: 400;\">Accessing Care Connect, PharmaNet and, if possible, the office EMR helps the clinical pharmacist understand the patient’s medical history. </span>\r\n\r\n<span style=\"font-weight: 400;\">“I’ll meet with the patient, interview them, discuss their needs, and get their perspective,” says Sangha. “I’ll attempt to determine if there is room for improvement in terms of medication optimization and then present that information to the doctor.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha observes that some patients are discharged from hospital without truly understanding why their medications have changed. In such cases, she thinks that one on one time with pharmacists provides true value. </span>\r\n\r\n<span style=\"font-weight: 400;\">“One of the benefits is being able to go over some of those things with the patients,” she says. “I do a bit more digging in order to figure out the whys and hows.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Yamamoto also sees benefits for the patient. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Perhaps they can’t afford their medication,” she says. “The clinical pharmacists don’t dispense the medication, but they can suggest options that the patient could then discuss with their doctor. Sometimes these options are more affordable or have less side effects.” </span>\r\n<h2><b>Utilizing a Shared Decision Model </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha believes in incorporating patients’ thoughts on the medication they receive. </span>\r\n\r\n<span style=\"font-weight: 400;\">“They’re at the forefront of primary care,” she says. “We need the patient to buy into those decisions, it can’t be a one-sided thing.” </span>\r\n\r\n<span style=\"font-weight: 400;\">She’s found patients to be grateful for the additional time and care, and speaks of a particular patient that she recently worked with. </span>\r\n\r\n<span style=\"font-weight: 400;\">“A patient of mine had a procedure that was done not too long ago that created some complications in her life,” she recalls. “I found there was a level of mistrust before I jumped into the picture. I was able to recognize that there was a need to go slow and build a relationship.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Yamamoto agrees. “It’s patient-centered care,” she says. “It empowers patients to have a choice.”  </span>\r\n<h2><b>Ability to Mold the Program </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha enjoyed the team-based model employed during her years at the hospital, and is pleased to see this dynamic at play within primary care. She’s also grateful to be in a position where she can utilize her experience to help shape an evolving system.</span>\r\n\r\n<span style=\"font-weight: 400;\">“After 19 years with the hospital, I felt like a primary care network position was an opportunity to use my experience to help mold this program,” she says. “The pharmacy program is being led by UBC in conjunction with Fraser Health, so there is structure on hand already, but I think our experience comes into play on some of the smaller aspects of the role.”</span><span style=\"font-weight: 400;\"> </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha says that things have been picking up of late and is excited for the trend to continue. </span>\r\n\r\n<span style=\"font-weight: 400;\">“There are currently six pharmacists within the Vancouver primary care network, and all of us come with strong experience,” she says. “The more exposure we get within doctors’ offices, the more we can showcase what we’re able to do. I think our range of experience and perspectives allow us to open doors and make a difference by getting more involved in patient care.” </span>\r\n\r\n&nbsp;\r\n\r\n<b>Cited Sources</b><b> </b>\r\n\r\n<b>Direct communication with Saori Yamamoto and Ruby Sangha</b>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9824"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:featuredmedia": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media/9826"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9824"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9824"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9824"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9824"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9674,
        "date": "2023-03-21T21:35:40",
        "date_gmt": "2023-03-21T21:35:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9674"
        },
        "modified": "2023-04-21T20:26:24",
        "modified_gmt": "2023-04-21T20:26:24",
        "slug": "medical-office-assistant-moa-job-posting-form",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/medical-office-assistant-moa-job-posting-form/",
        "title": {
            "rendered": "Medical Office Assistant (MOA) Job Posting Form"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            190
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "This form is intended for use by clinics and family physicians who are seeking to recruit clinic staff.",
            "resource-introduction": "",
            "resource-text": "<span style=\"font-weight: 400;\">The </span><i><span style=\"font-weight: 400;\">Medical Office Assistant (MOA) Job Posting Service </span></i><span style=\"font-weight: 400;\">has been developed to address the need for clinic office staff in family practice clinics in the city of Vancouver. This service allows clinics to recruit for different levels of office staff such as: Junior MOAs, Mid-Level MOAs, Senior MOAs, and Clinic Managers. This service was developed with a physician centered and clinic-led approach in mind as it allows clinics to gauge suitability of candidates on their own terms. </span>\r\n\r\nTo fill out this form, please login. For additional information regarding this service, please contact your regional Community Network Manager (CNM) <a href=\"https://van-division.yarko.dev/pcn-vancouver/\">here</a> or login to view more.\r\n\r\n<span style=\"font-weight: 400;\">Please note that the </span><i><span style=\"font-weight: 400;\">MOA Job Postings service</span></i><span style=\"font-weight: 400;\"> is distinct from the Family Physicians (FPs) and Nurse Practitioners (NPs) <a href=\"https://van-division.yarko.dev/recruitment-retention/\">recruitment programs</a>. </span>\r\n\r\n<span style=\"font-weight: 400;\">If you are an MOA seeking opportunities in Vancouver, please visit our </span><b><a href=\"https://van-division.yarko.dev/work-in-vancouver/\">Work in Vancouver</a> </b><span style=\"font-weight: 400;\">webpage and filter 'Job Title' for a list of current clinic staff opportunities.</span>\r\n\r\nView: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/MOA-Program-4.pdf\" target=\"_blank\" rel=\"noopener\">MOA Job Posting Workflow - Physician/Clinic Perspective</a>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Complete Form Here",
            "resource-button_link": "https://forms.gle/xWrcuEnNfZkdoGDLA",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163,
                190
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9674"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/190"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9674"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9674"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9674"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9674"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9873,
        "date": "2023-03-03T23:07:43",
        "date_gmt": "2023-03-03T23:07:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9873"
        },
        "modified": "2023-08-01T18:22:27",
        "modified_gmt": "2023-08-01T18:22:27",
        "slug": "fast-facts-march-3-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-march-3-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; March 3, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9563009",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9873"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9873"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9873"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9873"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9873"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9872,
        "date": "2023-02-22T23:05:38",
        "date_gmt": "2023-02-22T23:05:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9872"
        },
        "modified": "2023-08-01T18:22:59",
        "modified_gmt": "2023-08-01T18:22:59",
        "slug": "fast-facts-february-22-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-february-22-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; February 22, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9558217",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9872"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9872"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9872"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9872"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9872"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9871,
        "date": "2023-02-08T23:03:52",
        "date_gmt": "2023-02-08T23:03:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9871"
        },
        "modified": "2023-08-01T18:25:22",
        "modified_gmt": "2023-08-01T18:25:22",
        "slug": "fast-facts-february-8-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-february-8-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; February 8, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9552361",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9871"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9871"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9871"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9871"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9871"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8739,
        "date": "2023-02-08T02:06:30",
        "date_gmt": "2023-02-08T02:06:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8739"
        },
        "modified": "2023-04-25T20:50:25",
        "modified_gmt": "2023-04-25T20:50:25",
        "slug": "patient-handout-on-benzodiazepines",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/patient-handout-on-benzodiazepines/",
        "title": {
            "rendered": "Patient Handout on Benzodiazepines"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            199,
            124,
            119
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Patient handout on using benzodiazepines.",
            "resource-introduction": "",
            "resource-text": "<div class=\"post_body_wrapper\">\r\n<div class=\"post-body-container\">\r\n<div class=\"post-body-renderer-component post_body\">\r\n<div class=\"post-body-content\">\r\n<div class=\"body_text redactor-styles redactor-in\">The Vancouver Community Action Team is one of many CATs around the province responding to the overdose crisis. Vancouver Division members have been engaged on this partner project since 2018. VCAT has recently created a \"Benzo Basics\" handout on using benzodiazepines, which you can share with patients.</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download Document",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/02/Benzo-basics-1.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                199
            ],
            "related_campaigns": [],
            "related_events": [
                197
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8739"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/199"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8739"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8739"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8739"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8739"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8735,
        "date": "2023-02-08T01:37:20",
        "date_gmt": "2023-02-08T01:37:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8735"
        },
        "modified": "2023-02-08T01:37:20",
        "modified_gmt": "2023-02-08T01:37:20",
        "slug": "vancouver-division-cbt-skills-group-address-mental-health",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/vancouver-division-cbt-skills-group-address-mental-health/",
        "title": {
            "rendered": "Vancouver Division &#038; CBT Skills Group Address Mental Health"
        },
        "featured_media": 8737,
        "template": "",
        "resource_type": [
            118,
            119
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "The Division supports a program designed to take pressure off FPs managing their patients' mental health concerns.",
            "resource-introduction": "The Division supports a program designed to take pressure off FPs managing their patients' mental health concerns.",
            "resource-text": "<img class=\"aligncenter wp-image-8737 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/02/pexels-christina-morillo-1181712-1.jpg\" alt=\"\" width=\"1200\" height=\"800\" />\r\n\r\nWe know from talking to our members that mental health is top of mind for both doctors and members of the community alike. Tackling this problem will require significant resources which aren’t always available to family doctors. Many individuals experiencing health issues like depression or anxiety can fall through the cracks. To help, the Vancouver Division has been providing resources and partnership to the CBT Skills Group, an effective and exciting program designed to provide education and healing to patients who don’t qualify for medication or referral to psychiatry.\r\n\r\nAccording to <a href=\"https://van-division.yarko.dev/contact-us/\">Justin Ho</a>, Director of Membership Engagement and Collaboration at Vancouver Division, better support in this area is a priority.\r\n“Family doctors and other team members have told us that resources are needed,” says Ho. “With this in mind, Vancouver Division has been working with the CBT Skills Group to deliver solutions that provide value to doctors as well as patients.”\r\n<h3>What is the CBT Skills Group?</h3>\r\nThe Cognitive Behavioural Therapy Skills Group offers MSP-funded, online group therapy sessions to adults who are experiencing moderate depression, anxiety, or other lower-acuity mental health issues.\r\n\r\n“Mental health can be improved when patients are taught to recognize, understand, and manage patterns of feeling, thinking, and behaving,” explains Ho. “The CBT Skills Group facilitates learning while providing participants with valuable tools.”\r\n\r\nThe program was designed by psychiatrists and is taught by physicians, integrating neuroscience, mindfulness, and cognitive behavioural therapy skills and concepts.\r\n\r\n“Vancouver Division is supporting this initiative by providing resources and expertise which assist in strategic development and marketing,” says Ho. “We’re listening to our doctors and providing help where it’s needed.”\r\n<h3>Doctor Sees Benefits of Program</h3>\r\nOne doctor who sees the value of the initiative is Dr. Christine Singh. “The process really works well,” she says. “For patients with mental health concerns, these skills are so important.”\r\nSingh has been impressed with the way the program has been conceived and run.\r\n“I believe that it’s rooted in altruism,” she says. “I’ve recently taken the course myself and I really appreciate the approach my colleagues have taken. They’re kind, compassionate, experienced, skilled, and enthusiastic. I really feel that it’s coming from a good place.”\r\n<h3>Group Setting Fosters Vital Connection</h3>\r\nAs Dr. Singh sees it, the group aspect of the program is a key component of its success.\r\n\r\n“Patients with mental health issues can feel very isolated,” she says. “They may have cognitive distortions where they believe that no one else shares their experience. When they get involved with a group, they realize that these thinking patterns are common. Suddenly they’re not alone.”\r\n\r\nThe program offers therapeutic value within the confines of a safe circle. Dr. Singh believes that connection and understanding are part of the healing process.\r\n\r\n“Mental health is often about disconnection and feeling outside,” she says. “I think this program allows people to realize that they can participate in other groups as well. It allows people to move on with a level of social skills that go beyond CBT.”\r\n<h3>Flexible, Accessible, and Responsive</h3>\r\nThe CBT Skills Group values accessibility, offering scheduling alternatives that meet as many people’s needs as possible. The course is currently available throughout British Columbia in an online format.\r\n\r\n“I think the virtual version is great,” says Dr. Singh. “It allows a lot of different people to gain access.”\r\n\r\nNot only is the program responsive to patients, but to practitioners as well. At the conclusion of the patient’s experience their doctor receives a feedback report, allowing them to stay current with the patient’s progress.\r\n<h3>Program a ‘Game Changer’</h3>\r\nVancouver Division’s partnership with CBT Skills Group is just another example of our ongoing efforts to address the needs and concerns voiced by our members.\r\n\r\n“It’s important to raise awareness about mental health and to offer resources that can be used to address the issue,” says Ho. “That’s exactly what our involvement with this initiative seeks to accomplish.”\r\n\r\nAccording to Dr. Singh, the program hits the mark.\r\n\r\n“As family doctors, we don’t always have enough time to really do this work ourselves,” she says. “I feel confident making referrals to this program. It’s a real game-changer for my practice and my patients.”\r\n\r\n<a href=\"https://van-division.yarko.dev/initiative/cbt-skills-group/\">Learn more about the CBT Skills Group.</a>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                118,
                119
            ],
            "related_campaigns": [
                79
            ],
            "related_events": [
                198,
                197
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8735"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:featuredmedia": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media/8737"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8735"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8735"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8735"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8735"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9870,
        "date": "2023-01-25T22:59:25",
        "date_gmt": "2023-01-25T22:59:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9870"
        },
        "modified": "2023-08-01T18:29:19",
        "modified_gmt": "2023-08-01T18:29:19",
        "slug": "fast-facts-january-25-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-january-25-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; January 25, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9546289",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9870"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9870"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9870"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9870"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9870"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8660,
        "date": "2023-01-25T18:46:36",
        "date_gmt": "2023-01-25T18:46:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8660"
        },
        "modified": "2023-02-07T23:51:30",
        "modified_gmt": "2023-02-07T23:51:30",
        "slug": "longitudinal-family-physician-payment-model",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/longitudinal-family-physician-payment-model/",
        "title": {
            "rendered": "Longitudinal Family Physician Payment Model"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Details on the Longitudinal Family Physician Payment Schedule launching February 1, 2023. ",
            "resource-introduction": "",
            "resource-text": "Doctors of BC and BC Family Doctors shared the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-r/\" target=\"_blank\" rel=\"noopener\">Longitudinal Family Physician Payment Schedule</a> with physicians last week. We are further sharing to ensure physicians have access to the information they need to make an informed choice about enroling in the model, which launches February 1.\r\n\r\nSupports available:\r\n<ol>\r\n \t<li>The Physician <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-y/\" target=\"_blank\" rel=\"noopener\">pathway to enroling</a> in the LFP Payment model walks doctors through the steps to take toward registration.</li>\r\n \t<li>FAQs are available on the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-j/\" target=\"_blank\" rel=\"noopener\">Doctors of BC</a> website and on the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-t/\" target=\"_blank\" rel=\"noopener\">BC Family Doctors</a> website. Both pages require member log-in.</li>\r\n \t<li>The BC Family Doctors website will soon feature detailed billing information, including a Billing Question Library and case examples. If physicians are not yet a member of BC Family Doctors, they can <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-i/\" target=\"_blank\" rel=\"noopener\">join here.</a></li>\r\n \t<li>Information webinars: DoBC and BCFD hosted Webinars - the recordings can be <a href=\"https://www.youtube.com/watch?v=sOr0R5EDxqQ\">found here</a>.</li>\r\n</ol>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8660"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8660"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8660"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8660"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8660"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8654,
        "date": "2023-01-25T04:45:07",
        "date_gmt": "2023-01-25T04:45:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8654"
        },
        "modified": "2023-01-25T15:20:04",
        "modified_gmt": "2023-01-25T15:20:04",
        "slug": "for-the-care-point-davie-st-clinic-more-space-equals-more-service",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/for-the-care-point-davie-st-clinic-more-space-equals-more-service/",
        "title": {
            "rendered": "For the Care Point Davie St. Clinic, More Space Equals More Service"
        },
        "featured_media": 8656,
        "template": "",
        "resource_type": [
            186,
            196,
            162,
            70
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "A Division grant helps Care Point digitize files, free space for new examination rooms and serve the community better.",
            "resource-introduction": "A Vancouver Division grant helps Care Point Clinic digitize files, free space for new examination rooms and serve the community better.",
            "resource-text": "<img class=\"aligncenter wp-image-8656 size-large\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/P1230170-1024x768.jpg\" alt=\"A taxi drives by the Care Point Clinic on Davie Street in Vancouver's West End Neighbourhood.\" width=\"1024\" height=\"768\" />\r\n\r\nRunning a successful community family practice clinic requires certain things, key among them is a proper amount of suitable patient space.\r\n\r\n“Two or three years ago we were in deep trouble,” admits Clinic Manager Aleks Dukic at the <a href=\"https://www.carepoint.ca/\" target=\"_blank\" rel=\"noopener\">Care Point Clinic</a> on Davie Street. “We didn’t have enough clinicians and the clinic was declining.”\r\n\r\nThese Vancouver Division grants are for PMH practice improvement and building primary care networks. Thanks in part to this, the clinic has been able to expand its usable patient space, in the process greatly enhancing the level of service they’re able to offer the community.\r\n<h3>Clinic Upgrade: From File Rooms to Exam Rooms</h3>\r\nThe clinic started with only three exam rooms, but in the past several years has quickly expanded to become a five, and now seven room facility.\r\n\r\n“To go from three exam rooms to seven in two or three years is huge,” says Dukic. As she explains, the expansion proved appealing not only to patients, but staff as well. “It’s helped us attract physicians as well as nurse practitioners.”\r\n\r\nThe most recent room expansion came about when the clinic opened two new exam rooms that had previously been dedicated to the storage of patient records. To make this possible, the clinic began digitizing their files, a major task that was kicked off with the Division grant.\r\n\r\n“We have five or six clinicians at the moment and nobody wants to work evenings,” says Dukic. “We had to adjust and try to make more space.”\r\n\r\n[caption id=\"attachment_8655\" align=\"alignright\" width=\"400\"]<img class=\"wp-image-8655 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/P1230167-e1674621318376.jpg\" alt=\"Clinic staff stand outside the Care Point Clinic on Davie Street in Vancouver's West End neighbourhood.\" width=\"400\" height=\"533\" /> Left to right: FP Dr. Catherine Allen-Ayodabo, FP Dr. Kelsie Nixon, Care Point COO Christine Lavelle Martin and Clinic Manager Aleks Dukic.[/caption]\r\n<h3>Managing Space Effectively</h3>\r\nWhat’s important when it comes to managing space within a clinic? According to Christine Lavelle-Martin, a good game plan goes a long way. “People have an image of a shiny, new clinic, but that’s not necessarily what’s needed,” says the Chief Operating Office of Care Point. “Instead, it’s the smart use of space.”\r\n\r\nFor her part, Dukic does the majority of her work while at the clinic and the rest at home if her office space is needed. “Everything is web-based, so it doesn’t always matter if I’m here or not,” she says.\r\n\r\nDukic explains how one physician made maximal use of her space. “Younger physicians don’t realize that, with support, they can work in just one room,” she says. “I used to have a doctor who would sit in one room and see over 40 patients in her six hour shift. She would then go back to the doctor’s room to complete her work.”\r\n<h3>Telemedicine Alleviates Pressure on Office Traffic</h3>\r\nPhysicians at the clinic utilize Telemedicine as well, a practice that has benefits for both the patients and the clinic itself.\r\n\r\n“If the need is something minor, such as a renewal or prescription, it’s not always necessary for patients to be physically present,” says Dukic. Using a single space with no need for exam equipment, a doctor can provide a patient with a video consultation, review their records, and send a prescription with the push of a button. “This prevents patients from having to take time off work,” she says.\r\n\r\nLess foot traffic also means less congestion at the facility. “You can see that my reception area is tiny, so when I have six clinicians working at a time, it can be tight,” says Dukic.\r\n<h3>Clinic Environment Good for New Graduates</h3>\r\nDukic believes that facilities such as the Care Point clinic on Davies Street are ideal for new graduates who may not want to immediately tackle the challenge of opening their own practice. “You don’t even need to bring a stethoscope,” she says, “that’s all on the company.”\r\n\r\nAdministrative headaches are handled by management and MOAs, enabling physicians to focus on medicine. “You spend however many hours you want to spend at the clinic, then go home,” she says.\r\n<h3>Healthy, Growing Clinic</h3>\r\nOperating in its expanded physical space, the Care Point clinic continues to thrive. “I have a doctor here who is taking new patients,” says Dukic.\r\n\r\nThis is sure to be welcome news to the West End and the future looks even brighter.\r\n\r\n“We’ve been newly purchased,” announces Lavelle-Martin, “and the intention of our new ownership team is to invest in the clinics, so more upgrades are coming.” The success of the clinic, and others like it, ripples far beyond the facilities’ walls. “We’re trying to help both community patients and our business,” explains Dukic.\r\n\r\n<span style=\"font-weight: 400;\"><em>Photos: previously patient file rooms, the Davie St clinic team has almost finished converting two offices into usable patient space.</em> </span>\r\n\r\n<img class=\"wp-image-8657 size-full alignleft\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/IMG_5472-scaled-e1674621558200.jpeg\" alt=\"\" width=\"300\" height=\"400\" /><img class=\"wp-image-8658 size-full alignleft\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/IMG_5473-scaled-e1674621569321.jpeg\" alt=\"\" width=\"300\" height=\"400\" />\r\n<h3>Cited Sources</h3>\r\n<em>Direct communication with Christine Lavelle-Martin and Aleksandra Dukic.</em>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                186,
                196,
                162,
                70
            ],
            "related_campaigns": [
                185
            ],
            "related_events": [
                187
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8654"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/187"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"
                }
            ],
            "wp:featuredmedia": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media/8656"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8654"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8654"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8654"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8654"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8613,
        "date": "2023-01-18T23:37:45",
        "date_gmt": "2023-01-18T23:37:45",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8613"
        },
        "modified": "2023-01-18T23:37:45",
        "modified_gmt": "2023-01-18T23:37:45",
        "slug": "safe-clinic-environment-poster",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/safe-clinic-environment-poster/",
        "title": {
            "rendered": "Safe Clinic Environment Poster"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Printable poster reminding patients to be respectful to staff.",
            "resource-introduction": "Printable Clinic Poster",
            "resource-text": "Use this poster in your clinic to remind patients to be respectful with staff.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": 8614,
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download Poster",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2023/01/20230118-SafeEnvironmentPoster.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8613"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8613"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8613"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8613"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8613"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9869,
        "date": "2023-01-11T22:54:58",
        "date_gmt": "2023-01-11T22:54:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9869"
        },
        "modified": "2023-08-01T18:41:17",
        "modified_gmt": "2023-08-01T18:41:17",
        "slug": "fast-facts-january-11-2023",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-january-11-2023/",
        "title": {
            "rendered": "Fast Facts &#8211; January 11, 2023"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9546289",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9869"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9869"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9869"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9869"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9869"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9867,
        "date": "2022-12-21T21:31:21",
        "date_gmt": "2022-12-21T21:31:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=9867"
        },
        "modified": "2023-08-01T18:42:43",
        "modified_gmt": "2023-08-01T18:42:43",
        "slug": "fast-facts-december-21st-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-december-21st-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; December 21, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9542541",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/9867"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9867"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9867"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9867"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9867"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8416,
        "date": "2022-12-19T23:27:32",
        "date_gmt": "2022-12-19T23:27:32",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8416"
        },
        "modified": "2022-12-20T00:52:10",
        "modified_gmt": "2022-12-20T00:52:10",
        "slug": "letter-regarding-consultant-physicians-requesting-re-referrals",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/letter-regarding-consultant-physicians-requesting-re-referrals/",
        "title": {
            "rendered": "Letter Regarding Consultant Physicians Requesting Re-Referrals"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            199,
            170
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "A letter to Membership regarding consultant physicians requesting re-referrals.",
            "resource-introduction": "Letter to Membership",
            "resource-text": "<p data-pm-slice=\"1 1 []\">Over the past several months, a number of members have reached out to the Division expressing concerns about the re-referral process; in particular, family doctors are asked to provide a No Charge Referral (03333) after a 6-month period, even if the patient is receiving specialist care for an ongoing condition. In July, the Division’s Continuity of Care Committee met with representatives from Doctors of BC’s Consultation Working Group and Tariff Committee to discuss the issue and the Referral Process FAQ. The findings can be accessed below.</p>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Findings",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/12/Letter-To-Membership-vd.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                170
            ],
            "related_campaigns": [
                184
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8416"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8416"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8416"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8416"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8416"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8371,
        "date": "2022-12-16T00:34:17",
        "date_gmt": "2022-12-16T00:34:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8371"
        },
        "modified": "2022-12-16T00:42:24",
        "modified_gmt": "2022-12-16T00:42:24",
        "slug": "cbt-skills-group-referral-form",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cbt-skills-group-referral-form/",
        "title": {
            "rendered": "CBT Skills Group Referral Form"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            118,
            124,
            119
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Access the CBT Skills Group referral form.",
            "resource-introduction": "",
            "resource-text": "Access the CBT Skills Group referral form.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Access the Referral Form",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/12/CBT-SKILLS-GROUP-PROVINCIAL-REFERRAL-FORM-FILLABLE-2021.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                118,
                119
            ],
            "related_campaigns": [
                79
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8371"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8371"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8371"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8371"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8371"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8342,
        "date": "2022-12-08T17:12:08",
        "date_gmt": "2022-12-08T17:12:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8342"
        },
        "modified": "2022-12-08T17:15:17",
        "modified_gmt": "2022-12-08T17:15:17",
        "slug": "chinese-speaking-cop-focus-group-summary",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/chinese-speaking-cop-focus-group-summary/",
        "title": {
            "rendered": "Chinese Speaking CoP Focus Group Summary"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            196,
            195
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "A summary of two focus group sessions held for Community of Practice supporting Chinese-speaking patients.",
            "resource-introduction": "",
            "resource-text": "The Community of Practice (CoP) supporting Chinese Speaking Patients has identified the need to bolster the provision of culturally appropriate care for many patients who only speak Chinese.\r\n\r\nIn response to this issue, the Vancouver Division held a two-part virtual focus group with nineteen CoP members and FPs in the Chinatown area to learn what they foresee for the future of their practices and patients.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Summary",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/12/VDoFP-Chinese-Language-V3.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                119,
                196
            ],
            "related_campaigns": [],
            "related_events": [
                173
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8342"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8342"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8342"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8342"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8342"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8332,
        "date": "2022-12-08T01:26:14",
        "date_gmt": "2022-12-08T01:26:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8332"
        },
        "modified": "2023-08-01T18:54:33",
        "modified_gmt": "2023-08-01T18:54:33",
        "slug": "fast-facts-december-7-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-december-7-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; December 7, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/96b25d681e9b/youre-invited-for-a-sneak-peek-9531741",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8332"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8332"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8332"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8332"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8332"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8106,
        "date": "2022-12-08T01:20:08",
        "date_gmt": "2022-12-08T01:20:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8106"
        },
        "modified": "2023-05-01T18:20:26",
        "modified_gmt": "2023-05-01T18:20:26",
        "slug": "child-and-youth-mental-health-and-substance-use-resource-guide",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/child-and-youth-mental-health-and-substance-use-resource-guide/",
        "title": {
            "rendered": "Child and Youth Mental Health and Substance Use Resource Guide"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            119
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Supporting children, youth, and their families seeking and receiving timely access to local mental health resources.",
            "resource-introduction": "",
            "resource-text": "<span style=\"font-weight: 400;\">The Vancouver Local Action Team (LAT) was part of the provincial </span><a href=\"http://sharedcarebc.ca/completed-work/cymhsu-collaborative\" target=\"_blank\" rel=\"noopener\"><span style=\"font-weight: 400;\">Child and Youth Mental Health and Substance Use (CYMHSU) Collaborative</span></a><span style=\"font-weight: 400;\">. Since the conclusion of this provincial initiative, the individuals and organizations involved in the Vancouver LAT have continued to work together. Our purpose is to support children, youth, and their families seeking and receiving timely access to local mental health and substance use resources. We believe that mental health is just as important as physical health.</span>\r\n\r\n<span style=\"font-weight: 400;\">Active member organizations include the Vancouver School Board, Vancouver Parks and Recreation, Vancouver Coastal Health, Vancouver Division of Family Practice, YWCA Metro Vancouver, Pacific Community Resources, Family Services of Greater Vancouver, Pacific Autism Network, and the Crisis Centre of BC. For more information about the Vancouver LAT and the Vancouver Division’s involvement. Each member is showcased via video below. </span>\r\n\r\n<span style=\"font-weight: 400;\">The guide was first compiled by the Vancouver LAT in 2017 and was fully revised in December 2021. </span>\r\n\r\nAccess an <a href=\"https://vancouverlat.wixsite.com/resource-directory\" target=\"_blank\" rel=\"noopener\">additional online directory of resources </a>here.\r\n\r\nPromote the directory in your clinic space with these posters available for download and print.\r\n<ul>\r\n \t<li>Poster 1: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021.pdf\">Colour</a> or <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-BW.pdf\">Black and White</a></li>\r\n \t<li>Poster 2: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-v2.pdf\">Colour</a> or <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-BW-v2.pdf\">Black and White</a></li>\r\n</ul>\r\n&nbsp;",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Vancouver Child and Youth Mental Health Resources",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "1. Online Youth Resource Guide",
                    "resource-acc-item-content": "<p><a href=\"https://vancouverlat.wixsite.com/resource-directory\" target=\"_blank\">Vancouver LAT Resource Directory</a></p>\r\n<p><strong>WHO:</strong> Youth of any age (12-18)</p>\r\n<p><strong>WHAT:</strong> An online guide intended as a starting point for youth for support in mental health, medical services, sexual abuse, counselling, and places to go.</p>\r\n<p><strong>WHERE:</strong> <a href=\"https://vancouverlat.wixsite.com/resource-directory\">Online</a></p>\r\n<p><strong>Referrals:</strong> N/A</p>\r\n<p>Intended to be simple in design, this online directory is a starting point for youth on where to go for help. Services and resources are categorized by topic, with key resources listed for each. Each topic is meant to act as key access point rather than an exhaustive list of each resource:</p>\r\n<ul>\r\n<li>Sexual abuse supports\r\n<li>Mental health supports\r\n<li>Medical services\r\n<li>Counselling\r\n<li>Chat options\r\n<li>Programs and places to go\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777156342/01c1c31e39\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777156342?h=01c1c31e39\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "2. Foundry Vancouver Granville",
                    "resource-acc-item-content": "<p><a href=\"https://FoundryBC.ca\" target=\"_blank\">FoundryBC.ca</a></p>\r\n<p>(604) 806-9415</p>\r\n<p>icymhp@providencehealth.bc.ca</p>\r\n<p><strong>WHO:</strong>  Youth 12-24</p>\r\n<p><strong>WHAT:</strong> A place to access mental health care, substance use services, youth and family peer support, and social services, all under one roof. Primary care team available by phone.</p>\r\n<p><strong>WHERE:</strong> 1260 Granville, Vancouver</p>\r\n<p><strong>Referrals:</strong> Self, professional, or family referrals welcome: certain criteria apply to some programs. See below for more information.</p>\r\n<p>Youth should expect wrap-around care that is gender-affirming and trauma-informed in a youth-friendly environment. </p>\r\n<ul>\r\n<li>Website provides tools, articles, and stories\r\n<li>App allows youth to book appointments, get resources\r\n<li>Virtual services include drop-in counselling, peer supports, and groups for youth and families\r\n</ul><br>\r\n<p>Granville specifically:</p>\r\n<ul>\r\n<li>Primary care: limited drop-in: 1-5pm\r\n<li>Episodic care: drop-in, no expectation of ongoing care (ie sexual health)\r\n<li>Longitudinal care*\r\n<li>Psych consults*\r\n<li>Intensive case management*\r\n<li>Substance use: OAT, drug checking \r\n<li>Counselling: brief, solution-based (drop-in: 1 session)\r\n<li>Youth programming: groups, cooking, field trip, youth advisory committee, peer support \r\n</ul><br>\r\n<p>*certain criteria apply</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777158191/2307348b09\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777158191?h=2307348b09\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "3. TransCare BC",
                    "resource-acc-item-content": "<p><a href=\"http://www.phsa.ca/transcarebc/\"</a></p>\r\n<p>(866) 999-1514</p>\r\n<p>transcareteam@phsa.ca</p>\r\n<p><strong>WHO:</strong> Trans and gender-diverse people of Vancouver</p>\r\n<p><strong>WHAT:</strong> A small team of health navigators who work with care providers, clients, and their families to navigate the healthcare system and connect with gender-affirming care.</p>\r\n<p><strong>WHERE:</strong> Online self-referral</p>\r\n<p>TransCare BC provides supports and client navigation of resources. Although it is not a clinic, it is a small team of health navigators who work with care providers, clients, and their families to access information, resources, navigate the healthcare system and connect with gender-affirming care providers. Some limited, brief, direct client care includes surgical readiness assessment and aftercare linkage (i.e., if you’re travelling for surgery). They keep an inventory of providers and pathways. The #1 referral request is to primary care providers able to provide care to trans patients. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777159648/465057e0d5\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777159648?h=465057e0d5\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "4. Pacific Community Resources Society: Broadway Youth Resource Centre",
                    "resource-acc-item-content": "<p><a href=\"https://pcrs.ca/service-types/youth/\" target=\"_blank\">Youth and Family Support | Pacific Community Resources Society (pcrs.ca)</a></p>\r\n<p>(604) 709-5720</p>\r\n<p><a href=\"mailto:byrcreception@pcrs.ca\" target=\"_blank\">byrcreception@pcrs.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> Youth aged 13-24</p>\r\n<p><strong>WHAT:</strong> The BYRC is a one-stop youth centre that provides a wide range of social, health, education, employment, and life skills services to youth</p>\r\n<p><strong>WHERE:</strong> 2455 Fraser, Vancouver</p>\r\n<p><strong>Referrals:</strong> Self, professional, family: in person or by email</p>\r\n<p>Self-referral can take place either in person or by email. NP available for drop-in visits once a week, and staff can provide referrals to other programming for substance use, housing, and Indigenous victim services. An alternative school is also on site (certain criteria applies). A fresh food kit is offered weekly along with a staple pantry that is accessible Monday to Friday. \r\n<p>Youth can expect a warm, inviting welcome and access to a youth worker if needed, along with food, programming, access to computers, and a nonjudgmental space. </p>\r\n<p>Daily programming includes: \r\n<ul>\r\n<li>Substance use support</li>\r\n<li>Mental health support</li>\r\n<li>Self-care</li>\r\n<li>Art therapy</li>\r\n<li>Life skills</li>\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777160756/a9a48f64fe\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777160756?h=a9a48f64fe\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "5. Crisis Centre of BC",
                    "resource-acc-item-content": "<p><a href=\"https://crisiscentre.bc.ca\" target=\"_blank\">https://crisiscentre.bc.ca</a></p>\r\n<p>Mental Health Support Line (24/7): 310-6789</p>\r\n<p>Suicide Support Line (24/7): 1-800-SUICIDE</p>\r\n<p>Youth in BC: (12pm-1am Daily): <a href=\"https://youthinbc.com\" target=\"_blank\">https://youthinbc.com</a></p>\r\n\r\n<p><strong>WHO:</strong> Anyone needing crisis support, suicide prevention, and postvention\r\n<p><strong>WHAT:</strong> Immediate access to barrier-free support through 24/7 phone lines and online services\r\n<p><strong>WHERE:</strong> Phone, online chat\r\n<p><strong>Referrals:</strong> N/A\r\n<p>The Crisis Centre of BC provides help and hope to individuals, organizations, and communities. Services span the spectrum of crisis support, suicide prevention, and postvention. Youth can expect immediate access to barrier-free support through 24/7 phone lines and online services. The Centre also provides education, training, and support programs that promote mental wellness and community capacity Referrals and self-referrals are available to anyone regardless of age. Collaborative, client-centered care. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777162088/fa5edb2af2\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777162088?h=fa5edb2af2\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "6.  VCH: Child and Youth Mental Health Teams and Substance Use Services",
                    "resource-acc-item-content": "<p>Youth substance use services - <a href=\"http://www.vch.ca/public-health/children-youth-schools/youth-health/youth-addiction\" target=\"_blank\">Vancouver Coastal Health (vch.ca)</a></p>\r\n<p>(604) 209-3705 (call for referrals or help with referral process)</p>\r\n\r\n<p><strong>WHO:</strong> Youth aged 13-25 who use substances or alcohol and want support</p>\r\n<p><strong>WHAT:</strong> Trauma-informed, harm reduction approach in addressing substance use</p>\r\n<p><strong>WHERE:</strong> varies- see webpage</p>\r\n<p><strong>Referrals:</strong> call (604) 209-3705</p>\r\n<p>The VCH Youth Substance Use Services is for ages 13-25 who use substances or alcohol and want support addressing their substance use, whether that be reducing, modifying, or using safely. Centralized intake is available 7 days a week. 4 NPs are on staff to offer primary care as well as substance use support (e.g., OAT). The focus is trauma-informed with a harm reduction approach, friendly staff, and non-judgmental attitude. Food is a big part of what they do and is always available.  Services offered include:</p>\r\n<ul>\r\n<li>Cultural services\r\n<li>Social work\r\n<li>Outreach support \r\n<li>Case management \r\n<li>Weekly support for substance use goals\r\n<li>Help with basic needs\r\n<li>Family work\r\n<li>Connection to services \r\n<li>Referrals\r\n<li>Day treatment program\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777162822\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777162822?h=b0985ca68d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "7. Vancouver Parks: Youth Programming and Services",
                    "resource-acc-item-content": "<p><a href=\"https://vancouver.ca/people-programs/youth.aspx\" target=\"_blank\">Youth engagement and support | City of Vancouver</a></p>\r\n\r\n<p><strong>WHO:</strong> Ages 8-19</p>\r\n<p><strong>WHAT:</strong> Low-barrier activities for youth</p>\r\n<p><strong>WHERE:</strong> Various locations across the lower Mainland</p>\r\n<p><strong>Referrals:</strong> not needed; low/no-barrier access.</p>\r\n\r\n<p>Vancouver Parks Youth Programming is open for anyone ages 8-19 at their local community center. Each community center has its own Youth Community Programmer.</p>\r\n<p> A sense of belonging, low-barrier, not just sports: arts, social, dance, games room, ping pong, video games, relationship building. 1-on-1 office meetings available Monday-Friday, F 9-5, no/low cost. </p>\r\n<p>Leisure access program, offers occasional dental/vaccine clinic. </p>\r\n<p>Advocacy Volunteer opportunities: A chance for youth to make a difference in their community. Connected to many other CHY services in this list! Longer hours than many services, open Christmas, and New Year’s. A safe space. Harm reduction supplies available. Condoms available. Help for bus tickets. Menstrual products in all washrooms. Youth should come and expect an easy or nonexistent intake process. Trans celebration. Gender-affirming.  Scribing services. Multilingual.</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777166255/3c1851e8a9\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777166255?h=3c1851e8a9\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "8. Vancouver School Board: Services and Supports for Students",
                    "resource-acc-item-content": "<p><a href=\"https://www.vsb.bc.ca/page/5151/mental-health\" target=\"_blank\">Vancouver School Board (vsb.bc.ca)</a></p>\r\n\r\n<p><strong>WHO:</strong> School-aged children and youth enrolled in the VSB.</p>\r\n<p><strong>WHAT:</strong> Academic, social, emotional, and career support</p>\r\n<p><strong>WHERE:</strong> At schools in the VSB.</p>\r\n<p><strong>Referrals:</strong> Can happen by students, teachers, administrators, parents, and guardians.  </p> \r\n\r\nFind the VSB Student Health Information Sharing Forms <a href=\"https://van-division.yarko.dev/resource/vsb-student-health-information-sharing-form/\">here</a>. \r\n\r\n<p>School counsellors provide services to all school-aged children and youth enrolled in the VSB, their families, and their educators. Referral can happen by students, teachers, administrators, parents and guardians.</p>\r\n<p>Expect continued, consistent, and ongoing academic, social, emotional, and career support from kindergarten through grade 12.</p>\r\n<p>Facilitates referrals within community. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777167181/1f07e6f01d\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777167181?h=1f07e6f01d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "9. YMCA of Greater Vancouver: Y Mind",
                    "resource-acc-item-content": "<p>Website: <a href=\"https://www.gv.ymca.ca/mental-wellness\" target=\"_blank\">ymca.ca/mental-wellness</a>\r\n<p>Email: <a href=\"mailto:YMind@gv.ymca.ca\" target=\"_blank\">YMind@gv.ymca.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> 13-18</p>\r\n<p><strong>WHAT:</strong> Aims for early intervention to stress/mild-moderate anxiety</p>\r\n<p><strong>WHERE:</strong> Various locations</p>\r\n<p><strong>Referral:</strong> self and professional both welcome. Email for information.</p>\r\n\r\n<p>Approach: ACT: Acceptance and Commitment Therapy</p>\r\n<p>Anxiety is a part of life, not a problem to get rid of. </p>\r\n<p>Offers tools such as mindfulness to notice a make room for uncomfortable feelings, which allow us to move towards what is important to us, even in the presence of uncomfortable feelings. Ultimately this leads to a more rich and fulfilling life. </p>\r\n<p>Age: 13+ (13-18, 18-30): Mild-moderate anxiety; aim for early intervention and prevention. No diagnosis required. Group setting, main focus on anxiety/stress; 7-week commitment required.\r\n<p>Outcomes: decreased anxiety symptoms, increased wellbeing, improved mindfulness and greater psychological flexibility.</p>\r\n<p>Referral: self, professional both welcome. YMind will reach out with program information.</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777167809/930128e520\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777167809?h=930128e520\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "10.  Directions Youth Services",
                    "resource-acc-item-content": "<p><a href=\"https://www.directionsyouthservices.ca/\" target=\"_blank\">Directionsyouthservices.ca</a></p>\r\n<p>(604) 633-1472 / (866) 249-6884</p>\r\n<p><a href=\"mailto:directions@fsgv.ca\" target=\"_blank\">directions@fsgv.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> Low-income youth under 25 </p>\r\n<p><strong>WHAT:</strong> Low-barrier services for youth experiencing homelessness as a result of abuse, neglect, substance use, or mental health challenges</p>\r\n<p><strong>WHERE:</strong> 1138 Burrard St., Vancouver</p>\r\n<p>Open program can be referred to and accessed at any time. Criteria is typically: youth under 25; low income; in need of housing; mental/physical disability; but will help anyone in crisis under age 25 and is a safe place.</p>\r\n<ul>\r\n<li>24/7/365 low-barrier service\r\n<li>Washrooms and showers\r\n<li>Meals, snacks, pantry program\r\n<li>Shelter: extra mats for extreme weather\r\n<li>Harm reduction supplies and information\r\n<li>Pet room\r\n<li>SYJA Pre-employment \r\n<li>Media/arts programming\r\n<li>Primary care 2x weekly\r\n<li>2 Safehouses for ages 16-18\r\n<li>Youth Detox: (criteria not as low barrier; see presentation/website)\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777169145/2179320a8d\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777169145?h=2179320a8d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                },
                {
                    "resource-acc-item-title": "11. Family Smart",
                    "resource-acc-item-content": "<p><a href=\"https://familysmart.ca/\" target=\"_blank\">Familysmart.ca</a></p>\r\n<p>(855) 887-8004</p>\r\n\r\n<p><strong>WHO:</strong> For families of children, youth, and young adults.</p>\r\n<p><strong>WHAT:</strong> An organization that helps young people by helping the adults who care for them\r\n<p><strong>WHERE:</strong> see website</p>\r\n<p><strong>Referrals:</strong> <a href=\"https://familysmart.ca/refer-people/\" target=\"_blank\">Refer People - FamilySmart</a></p>\r\n\r\n<p>Families can self-refer: no diagnosis, no waitlist, free. Can refer a family with consent. \r\nWe help children and young people by helping their family and other caring adults in their lives. We know that when families are supported alongside of their children, youth, and young adults, things go better.</p>\r\n<p>Peer Support Workers are parents who lead with their own lived experience of supporting child, youth, or young adult through the mental health and/or substance use system. Support for all stages of the journey. </p>\r\n<ul>\r\n<li>Provides emotional support and mentoring to parents and caregivers \r\n<li>Connects families to resources and information about services and supports\r\n<li>Helps with service navigation, what to expect when accessing services\r\n<li>Can meet by phone, email, video chat.\r\n<li>Monthly virtual events to share experiences and strategies that help in hard moments \r\n<li>Focus on strengthening understanding and connection with our kids. \r\n<li>Free monthly workshops for families with repeated ER visits or inpatient experiences with mental health or substance use \r\n<ul>\r\n<li>Topics include safety at home and managing once emerging from crisis \r\n</ul></ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777170429/29d250b674\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777170429?h=29d250b674\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"
                }
            ],
            "related_resources": [
                118,
                119
            ],
            "related_campaigns": [
                79,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8106"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8106"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8106"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8106"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8106"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8319,
        "date": "2022-12-06T21:38:31",
        "date_gmt": "2022-12-06T21:38:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8319"
        },
        "modified": "2022-12-06T22:30:32",
        "modified_gmt": "2022-12-06T22:30:32",
        "slug": "vch-adult-day-programs",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/vch-adult-day-programs/",
        "title": {
            "rendered": "VCH Adult Day Programs"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Adult day services assist seniors and adults with disabilities to continue to live in their own homes.",
            "resource-introduction": "",
            "resource-text": "Adult day services assist seniors and adults with disabilities to continue to live in their own homes by providing supportive group programs and activities in the community. There are 12 funded Adult Day Programs in Vancouver and after a challenging period of closure in the heat of the pandemic, they are up and running again. There are Adult Day Program spaces available across the city.\r\n\r\nFor more information or to access the Referral form, please see the resources below.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "Vancouver Home and Community Referral Form",
                    "resource-acc-item-content": "To access this service, an individual requires a referral to a Home Health Case Manager. To make a Home Health Case Manager Referral anyone may call Vancouver Community Central Intake at (604) 263-7377. A Health Care Professional <strong><a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/Vancouver-home-and-community-referral-form.pdf\">can complete the Central Intake Referral form </a></strong> and fax it to (604) 267- 3419."
                },
                {
                    "resource-acc-item-title": "VC Adult Day Programs Info Sheet - December 2022",
                    "resource-acc-item-content": "Adult Day Programs are designed for adults who have physical and/or memory challenges or are living with a chronic illness. The program is for individuals who may struggle to attend programs at conventional community centers. Clients of VCH Adult Day Programs travel to a location in their community 1-2 days per week where they are met by knowledgeable and caring staff offering a variety of services.\r\n\r\n<p><strong><a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/VC-Adult-Day-Programs-December-2022.pdf\">Learn More about the programs here.</a></strong>"
                }
            ],
            "related_resources": [
                180,
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8319"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8319"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8319"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8319"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8319"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8272,
        "date": "2022-11-30T10:46:29",
        "date_gmt": "2022-11-30T10:46:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8272"
        },
        "modified": "2022-11-30T10:46:29",
        "modified_gmt": "2022-11-30T10:46:29",
        "slug": "accepting-provider-reminder",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/accepting-provider-reminder/",
        "title": {
            "rendered": "Accepting Provider Reminder Emails"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "Reminder email to accepting providers about patient panel. ",
            "resource-introduction": "",
            "resource-text": "An example email providers receive from the Vancouver Division. ",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Email Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/11/Accepting-Provider-Reminder-Emails.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8272"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8272"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8272"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8272"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8272"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8271,
        "date": "2022-11-30T10:42:52",
        "date_gmt": "2022-11-30T10:42:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8271"
        },
        "modified": "2022-11-30T10:44:19",
        "modified_gmt": "2022-11-30T10:44:19",
        "slug": "introduction-to-new-primary-care-provider",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/introduction-to-new-primary-care-provider/",
        "title": {
            "rendered": "Introduction to New Primary Care Provider"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "Email to patients receive from the Vancouver Division introducing their new primary care provider.",
            "resource-introduction": "",
            "resource-text": "An example email patients receive from the Vancouver Division introducing their new primary care provider. ",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/11/Reallocation-Email-Example.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8271"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8271"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8271"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8271"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8271"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8235,
        "date": "2022-11-25T08:13:36",
        "date_gmt": "2022-11-25T08:13:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8235"
        },
        "modified": "2022-11-25T08:29:02",
        "modified_gmt": "2022-11-25T08:29:02",
        "slug": "cbt-mh-tiers",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cbt-mh-tiers/",
        "title": {
            "rendered": "CBT and Mental Health Tiers of Service"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            118,
            124,
            119
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Where CBT Skills intersect with Mental Health Tiers of Service.",
            "resource-introduction": "",
            "resource-text": "Understand where CBT Skills intersect with Mental Health Tiers of Service. Further information is also available via the <a href=\"https://van-division.yarko.dev/mhsu\" target=\"_blank\" rel=\"noopener\">Mental Health and Substance Use (MHSU) page</a>.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": 8208,
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "<a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/11/MH-Tiers-of-care-CBT.pdf\">MH Tiers of care &amp; CBT</a>",
            "resource-button_text": "View the Image",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/11/MH-Tiers-of-care-CBT.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                118,
                119
            ],
            "related_campaigns": [
                79
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8235"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8235"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8235"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8235"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8235"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8234,
        "date": "2022-11-25T00:23:14",
        "date_gmt": "2022-11-25T00:23:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=8234"
        },
        "modified": "2023-08-01T19:15:50",
        "modified_gmt": "2023-08-01T19:15:50",
        "slug": "fast-facts-november-23-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-november-23-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; November 23, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9531677",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/8234"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8234"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8234"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8234"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8234"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7650,
        "date": "2022-11-10T19:21:54",
        "date_gmt": "2022-11-10T19:21:54",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7650"
        },
        "modified": "2023-08-01T19:20:08",
        "modified_gmt": "2023-08-01T19:20:08",
        "slug": "fast-facts-november-09-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-november-09-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; November 09, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9527841",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7650"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7650"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7650"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7650"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7650"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7591,
        "date": "2022-11-08T01:04:00",
        "date_gmt": "2022-11-08T01:04:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7591"
        },
        "modified": "2022-11-08T01:04:00",
        "modified_gmt": "2022-11-08T01:04:00",
        "slug": "urgent-and-primary-care-centres",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/urgent-and-primary-care-centres/",
        "title": {
            "rendered": "Urgent and Primary Care Centres"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            194
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Urgent and Primary Care Centres are available with extended hours for same-day, non-life-threatening injuries and illnesses.",
            "resource-introduction": "",
            "resource-text": "<a href=\"http://www.vch.ca/your-care/urgent-and-primary-care-centres\" target=\"_blank\" rel=\"noopener\">Urgent and Primary Care Centres</a> are available with extended hours for same-day, non-life-threatening injuries and illnesses",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Find Urgent and Primary Care Centres",
            "resource-button_link": "http://www.vch.ca/your-care/urgent-and-primary-care-centres",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7591"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7591"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7591"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7591"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7591"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7590,
        "date": "2022-11-08T01:02:29",
        "date_gmt": "2022-11-08T01:02:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7590"
        },
        "modified": "2022-11-08T01:06:20",
        "modified_gmt": "2022-11-08T01:06:20",
        "slug": "bc211",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/bc211/",
        "title": {
            "rendered": "bc211"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            191,
            193
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "bc211 is a free 24/7, confidential multilingual service that links people to resources for help, where and when they need it.",
            "resource-introduction": "",
            "resource-text": "<section class=\"has_ae_slider elementor-section elementor-top-section elementor-element elementor-element-cfa5162 elementor-section-boxed elementor-section-height-default elementor-section-height-default ae-bg-gallery-type-default\" data-id=\"cfa5162\" data-element_type=\"section\" data-settings=\"{&quot;_ha_eqh_enable&quot;:false}\">\r\n<div class=\"elementor-container elementor-column-gap-default\">\r\n<div class=\"has_ae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e89cbb ae-bg-gallery-type-default\" data-id=\"3e89cbb\" data-element_type=\"column\">\r\n<div class=\"elementor-widget-wrap elementor-element-populated\">\r\n<div class=\"elementor-element elementor-element-eda2540 elementor-widget elementor-widget-text-editor\" data-id=\"eda2540\" data-element_type=\"widget\" data-widget_type=\"text-editor.default\">\r\n<div class=\"elementor-widget-container\">\r\n\r\n<a href=\"https://bc.211.ca/\" target=\"_blank\" rel=\"noopener\">bc211</a> is a free 24/7, confidential multilingual service that links people to resources for help, where and when they need it.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</section><section class=\"has_ae_slider elementor-section elementor-top-section elementor-element elementor-element-ca579c6 elementor-section-boxed elementor-section-height-default elementor-section-height-default ae-bg-gallery-type-default\" data-id=\"ca579c6\" data-element_type=\"section\" data-settings=\"{&quot;_ha_eqh_enable&quot;:false}\">\r\n<div class=\"elementor-container elementor-column-gap-default\">\r\n<div class=\"has_ae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6440caa ae-bg-gallery-type-default\" data-id=\"6440caa\" data-element_type=\"column\">\r\n<div class=\"elementor-widget-wrap elementor-element-populated\"></div>\r\n</div>\r\n</div>\r\n</section>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Visit bc211",
            "resource-button_link": "https://bc.211.ca/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                73
            ],
            "related_campaigns": [
                91,
                117,
                184
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7590"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7590"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7590"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7590"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7590"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7589,
        "date": "2022-11-08T01:00:30",
        "date_gmt": "2022-11-08T01:00:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7589"
        },
        "modified": "2022-11-08T01:06:53",
        "modified_gmt": "2022-11-08T01:06:53",
        "slug": "healthlinkbc",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/healthlinkbc/",
        "title": {
            "rendered": "HealthlinkBC"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            191,
            193
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A free provincial health information and advice phone line.",
            "resource-introduction": "",
            "resource-text": "<a href=\"https://www.healthlinkbc.ca/health-services/search-services-your-area\" target=\"_blank\" rel=\"noopener\">HealthlinkBC</a> or call 8-1-1, is a free provincial health information and advice phone line. You can speak to a health service navigator who can help you find information and services, or connect you directly to a registered nurse, registered dietitian, qualified exercise professional or pharmacist.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Visit HealthlinkBC",
            "resource-button_link": "https://www.healthlinkbc.ca/health-services/search-services-your-area",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                73
            ],
            "related_campaigns": [
                79,
                91,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7589"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7589"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7589"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7589"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7589"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7588,
        "date": "2022-11-08T00:57:27",
        "date_gmt": "2022-11-08T00:57:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7588"
        },
        "modified": "2022-11-08T01:07:39",
        "modified_gmt": "2022-11-08T01:07:39",
        "slug": "medimap",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/medimap/",
        "title": {
            "rendered": "Medimap"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            191,
            193
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Locate the nearest walk-in clinic and their wait-times.",
            "resource-introduction": "",
            "resource-text": "Compare availability and book an appointment with a wide variety of local care providers in one place. Our vision is to be the go-to resource for easy access to care across the globe.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Go to Medimap",
            "resource-button_link": "https://medimap.ca/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                73
            ],
            "related_campaigns": [
                79,
                91,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7588"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7588"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7588"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7588"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7588"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7425,
        "date": "2022-10-31T22:22:58",
        "date_gmt": "2022-10-31T22:22:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7425"
        },
        "modified": "2023-08-01T19:43:21",
        "modified_gmt": "2023-08-01T19:43:21",
        "slug": "fast-facts-october-26-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-october-26-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; October 26, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9067373",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7425"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7425"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7425"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7425"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7425"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7424,
        "date": "2022-10-31T22:21:27",
        "date_gmt": "2022-10-31T22:21:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7424"
        },
        "modified": "2022-10-31T22:22:50",
        "modified_gmt": "2022-10-31T22:22:50",
        "slug": "fast-facts-october-12-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-october-12-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; October 12, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9063857",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                166,
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7424"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7424"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7424"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7424"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7424"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7419,
        "date": "2022-10-31T15:43:36",
        "date_gmt": "2022-10-31T15:43:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7419"
        },
        "modified": "2022-11-08T01:08:17",
        "modified_gmt": "2022-11-08T01:08:17",
        "slug": "find-a-doctor-bc",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/find-a-doctor-bc/",
        "title": {
            "rendered": "Find a Doctor BC"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            191,
            192
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A site that is updated by the public regularly.",
            "resource-introduction": "",
            "resource-text": "Find a Doctor BC is a website dedicated to helping patients help each other find family practitioners accepting new patients.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Find a Doctor BC",
            "resource-button_link": "https://www.findadoctorbc.ca/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                73
            ],
            "related_campaigns": [
                184,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7419"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7419"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7419"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7419"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7419"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7418,
        "date": "2022-10-31T15:38:17",
        "date_gmt": "2022-10-31T15:38:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7418"
        },
        "modified": "2022-11-08T01:08:58",
        "modified_gmt": "2022-11-08T01:08:58",
        "slug": "pathways-medical-care-directory",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/pathways-medical-care-directory/",
        "title": {
            "rendered": "Pathways Medical Care Directory"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            73
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [
            191,
            192
        ],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Use the “Find Care” search function",
            "resource-introduction": "",
            "resource-text": "<a href=\"https://pathwaysmedicalcare.ca/\" data-type=\"URL\" data-id=\"https://pathwaysmedicalcare.ca/\" data-wpel-link=\"internal\">PathwaysMedicalCare.ca</a> is a new one-stop online directory to easily find information about doctors and medical clinics in British Columbia.\r\n\r\n<a href=\"https://pathwaysmedicalcare.ca/\" data-type=\"URL\" data-id=\"https://pathwaysmedicalcare.ca/\" data-wpel-link=\"internal\">PathwaysMedicalCare.ca</a> helps patients find details of how to connect with doctors for virtual care by phone or video and also provides latest clinic updates.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Pathways Medical Care Directory",
            "resource-button_link": "https://pathwaysmedicalcare.ca/about/",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                73
            ],
            "related_campaigns": [
                184,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7418"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7418"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7418"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7418"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7418"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7396,
        "date": "2022-10-27T16:21:17",
        "date_gmt": "2022-10-27T16:21:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7396"
        },
        "modified": "2022-10-27T16:21:17",
        "modified_gmt": "2022-10-27T16:21:17",
        "slug": "2021-22-vdofp-annual-report",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/2021-22-vdofp-annual-report/",
        "title": {
            "rendered": "2021/22 VDoFP Annual Report"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            167
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Read the annual report for the 2021-2022 year.",
            "resource-introduction": "",
            "resource-text": "Read the annual report for the 2021-2022 year.\r\n\r\nIncludes:\r\n<ul>\r\n \t<li>Messages:\r\n<ul>\r\n \t<li>Executive Director Message</li>\r\n \t<li>Board Chair Message</li>\r\n</ul>\r\n</li>\r\n \t<li>Organizational Overview</li>\r\n \t<li>Financial Report</li>\r\n \t<li>Reports:\r\n<ul>\r\n \t<li>Primary Care Networks</li>\r\n \t<li>PCN Project Team</li>\r\n \t<li>Physician Wellness</li>\r\n \t<li>Member Engagement</li>\r\n \t<li>Mental Health &amp; Substance Use</li>\r\n \t<li>Maternity Care</li>\r\n \t<li>Recruitment &amp; Retention</li>\r\n \t<li>Patient Attachment Initiative</li>\r\n \t<li>Seniors’ Care</li>\r\n</ul>\r\n</li>\r\n</ul>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Report",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/VDoFP-2021-22-Annual-Report.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7396"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7396"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7396"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7396"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7396"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7389,
        "date": "2022-10-26T23:00:30",
        "date_gmt": "2022-10-26T23:00:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7389"
        },
        "modified": "2022-10-26T23:01:22",
        "modified_gmt": "2022-10-26T23:01:22",
        "slug": "member-survey-infographic",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/member-survey-infographic/",
        "title": {
            "rendered": "Member Survey Infographic"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            167,
            125
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Valuable member insight from our 2022 member-wide survey.",
            "resource-introduction": "",
            "resource-text": "Valuable member insight from our 2022 member-wide survey.\r\n<ul>\r\n \t<li>249 responses from a diverse cross section of members (20% response rate)</li>\r\n \t<li>Survey Focus Areas\r\n<ul>\r\n \t<li>COVID-19 Impacts</li>\r\n \t<li>Preferred methods of communication and engagement</li>\r\n \t<li>Current thoughts on program areas</li>\r\n \t<li>Baseline demographics on member diversity</li>\r\n</ul>\r\n</li>\r\n</ul>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Browse the infographic",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/Member-Needs-Survey-Infographic-2022.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7389"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7389"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7389"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7389"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7389"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7385,
        "date": "2022-10-26T22:55:09",
        "date_gmt": "2022-10-26T22:55:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7385"
        },
        "modified": "2022-10-26T22:56:26",
        "modified_gmt": "2022-10-26T22:56:26",
        "slug": "member-survey-briefing-notes",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/member-survey-briefing-notes/",
        "title": {
            "rendered": "Member Survey Briefing Notes"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            167,
            125
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Sharing additional results from the 2022 Member Needs and Engagement survey.",
            "resource-introduction": "",
            "resource-text": "<ul>\r\n \t<li>The anonymized survey was open for 16 days (Feb 25-Mar 13)</li>\r\n \t<li>249 responses were received from a diverse cross section of members (20% response rate)\r\nThe survey collected answers on the following four topic areas:\r\n<ol>\r\n \t<li>COVID-19 impacts</li>\r\n \t<li>Current opinions on Division communications and engagement</li>\r\n \t<li>Up-to-date feedback on program areas</li>\r\n \t<li>Baseline demographics on member diversity</li>\r\n</ol>\r\n</li>\r\n</ul>\r\n<div class=\"page\" title=\"Page 2\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nIncluded are highlighted survey results based on information that are informing different Division departments and areas.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the notes",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/Briefing-Note-June-2022-Board-Meeting-Member-Survey.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7385"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7385"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7385"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7385"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7385"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7259,
        "date": "2022-10-24T15:31:10",
        "date_gmt": "2022-10-24T15:31:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7259"
        },
        "modified": "2023-07-13T18:33:45",
        "modified_gmt": "2023-07-13T18:33:45",
        "slug": "2023-24-strategic-priorities-vancouver-division-of-family-practice",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/2023-24-strategic-priorities-vancouver-division-of-family-practice/",
        "title": {
            "rendered": "2023-24 Strategic Priorities &#8211; Vancouver Division of Family Practice"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            167
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Read the 2022-23 Strategic Priorities for the Vancouver Division of Family Practice.",
            "resource-introduction": "",
            "resource-text": "Read the 2023-24 Strategic Priorities for the Vancouver Division of Family Practice.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "<a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/10/Vancouver-Division-8a-2022-Strat-Priorities-Revised.pdf\">Vancouver Division 8a-2022 Strat Priorities Revised</a>",
            "resource-button_text": "Access the Strategic Plan",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/2023-Strat-Priorities-Final.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                167
            ],
            "related_campaigns": [],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7259"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7259"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7259"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7259"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7259"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6868,
        "date": "2022-10-12T10:07:52",
        "date_gmt": "2022-10-12T10:07:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6868"
        },
        "modified": "2023-01-02T18:10:49",
        "modified_gmt": "2023-01-02T18:10:49",
        "slug": "clinic-grant-faq-2022-23",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/clinic-grant-faq-2022-23/",
        "title": {
            "rendered": "Clinic Grant FAQ 2022/23"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            186
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": "",
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "This FAQ regroups the major questions asked by Family Physicians as of <strong>November 15th</strong>. We will update this FAQ as we receive further questions from FPs.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "What’s the purpose of the grant?",
                    "resource-acc-item-content": "The Vancouver Division of Family Practice (VDOFP) is proud to offer our community family practice clinics a one-time financial grant to support your ideas to improve your Patient Medical Home practices and to build your Primary Care Networks. Our objective is to encourage as many clinics as possible to access the grants for a project that will make a meaningful difference to your clinic and staff."
                },
                {
                    "resource-acc-item-title": "Which clinics are eligible?",
                    "resource-acc-item-content": "The clinic grant program is available to PMHs providing primary care to patients in the community, and not in a care facility (e.g. hospital facility). PMH's providing community based primary care, but funded primarily by another entity (e.g. VCH), may receive funding for programs supporting improvements for Division members providing patient care."
                },
                {
                    "resource-acc-item-title": "How much grant funding can each clinic receive?",
                    "resource-acc-item-content": "Grant amounts are funded based on the number of physician full-time equivalent (FTE) at a clinic. Clinics with:\r\n<ul>\r\n<li><b>1 family physician FTE</b> will receive <b>$1,500</b></li>\r\n<li><b>2 - 4 family physician FTEs</b> will receive <b>$3,000</b></li>\r\n<li><b>5 or more family physician FTEs</b> will receive <b>$4,500</b></li>\r\n</ul>\r\n<br>For example, if your clinic has 2 full-time physicians and 3 physicians that see patients half-time, the clinic is eligible for $3,000 (2 + 1.5 FTEs = 3.5 FTEs)."
                },
                {
                    "resource-acc-item-title": "Can multiple clinics partner on a project?",
                    "resource-acc-item-content": "Yes. Clinics may work together on a joint project the positively benefits each clinic. Each clinic will be awarded the grant based on the number of physicians working at each clinic, up to $4,500 per clinic. Only one Clinic Owner or Clinic Manager needs to submit the grant request on behalf of all clinics involved."
                },
                {
                    "resource-acc-item-title": "Can multiple physicians in a clinic submit different grant applications?",
                    "resource-acc-item-content": "No. The application is for the entire clinic (or group of clinics). A single application can include multiple ideas that all support the improvement of Patient Medical Homes and building Primary Care Networks. "
                },
                {
                    "resource-acc-item-title": "How do I apply? And when do I apply?",
                    "resource-acc-item-content": "Each clinic or group of clinics may request one grant for a project of its choice, using the online application form here: <b><a href=\"https://tinyurl.com/ytnz42ps\" target=\"blank\">Clinic Grant Application</a></b>. We encourage Clinic Owners and Clinic Managers representing an individual clinic (or representing a group of clinics) to apply on behalf of the entire clinic. <br>\r\nPlease submit your application prior to November 16, 2022. <br>\r\nIf you have any questions or would like support to submit your application, please contact your Community Network Manager (CNM) or email <a href=\"mailto:pcn@van-division.yarko.dev\">pcn@van-division.yarko.dev</a>"
                },
                {
                    "resource-acc-item-title": "What types of projects will the grant fund?",
                    "resource-acc-item-content": "The grant is to encourage clinics to invest in practice support and networking, two things that clinics may have been unable to work on given the impact of COVID-19 and the primary care crisis. <br>\r\nClinic grants can be used for a variety of improvements - from support upgrading office furniture and performing renovations through to paying for MOA training.<br>\r\nHere are some more project ideas (and feel free to propose something that is meaningful to your individual clinic):\r\n<ul>\r\n<li>Digitize / remove old charts from the clinic </li>\r\n<li>Upgrade your EMR </li>\r\n<li>Implement an online patient appointment booking tool  </li>\r\n<li>Update clinic software or expand clinic Wi-Fi  </li>\r\n<li>Improve patient spaces within your clinic (seating, room dividers, accessibility improvements)</li>\r\n<li>Train clinic staff on principles of Team Based Care </li>\r\n<li>Train your MOAs on new technology or other skills  </li>\r\n<li>Update your employment contracts or associate agreements</li> \r\n<li>Evaluate clinic technology privacy and security, and implement improvements </li>\r\n<li>Create a clinic website on Pathways </li>\r\n</ul>\r\n<br>\r\nIf you're looking for more ideas, <a href=https://van-division.yarko.dev/resource/clinic-grant-report-december-2021-march-2022/\">here are examples of programs that were undertaken during the 2021/22 clinic grant program</a>. "
                },
                {
                    "resource-acc-item-title": "Can the grants be used towards the purchase of computers?",
                    "resource-acc-item-content": "Many clinics use the grant to improve their operations through technology. Grants can be used towards the purchase of computer hardware that is <b>not attached</b> to clinical equipment. This would include clinic computers used by physicians and staff.\r\n\r\n\r\nGrants <b>cannot</b> be awarded for purchase of clinical equipment or computer hardware to provide direct patient care, or where other funding already exists. Please see the FAQ item on Exclusions."
                },
                {
                    "resource-acc-item-title": "Are there any exclusions?",
                    "resource-acc-item-content": "Grants cannot be awarded for purchase of clinical equipment or computers to provide direct patient care, or where other funding already exists: \r\n<ul>\r\n<li>E.g., GPSC already offers funding for clinics to perform panel management and to implement Health Data Coalition’s EMR data portal.</li>\r\n<li>E.g. 2, The Ministry of Health provides free PPE to clinics, and a clinic should not need to use this grant to obtain PPE. </li>\r\n</ul>"
                },
                {
                    "resource-acc-item-title": "When will the grant money be awarded?",
                    "resource-acc-item-content": "Clinics will receive 80% of the funds shortly after project approval, and the remaining 20% of the funds at project completion."
                },
                {
                    "resource-acc-item-title": "How long do I have to complete my project?",
                    "resource-acc-item-content": "Projects must be completed by <b>February 28, 2023</b> providing clinics up to four (4) months to achieve their desired outcomes."
                },
                {
                    "resource-acc-item-title": "How do I receive the remaining 20% of the grant funding?",
                    "resource-acc-item-content": "A clinic (or group of clinics) will receive the remaining 20% of project funds upon project completion. We will send you a template to provide a brief update on your project, after which you will receive the remaining funding."
                },
                {
                    "resource-acc-item-title": "Will the grant cover ongoing costs associated with the projects? ",
                    "resource-acc-item-content": "No. The grant will cover the clinic’s initial project costs, and it is the clinic’s responsibility to pay for any ongoing costs beyond the initial project.  "
                },
                {
                    "resource-acc-item-title": "Who should I contact with questions or for support? ",
                    "resource-acc-item-content": "If you have any questions or comments about the grant or your project idea, please contact your Community Network Manager (CNM) or email <a href=\"mailto:pcn@van-division.yarko.dev\">pcn@van-division.yarko.dev</a>"
                }
            ],
            "related_resources": [],
            "related_campaigns": [
                185,
                184
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6868"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6868"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6868"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6868"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6868"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6695,
        "date": "2022-10-03T15:53:31",
        "date_gmt": "2022-10-03T15:53:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6695"
        },
        "modified": "2022-10-03T15:53:31",
        "modified_gmt": "2022-10-03T15:53:31",
        "slug": "fast-facts-september-28-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-september-28-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; September 28, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9059597",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                166,
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6695"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6695"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6695"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6695"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6695"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6694,
        "date": "2022-10-03T15:51:00",
        "date_gmt": "2022-10-03T15:51:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6694"
        },
        "modified": "2022-10-03T15:51:00",
        "modified_gmt": "2022-10-03T15:51:00",
        "slug": "fast-facts-september-14-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-september-14-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; September 14, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9055409",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                166,
                172,
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6694"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6694"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6694"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6694"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6694"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7126,
        "date": "2022-09-22T10:00:14",
        "date_gmt": "2022-09-22T10:00:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7126"
        },
        "modified": "2022-10-19T19:17:11",
        "modified_gmt": "2022-10-19T19:17:11",
        "slug": "clinic-grant-report-december-2021-march-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/clinic-grant-report-december-2021-march-2022/",
        "title": {
            "rendered": "Clinic Grant Report – December 2021-March 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            186,
            125
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Clinic grant support overview, impact and efficacy report.",
            "resource-introduction": "Clinic grant support overview, impact and efficacy report.",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nBetween December 2021 and March 2022, Vancouver-based primary care clinics received one-time grants to support patient medical home (PMH) related practice improvements. Most of the work focused on improving clinic operations.\r\n\r\n</div>\r\nDownload the PDF infographic report on this page.\r\n\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Report",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_Clinic-Grant-Report-V7-1.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                186
            ],
            "related_campaigns": [
                185
            ],
            "related_events": [
                187
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7126"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/187"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7126"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7126"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7126"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7126"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6482,
        "date": "2022-09-14T22:48:44",
        "date_gmt": "2022-09-14T22:48:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6482"
        },
        "modified": "2022-10-05T17:40:06",
        "modified_gmt": "2022-10-05T17:40:06",
        "slug": "flu-vaccine-faq-2022-23",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/flu-vaccine-faq-2022-23/",
        "title": {
            "rendered": "Flu Vaccine FAQ 2022/23"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            169
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis FAQ regroups the major questions asked by Family Physicians and responses from VCH and the Vancouver Division as of <strong>October 4th, 2022</strong>. We will update this FAQ as we receive new information from VCH and further questions from FPs.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Access the FAQ",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_Influenza-2022-V2.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                169
            ],
            "related_campaigns": [
                168
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6482"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6482"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6482"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6482"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6482"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6464,
        "date": "2022-09-13T23:08:49",
        "date_gmt": "2022-09-13T23:08:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6464"
        },
        "modified": "2022-09-13T23:44:04",
        "modified_gmt": "2022-09-13T23:44:04",
        "slug": "flu-vaccine-campaign-2022-23",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/flu-vaccine-campaign-2022-23/",
        "title": {
            "rendered": "Flu Vaccine 2022 VCH Bulletin #1"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            169
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "VCH Influenza Vaccine Campaign 2022-2023: Bulletin #1",
            "resource-introduction": "",
            "resource-text": "The provincial influenza vaccination campaign is set to start in October. Influenza vaccine will be offered to BC residents at community COVID-19 booster clinics, pharmacies, as well as physician and nurse practitioner offices. Vancouver Coastal Health has released a bulletin more information about eligibility, ordering and distribution.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Bulletin",
            "resource-button_link": "http://www.vch.ca/Documents/PhysicianNPUpdate_InfluenzaVaccineCampaign_Bulletin1.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                169
            ],
            "related_campaigns": [
                168
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6464"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6464"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6464"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6464"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6464"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7130,
        "date": "2022-09-13T10:00:47",
        "date_gmt": "2022-09-13T10:00:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7130"
        },
        "modified": "2022-10-19T19:18:02",
        "modified_gmt": "2022-10-19T19:18:02",
        "slug": "security-technology-project-report-january-march-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/security-technology-project-report-january-march-2022/",
        "title": {
            "rendered": "Security &#038; Technology Project Report – January-March 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            125
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Infographic report on the quality, impact and suggestions.",
            "resource-introduction": "Infographic report on the quality, impact and suggestions.",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nDivision members were invited to participate in an assessment of their virtual or in-clinic security and technology. The assessment was intended to support onboarding to CareConnect and Pathways, two key elements of an information technology enabled Patient Medical Home. Each provincial portal requires adherence to protocols and standards.\r\n\r\nPhysicians completed the assessments which involved documenting the current state of their systems (virtual environments and in-office environments) through a phone interview or by completing a DTO/Vancouver Division needs assessment; meeting with a consultant who completed an on-site assessment and produced a scorecard that included recommendations; and completing an end- of-project survey.\r\n\r\nDownload the PDF infographic report on this page.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Report",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_SecurityTechnology-Project-Report-V4.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                70
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7130"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7130"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7130"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7130"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7130"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6446,
        "date": "2022-09-12T16:06:26",
        "date_gmt": "2022-09-12T16:06:26",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6446"
        },
        "modified": "2022-09-12T16:06:49",
        "modified_gmt": "2022-09-12T16:06:49",
        "slug": "ltci-physician-statement-of-interest",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/ltci-physician-statement-of-interest/",
        "title": {
            "rendered": "LTCI Physician Statement of Interest"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            180
        ],
        "resource_cat": [
            78
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2269,
            "post-excerpt": "A physician statement of interest for working in a long term care home.",
            "resource-introduction": "",
            "resource-text": "If you are interested in getting more information about working with a care home, or would like to note your interest for future long term care opportunities, please complete and return the <a href=\"https://vandivision.wpengine.com/wp-content/uploads/2021/03/LTCI-Physician-Statement-of-Interest-2.pdf\">LTCI Physician Statement of Interest</a> form.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Access the Form",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/09/LTCI-Physician-Statement-of-Interest-2.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                180
            ],
            "related_campaigns": [
                152,
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6446"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6446"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6446"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6446"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6446"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6261,
        "date": "2022-09-01T02:18:31",
        "date_gmt": "2022-09-01T02:18:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6261"
        },
        "modified": "2022-09-01T02:18:31",
        "modified_gmt": "2022-09-01T02:18:31",
        "slug": "fast-facts-august-31-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-august-31-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; August 31, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9052197",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174,
                74,
                129
            ],
            "related_campaigns": [],
            "related_events": [
                166,
                178,
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6261"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/178"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6261"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6261"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6261"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6261"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6257,
        "date": "2022-09-01T01:58:34",
        "date_gmt": "2022-09-01T01:58:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6257"
        },
        "modified": "2022-09-01T01:58:34",
        "modified_gmt": "2022-09-01T01:58:34",
        "slug": "funding-for-clinical-observerships",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/funding-for-clinical-observerships/",
        "title": {
            "rendered": "Funding for Clinical Observerships"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            175
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Douglas College has obtained funding to support their clients with obtaining Clinical Observerships.",
            "resource-introduction": "",
            "resource-text": "The Career Paths for Skilled Immigrants program aims to help skilled immigrants gain their license to practice and find work in their field of expertise. As part of Career Paths' goal to help IMGs gain exposure and strengthen their CaRMS applications, Douglas College has obtained funding to support their clients with obtaining Clinical Observerships.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Learn More",
            "resource-button_link": "https://mcusercontent.com/a11596f5ef77e17a39fbb52d3/files/46e0b6d5-6f89-27d4-7904-0281ee30b5b7/Career_Paths_Clinical_Observership_Funding.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                170
            ],
            "related_campaigns": [],
            "related_events": [
                156,
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6257"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6257"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6257"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6257"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6257"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6256,
        "date": "2022-09-01T01:56:03",
        "date_gmt": "2022-09-01T01:56:03",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6256"
        },
        "modified": "2022-10-01T09:07:18",
        "modified_gmt": "2022-10-01T09:07:18",
        "slug": "new-supports-for-family-doctors",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/new-supports-for-family-doctors/",
        "title": {
            "rendered": "New Supports for Family Doctors"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            170
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "This interim funding will work to keep your doors open while a new payment model is introduced and implemented.",
            "resource-introduction": "",
            "resource-text": "The Ministry of Health and Doctors of BC are providing $118 million in stabilization funding to family doctors throughout the province. This interim funding will work to keep your doors open while a new payment model is introduced and implemented.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Full Announcement",
            "resource-button_link": "https://news.gov.bc.ca/releases/2022HLTH0172-001282",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                170
            ],
            "related_campaigns": [],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6256"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6256"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6256"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6256"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6256"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6255,
        "date": "2022-09-01T01:48:57",
        "date_gmt": "2022-09-01T01:48:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6255"
        },
        "modified": "2022-09-01T01:50:31",
        "modified_gmt": "2022-09-01T01:50:31",
        "slug": "covid-19",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/covid-19/",
        "title": {
            "rendered": "COVID-19 Resource Collection"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            74,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Stay up-to-date on clinical guidelines, support for your practice, and patient resources.",
            "resource-introduction": "",
            "resource-text": "Stay up-to-date on clinical guidelines, support for your practice, and patient resources.\r\n\r\n<strong>Canada COVID-19 Epidemiology Update</strong> - <a href=\"https://health-infobase.canada.ca/covid-19/#_blank\" target=\"_blank\" rel=\"noopener\">Click Here</a>\r\n\r\n<strong>Provincial COVID-19 Data (and Vaccine) Dashboard</strong> - <a href=\"https://experience.arcgis.com/experience/a6f23959a8b14bfa989e3cda29297ded\" target=\"_blank\" rel=\"noopener\">Click Here</a>\r\n\r\n<strong>COVID-19 Vaccination Updates</strong> - <a href=\"https://www2.gov.bc.ca/gov/content/covid-19/vaccine/plan\" target=\"_blank\" rel=\"noopener\">BC Government</a> | <a href=\"http://www.bccdc.ca/health-info/diseases-conditions/covid-19/covid-19-vaccine\" target=\"_blank\" rel=\"noopener\">BCCDC</a>\r\n\r\n<strong>Clinical Practice Guide</strong> - <a href=\"http://www.bccdc.ca/Health-Professionals-Site/Documents/COVID-treatment/ClinicalPracticeGuide_Evusheld.pdf\" target=\"_blank\" rel=\"noopener\">The use of Evusheld</a>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                174
            ],
            "related_campaigns": [
                168,
                152
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6255"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6255"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6255"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6255"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6255"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6253,
        "date": "2022-09-01T01:45:09",
        "date_gmt": "2022-09-01T01:45:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6253"
        },
        "modified": "2022-09-01T01:50:16",
        "modified_gmt": "2022-09-01T01:50:16",
        "slug": "monkeypox",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/monkeypox/",
        "title": {
            "rendered": "Monkeypox Resource Collection"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            174
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Stay up-to-date on clinical guidelines and emerging information.",
            "resource-introduction": "Stay up-to-date on clinical guidelines and emerging information.",
            "resource-text": "<strong>Monkeypox Surveillance Report</strong> - <a href=\"http://www.bccdc.ca/Health-Info-Site/Documents/Monkeypox/Epidemiological_Summary/MPX_Epi_Summary_20220822.pdf\" target=\"_blank\" rel=\"noopener\">An epidemiological summary</a> released on August 22, 2022.\r\n\r\n<strong>Monkeypox General Update</strong> - Stay up to date on the province’s <a href=\"http://www.bccdc.ca/health-professionals/clinical-resources/monkeypox\" target=\"_blank\" rel=\"noopener\">active cases, immunization and treatment</a>.\r\n\r\n<strong>Vaccine Appointments - </strong><a href=\"https://vchcdimms.janeapp.com/\" target=\"_blank\" rel=\"noopener\">Appointments available</a> for the Imvamune vaccine.\r\n\r\n<strong>Clinical Resources</strong> - <a href=\"https://www.picnet.ca/wp-content/uploads/MonkeyIPACGuidanceHC_08Aug2022Final.pdf\" target=\"_blank\" rel=\"noopener\">Interim Infection Prevention and Control Guidance</a> for Monkeypox in Health Care Settings.\r\n\r\n&nbsp;\r\n\r\n<em>UPDATED August 31, 2022</em>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                74
            ],
            "related_campaigns": [
                168,
                152
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6253"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6253"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6253"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6253"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6253"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6151,
        "date": "2022-08-30T07:22:24",
        "date_gmt": "2022-08-30T07:22:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6151"
        },
        "modified": "2022-08-30T07:22:24",
        "modified_gmt": "2022-08-30T07:22:24",
        "slug": "fast-facts-august-16-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-august-16-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; August 16, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9048589",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                165,
                168
            ],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6151"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6151"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6151"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6151"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6151"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6147,
        "date": "2022-08-30T07:19:51",
        "date_gmt": "2022-08-30T07:19:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6147"
        },
        "modified": "2022-08-30T07:19:51",
        "modified_gmt": "2022-08-30T07:19:51",
        "slug": "fast-facts-august-3-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-august-3-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; August 3, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9045633",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                168,
                165
            ],
            "related_events": [
                171
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6147"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6147"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6147"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6147"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6147"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6035,
        "date": "2022-08-29T22:25:08",
        "date_gmt": "2022-08-29T22:25:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6035"
        },
        "modified": "2022-10-04T20:20:48",
        "modified_gmt": "2022-10-04T20:20:48",
        "slug": "primary-care-crisis-event-resources",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/primary-care-crisis-event-resources/",
        "title": {
            "rendered": "Primary Care Crisis Event: Overview and FAQ"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            170,
            125
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "Learn about the answers to FAQs we heard from members at our Primary Care Crisis event.",
            "resource-introduction": "",
            "resource-text": "On July 21st, 2022, the Vancouver Divisions of Family Practice hosted an event to allow members to gather in person and online to hear from partner organizations on what they are doing to address the current primary care crisis in Vancouver. Leaders from the Doctors of BC, BC Family Doctors, The College of BC Family Doctors and the General Practice Services Committee attended to share their ongoing plans to support family doctors in the province.\r\n\r\n60 Members attended the in-person event at the Arbutus Club and over 120 members joined in online to hear from the partners and bring their questions forward.\r\n\r\nBelow you will find useful information and links from the event.\r\n<h2>Your Partners</h2>\r\n&nbsp;\r\n<table>\r\n<tbody>\r\n<tr>\r\n<th>Partner</th>\r\n<th>Representative(s)</th>\r\n<th>Partner Mission</th>\r\n<th>Partner Advocacy</th>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://www.doctorsofbc.ca/about-us\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">Doctors of BC</span></a></td>\r\n<td>Dr. Brenda Hefford – Vice President</td>\r\n<td>To promote a social, economic, and political climate in which members can provide British Columbians with the highest standard of health care, while achieving maximum professional satisfaction and fair economic reward.</td>\r\n<td><a href=\"https://www.doctorsofbc.ca/advocacy-policy/advocacy/areas-focus/advocating-primary-care\" target=\"_blank\" rel=\"noopener\">Advocating for Primary Care</a> &amp; <a href=\"https://www.doctorsofbc.ca/presidents-letter/primary-care-consultation-update\" target=\"_blank\" rel=\"noopener\">President’s Letter – August 8<sup>th</sup> 2022</a></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://bcfamilydocs.ca/about-us/\" target=\"_blank\" rel=\"noopener\">BC Family Doctors</a></td>\r\n<td>Dr. Renee Fernandez – Executive Director</td>\r\n<td>BC Family Doctors advocates for the economic and professional well-being of family doctors in BC. Our purpose is to build an environment where family doctors thrive.</td>\r\n<td><a href=\"https://bcfamilydocs.ca/wp-content/uploads/2022/04/BCFD_Toolkit_FINAL.pdf\" target=\"_blank\" rel=\"noopener\">Speak out for Family Medicine Toolkit</a> &amp; <a href=\"https://bcfamilydocs.ca/everyone-deserves-a-family-doctor/\" target=\"_blank\" rel=\"noopener\">Social Media Campaign</a></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://gpscbc.ca/what-we-do\" target=\"_blank\" rel=\"noopener\">General Practice Services Committee</a></td>\r\n<td>Dr. Sari Cooper – Co-Chair</td>\r\n<td>Strengthen longitudinal family practice as the foundation of an integrated system of care.</td>\r\n<td></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://bccfp.bc.ca/about-us/\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">BC College of Family Physicians</span></a></td>\r\n<td><span data-contrast=\"auto\">Dr. David May – President </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span><span data-contrast=\"auto\">Toby Achtman – Executive Director</span></td>\r\n<td>Leading family medicine to improve the health of all people in Canada—by setting standards for education, certifying and supporting family physicians, championing advocacy and research, and honouring the patient-physician relationship as being core to the profession.</td>\r\n<td><a href=\"https://bccfp.bc.ca/wp-content/uploads/2022/04/AdvocacyToolKit_FINAL.pdf\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">Advocacy Tool Kit</span></a><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335551550&quot;:2,&quot;335551620&quot;:2,&quot;335559740&quot;:259}\"> </span></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://health.ubc.ca/\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">University of British Columbia</span></a><span data-contrast=\"auto\"> </span></td>\r\n<td><span data-contrast=\"none\">Dr. Christie Newton – Associate Head Education and Engagement, Department of Family Practice /Associate Vice President Health </span><i><span data-contrast=\"none\">pro tem</span></i><span data-contrast=\"none\"> </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span></td>\r\n<td><span data-contrast=\"auto\">Connecting people, ideas, and actions to advance health outcomes, equity, and systems</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span></td>\r\n<td></td>\r\n</tr>\r\n</tbody>\r\n</table>\r\n&nbsp;\r\n\r\n<span class=\"TextRun SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW99874672 BCX9\">Additional </span><span class=\"NormalTextRun SCXW99874672 BCX9\">ways to get involved</span><span class=\"NormalTextRun SCXW99874672 BCX9\">:</span></span>\r\n<ul>\r\n \t<li><a class=\"Hyperlink SCXW99874672 BCX9\" href=\"https://bchealthcarematters.com/\" target=\"_blank\" rel=\"noreferrer noopener\"><span class=\"TextRun Underlined SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW99874672 BCX9\" data-ccp-charstyle=\"Hyperlink\">BC Health Care Matters</span></span></a></li>\r\n \t<li><a href=\"https://bccfp.bc.ca/myfamilydoctorcares/\" target=\"_blank\" rel=\"noopener\"><span class=\"TextRun SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW99874672 BCX9\">My Family Doctor Cares</span></span></a></li>\r\n \t<li><a class=\"Hyperlink SCXW99874672 BCX9\" href=\"https://thetyee.ca/News/2022/08/12/The-Vancouver-Plan-Seven-Minutes/?utm_source=daily&amp;utm_medium=email&amp;utm_campaign=120822\" target=\"_blank\" rel=\"noreferrer noopener\"><span class=\"TextRun Underlined SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW99874672 BCX9\" data-ccp-charstyle=\"Hyperlink\">The Vancouver Plan, in Seven Minutes</span></span></a></li>\r\n</ul>\r\n<img class=\"alignnone wp-image-6036 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2022/08/HopesForTheFuture.jpeg\" alt=\"\" width=\"720\" height=\"405\" />\r\n<h2>FAQ</h2>\r\nThe following questions were asked by our in-person and online members during the event. Our partners have provided the following answers as applicable.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "What is the future of the fee for service (FFS) payment model?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>What do you think lies ahead for the future of the fee for service payment model? Is FFS being slowly phased out in favour of alternative payment models? Is FFS being negotiated in the PMA with complexity and time modifiers - also gender inequalities?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>BC Family Doctors</strong></p>\r\n\r\n<p>There is no one good answer on how to pay a FP. All the needs are different because everyone has different panel types. The idea of a single model is not going to work. We need a menu of good options. FFS is not a problem but it manifests in BC as a problem – there are jurisdictions in the country where FFS work and these are ones where they promote relationship and the role it has in high quality patient care. We need to modernize it to not be a burden to bill. We know everyone doesn’t want to be FFS so the question is whether we can create several good models all with an increased funding basket.</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Negotiations being done based on fees and they are making something to see what benefits family medicine. They have reduced the fees for corporations. The College has also collected data on all the remuneration model and the evidence is strong that one size doesn’t fit all. Point towards a blended model</p>"
                },
                {
                    "resource-acc-item-title": "Why are practices responsible for the costs of EMRs?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>EMRs are tools that we use to help the patients and using them properly will affect the patient care. The prices are going up significantly and are hard to afford. Why does the government not pay for the EMR?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>We agree that there needs to be simpler and fewer EMRs that talk to each other. Each individual practice having to negotiate data transfers is unacceptable. Conversations have happened.</p>"
                },
                {
                    "resource-acc-item-title": "Why is so much of the funding for primary care in BC used for administration rather than patient care?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>I do not think the BC system is poorly funded. Where has the money gone? There are a lot of administrative wages. Every time we complain about anything, a pilot project is made that has already been done and no one is checking. How do we move the funding to patient care vs. an administrative person that doesn't get back to us. Why do we have so many administrative people in your system?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The health authorities shouldn’t be where the funding goes. The government has agreed to take a look at that. There are ways the health authorities work that add to the burdens rather than supporting the systems of primary care. We need to look at what the health authorities role in primary care is. They should be supporting – not adding to the burdens.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We have been working with Divisions and other organizations to run engagement sessions in hopes of listening to the voice of the physicians. We have heard that PCN is a burden when it should be a benefit. GPSC's role is to work on this. We are hopeful that we can make change in where the power lies in the community and the design of the system in the near future.</p>"
                },
                {
                    "resource-acc-item-title": "There are some concerns with the new contracts (new to practice and group). Instead, could the fee-for-service payment model be improved to include time spent doing paperwork?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>I would love to do community care but I do hospital now. A lot of people are scared to enter a contract because there are a number of requirements, such as numbers in your patient panel, etc. Are people aware of this issue? Would there be FFS but include paperwork? I am asking about both contracts (NTP and group).</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Even within FFS, we aren’t pure FFS. Some of the fees like the CLFP is not an actual fee. You do something, you get paid for it. Sometimes we get caught in the terminology.\r\n– Contracts – within family physician world, NTP and group contracts. Have been developed, have pros and have cons. Still not valued at the level they should be valued. They are complex and there are a lot of pages to them. There are restrictions on who can access them. However, a lot of the doctors on the contracts feel there is improvement.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>Worries about the debate re: contract and FFS. FP doing longitudinal care are not paid adequately but because of compensation. We need to compensate giving good quality care.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We are looking at different ways to measure attachment while minimizing burden.</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>The College is looking at panel sizes and capitation models. The patient requirements haven’t factored complexity.</p>"
                },
                {
                    "resource-acc-item-title": "Do specialists agree that support for family doctors is needed?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>Where are the specialists as to engaging with the idea that more funding needs to go to family medicine?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Within the engagement work, we have had a lot of feedback from specialists as well. They agree that support for family doctors is needed. Inequity in the specialist world exists as well and we won’t fix it all tomorrow, but shows another reason why the parallel track is needed. Rise of staffing, overhead, etc. they are also having some of these challenges.</p>"
                },
                {
                    "resource-acc-item-title": "What is happening to alleviate the large overhead costs for family practices in Vancouver?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>Robust amount for overhead in family medicine - is this something that DoBC is working towards?</p>\r\n\r\n<p>Response:<p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>We are. It is one of the areas that shows flaws in the system. The MOH is sets their own bars with what they are offering their new to practice doctors. We have something that can be pushed on.</p>"
                },
                {
                    "resource-acc-item-title": "Are there any updates with how the PCNs are governed?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>Role of health authorities in PCN. We know the struggles. In this space, PCNs were designed to support family medicine. How can we have PCN reform if there's no flexibility in the governance?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The intent behind PCN governance was to give more of a voice to the practitioners but the opposite has happened. Let’s say we get PCN governance through this. The PCN still has from the funding from the government where certain decisions are made. That shows there is an issue and a problem. The GPSC will take leadership and the Divisions need to be a part of the leadership for representation.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>The PCN is PMH – PCN is not a PMH. The two are not the same. We need to do a lot of work to get our clinics to be PMHs. PCN is a building block for PMH. They are linked but not the same thing.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>This is where GPSC fits in well. We hear this from every Division. Almost all Division have this problem. All the PCN pieces need to be coordinated and integrated where patients have agency.</p>"
                },
                {
                    "resource-acc-item-title": "Will there be more compensation for physicians to teach family practice?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>As a UBC instructor, we spend a half day with Med students in LTC and we only get pair $90 for a session from UBC. Even the hourly rate has not been updated for years and is much less than sessional pay. Why would anyone choose to teach - what it takes out of practice and with the current compensation? Poor pay, less offices, less family physicians willing to take learners, so who is training new family physicians? Who would want to be an underpaid, overworked small business owner?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>There is currently a pilot project funded by the Ministry of Health aimed at improving practice based teaching for family practice residents. Preceptors involved in the project receive 0.1FTE (approx. $17,500/year) to take on 2 family practice residents (each resident in their clinic for 4 months) It is a 3 year project and if we demonstrate improved recruitment and retention to these teaching clinics the MOH may fund a phase two to expand to additional clinics. UBC also needs to recognize the value of clinical education. The Faculty of Medicine is underfunded compared to other faculties of the University. There is ongoing advocacy for improved remuneration for clinical education. That noted there is poor understanding of the different costs of community based practice vs. facility based practice (ex. ambulatory specialty clinics). There is a growing understanding that in order to sustain clinical education within the community to ensure grads are work force ready, we need to transform the system to better support the clinical learning environment. We need to support the teachers.</p>\r\n\r\n<p>We already know that 90% of students have no intent of working primary care. This is primarily because they don’t have the team support.</p>"
                },
                {
                    "resource-acc-item-title": "Can business training be added to the FP residency program?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>UBC - can you have a community doctor do a business class? It's difficult to negotiate with doctors that do not understand overhead. </p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>There are significant challenges with adding to the residency curriculum. There are so many things – like business management, point of care ultrasound, dermoscopy, cultural safety and humility, virtual care, post and long covid care, complex care, health system leadership, …The issue has become what can be removed to allow for things to be added? The other issue is that in order to preserve mental health and work life balance, residents have fewer clinical education days per year (ie; on average a resident will work 176 days per year) To address this the CFPC has proposed to extend residency. The key will be to create a very different – ie; community based, service oriented, extension to better support a transition to practice.</p>"
                },
                {
                    "resource-acc-item-title": "Is there a way that partners can help with MOA retention?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>Can the ministry provide a MOA teaching course? I cannot keep up after I train them and they get a higher paying job.</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The value of MOA has come up over and over again. The need to support the MOA, pay the MOA etc. has come out very strongly in the engagement.</p>\r\n"
                },
                {
                    "resource-acc-item-title": "What is happening around group contracts, pensions and benefits for family practice?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>It took me so long to get on a PCN group contract and I asked for help repeatedly and was not given any. There are options in the contract at the start but they were made no longer options from the MOH after I got on it. The MOH opposes our rules. Doctors of BC was nowhere to be found to help us. We only went on a contract to save our practice. Who is handling the negotiations at Doctors of BC? We don't have pensions or benefits and it is so demoralizing. Months have gone by and we need to rely on the media. Where are the negotiations? I can make $300,000 without overhead working at the hospital vs. $90,000 + 40% overhead. We should be telling the young grads this instead of trying to get them into a contract. This system needs to be more transparent. It can't take years to figure this out.</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>One of the things communicated today was that we need answers for the Fall. There are too many flaws in the current system. The funder needs to change the way things are done.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We need to change the infrastructure – community FPs carry the weight. Admin burdens are different as we are “relationship professionals” – it is a service driven and mission driven profession.We need change to happen this calendar year. We have less than 6 months to figure this out. We are going to fight like hell.</p>"
                },
                {
                    "resource-acc-item-title": "Will family practitioners get paid more, like in the UK?",
                    "resource-acc-item-content": "<p>Question:</p>\r\n<p>In the UK, FPs are paid higher than any other specialty. If we truly value primary care, we as a society should put our money where our mouth is and address the disparity/inequity in remuneration.</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The reality is that family medicine is the least compensated specialty that you can go to. All of you toiling in your practices, can likely make more doing other things. Yet, it’s the bedrock of the system. I don’t think we’ll get to the point where we are paid the most, but at the bare minimum, we should be paid equitabilty to other specialties. This is what Docs of BC has advocated for.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>There needs to be huge advance for doctors in BC. Community FPs needs to be paid at a higher rate than a hospitalists for example. Equitable is a good step forward but we need to do more than that!</p>"
                }
            ],
            "related_resources": [
                163
            ],
            "related_campaigns": [],
            "related_events": [
                172
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6035"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6035"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6035"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6035"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6035"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 6031,
        "date": "2022-08-29T17:05:16",
        "date_gmt": "2022-08-29T17:05:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=6031"
        },
        "modified": "2022-09-13T23:39:08",
        "modified_gmt": "2022-09-13T23:39:08",
        "slug": "flu-vaccine-2021-findings",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/flu-vaccine-2021-findings/",
        "title": {
            "rendered": "Flu Vaccine Delivery Program Report 2021"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            169,
            125
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "Vancouver Division findings from the 2021/22 Flu Vaccine Delivery Program.",
            "resource-introduction": "Flu Vaccine Delivery Program 2021/22",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThe Vancouver Division of Family Practice partnered with Vancouver Costal Health to provide flu vaccines to Vancouver clinics. The program was promoted between September 2021 and January 2022. Clinics could select to have vaccines delivered directly to their offices or to pick them up from their local Community Health Clinic. Sixty-nine physicians completed the program evaluation survey which represents approximately 35% of participating clinics. Among survey respondents, 47% had their vaccines delivered, 37% picked up their vaccines, and 16% took advantage of both options. The cost per delivery was $33.90.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Report",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/08/VDFP_Flu-Vaccine-Delivery-Program-Report.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                169,
                125
            ],
            "related_campaigns": [
                168
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/6031"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6031"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6031"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6031"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6031"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5871,
        "date": "2022-08-03T20:44:14",
        "date_gmt": "2022-08-03T20:44:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5871"
        },
        "modified": "2023-09-18T21:47:24",
        "modified_gmt": "2023-09-18T21:47:24",
        "slug": "2023-membership-vote",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/2023-membership-vote/",
        "title": {
            "rendered": "2023 Membership Vote Details"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            167,
            128
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Information on timelines and the nomination process.",
            "resource-introduction": "",
            "resource-text": "<h5>Introduction</h5>\r\nThere are two parts to the membership vote this year, with eligible members voting via online ballot between September 28 and October 12. They two parts of the this year's vote are:\r\n<ol>\r\n \t<li style=\"list-style-type: none;\">\r\n<ol>\r\n \t<li><strong>The 2023 Board of Directors Election</strong> - This year there are six (6) board of director positions open for election: five (5) FP Member Director positions and one (1) Resident Member Director position. <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">Click here</a> for the nominations form. Nominations period is Thu, August 17 to Monday, September 11. <strong>UPDATE</strong> - Nominations have now closed. Because there are more available board positions than candidates, there will not be a board of directors election.</li>\r\n \t<li><strong>Bylaw Changes</strong> - The membership will be asked to consider two bylaw changes as part of this year's membership vote. One is to add clarity on the appointment of Directors during vacancies and the other is to create a Past Chair Role.</li>\r\n</ol>\r\n</li>\r\n</ol>\r\n&nbsp;\r\n<h5>Choosing Between Board Participation Versus Project Participation</h5>\r\nIn compliance with the BC Societies Act, if a member is elected to the board of directors of the Vancouver Division, they are ineligible to engage and be remunerated for any activities at the day-to-day operations and programming level of the Division. Meaning a member must choose between being a board member OR participating in committees, working groups, programs or projects. A member cannot be remunerated for both. For a detailed chart on the difference, please <a href=\"https://vdofp.sharepoint.com/:b:/g/EXkPBaTRcOBJkWtWPu5OlO0B31p-nOB6LwWANAVWSNtmBQ?e=Doydyd\" target=\"_blank\" rel=\"noopener\">click here.</a>\r\n\r\n<strong><em>Are there any exceptions? </em></strong>Yes, there is one exception, which is for members interested in serving on the board who are also officially a part of the Vancouver Division’s Long-Term Care Initiative program.\r\n<h5>Additional Information</h5>\r\nPlease login to see additional information on the above along with details on eligibility, timelines, and the proposed bylaw changes. Election results will be announced and ratified at the <a href=\"https://van-division.yarko.dev/initiative/annual-general-meeting-2023/\">Annual General Meeting</a>.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "What are the important dates?",
                    "resource-acc-item-content": "<b>Nomination Period:</b> Thursday, August 17th, 2023 at 12:00:00 am PT – Monday, September 11th, 2023 at 11:59:59 pm PT. You can find the nominations form <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">here</a>.<br>\r\n<br>\r\n<b>Voting Period:</b> Thursday, September 28th 2023 at 12:00:00 am PT – Thursday, October 12th, 2023 at 11:59:59 pm PT.\r\n"
                },
                {
                    "resource-acc-item-title": "How do I vote?",
                    "resource-acc-item-content": "Voting for both the board elections and bylaw changes will take place through an electronic voting process facilitated by <a href=\"http://www.simplyvoting.com/\" target=\"_blank\" rel=\"noopener\">www.simplyvoting.com</a>. Members eligible to vote will be sent an email on September 28th with a unique link to access their online ballot. Members will be required to cast votes for the full number of vacancies on the board. The voting period is between Thursday, September 28th at 12:00am PT and Thursday, October 12th at 11:59pm PT. Election results will be announced and ratified at the <a href=\"https://VancouverDivisionAGM.eventbrite.ca/?aff=Website\" target=\"_blank\" rel=\"noopener\">Annual General Meeting</a>, taking place on the evening of Thursday, October 19th, 2023."
                },
                {
                    "resource-acc-item-title": "Who is eligible to run for a board position?",
                    "resource-acc-item-content": "Candidates must be a general member in good standing with the Division and the College of Family Physicians to be on the Board of Directors.<br><br>\r\nActively Practicing and Resident members are eligible for election to the board and to participate in the membership vote. Retired members, as associate members, are not eligible to participate.\r\n"
                },
                {
                    "resource-acc-item-title": "What board positions are available this year?",
                    "resource-acc-item-content": "<b>Board Composition:</b> The board is comprised of 8 members – seven (7) FP Member Directors and one (1) Resident Member Director physician.<br><br>\r\n\r\n<b>Positions Up for Election:</b> For this year’s election, there are six (6) board of director positions open for election – five (5) FP Member Director positions and one (1) Resident Member Director position.<br><br>\r\n\r\n<i>Please note: All applications received will undergo an initial review by the Vancouver Division’s Nominations Committee.</i>"
                },
                {
                    "resource-acc-item-title": "If I have a board member, can I still do project work of the Division and be remunerated for it?",
                    "resource-acc-item-content": "In accordance with the BC Societies Act, the Division constitution and bylaws (when updated in 2016) provide clear policies and procedures that govern the role of a board member.<br><br>\r\n\r\n<b>How is governance leadership defined in the current bylaws and constitution?</b><br><br>\r\n\r\nAs described in the BC Societies Act there must be a separation between the people who provide leadership for the overall governance of the organization and the people who provide leadership by actively engaging in the work of the Division at the committee or program level.<br><br>\r\n\r\n<b>What does that mean if you are considering being on the Board of Directors?</b><br><br>\r\n\r\nIf a member is elected to the board of directors of the Vancouver Division, they are ineligible to engage and be remunerated for any activities at the day-to-day operations and programming level of the Division. Meaning a member must choose between being a board member OR participating in committees, working group, programs or projects. A member cannot be remunerated for both.<br><br>\r\n\r\nFor a detailed chart on the difference, please <a href=\"https://vdofp.sharepoint.com/:b:/g/EXkPBaTRcOBJkWtWPu5OlO0B31p-nOB6LwWANAVWSNtmBQ?e=Doydyd\" target=\"_blank\" rel=\"noopener\">click here.</a><br><br>\r\n\r\n<b>Are there any exceptions?</b><br><br>\r\n\r\nThere is one exception, which is for members interested in serving on the board who are also officially a part of the Vancouver Division’s Long-Term Care Initiative program."
                },
                {
                    "resource-acc-item-title": "How do I put myself forward as a candidate for the board?",
                    "resource-acc-item-content": "Find the nominations form <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">here</a>\r\n"
                },
                {
                    "resource-acc-item-title": "Is there a role description for the board of directors?",
                    "resource-acc-item-content": "Yes, we have created a short role description that explains the role of the board. <a href=\"https://vdofp.sharepoint.com/:b:/g/ERdIe4vj6cxHrD8WMOA3pR0B58G3b8B9d7tosNtSwdWYWg?e=fMfE1V\" target=\"_blank\" rel=\"noopener\">Click here</a> to read it. If you are considering a board position, we have also compiled some <a href=\"https://vdofp.sharepoint.com/:b:/g/Ef-MsIFWrixJoRKqXPPbNtUB0tNRQe0pi8aqiw7etKVgng?e=eNgNBh\" target=\"_blank\" rel=\"noopener\">key points for you to consider</a>. "
                },
                {
                    "resource-acc-item-title": "What are the bylaw amendment being proposed this year?",
                    "resource-acc-item-content": "The Division membership will be asked to consider and vote on two changes to the organization's bylaws. Voting on the bylaw changes will done at the same time and same ballot as the board election.<br><br>\r\n\r\n<b>Proposed Bylaw Change 1: Appointment of Directors</b><br><br>\r\n\r\n<u>Context</u><br>\r\nThe following proposed change to the Bylaws enables the Board to appoint Directors to fill Board vacancies (for a one-year term) in the event that the number of available seats exceeds the number of members who run, in a given year. <br><br>\r\n\r\nCurrently, the Board can only appoint a new Director if a sitting Director exits their seat early. Should seats remain unfilled after election, the Division is at risk of having fewer Directors than required for the Board. An appointed seat would re-open for election in the following year. <br><br>\r\n\r\n<u>Motion</u><br>\r\nMotion – That the wording of Section 7.9 be amended as follows: <b><i>If a Director ceases to hold office before the expiry of his or her term, or there are vacant seats after the election pursuant to 5.1(f), the Board, by Board Resolution, may appoint a Member qualified in accordance with section 7.5. to fill the resulting vacancy. </b></i><br><br>\r\n\r\n<a href=\"https://vdofp.sharepoint.com/:b:/g/EZgliEU8T1tLlcDRg9JzT2MBQUQOz2uTQj0mRaupyVVCXg?e=kdMBdb\" target=\"_blank\" rel=\"noopener\">Click here</a> for a full description.<br><br>\r\n\r\n<b>Proposed Bylaw Change 2: Creation of a Past Chair Role</b><br><br>\r\n\r\n<u>Context</u><br>\r\nThe following proposed change to the Bylaws creates the position of Past Chair, enabling a Chair who has completed six consecutive years on the Board to sit on the Board for a further year in the role of Past Chair, to support continuity and the transfer of corporate memory on the Board and Executive.<br><br>\r\n\r\nThe role of the Past Chair and the compensation would be in line with others on the Executive Committee and reflected in the Division Policy.<br><br>\r\n\r\nFurther, as an administrative change, section 7.7 would also be amended to remove “provided that such Member is still eligible during that period to be appointed to fill a vacancy in the Board under Bylaw 7.9 hereof”, as it conflates the ability to be elected after leaving the Board for at least one year with the appointment process.<br><br>\r\n\r\n<u>Motion</u><br>\r\nMotion – That the wording of Section 7.7 be amended as follows: <b><i>There will be a limit of three (3) consecutive terms, after which a <u>Member</u> is not eligible for re-election as a Director until they have ceased to be a Director for at least one (1) year.  However, if the Chair completes three (3) consecutive Board terms, they may be appointed for an additional one-year term to serve in the capacity of Past-Chair.</b></i><br><br>\r\n\r\n<a href=\"https://vdofp.sharepoint.com/:b:/g/ERZjCMj06TJKg1h5OPH-eNIBx556-ZlHmrs2vUxUfu3AXg?e=j1AxPw\" target=\"_blank\" rel=\"noopener\">Click here</a> for a full description.\r\n"
                }
            ],
            "related_resources": [
                167
            ],
            "related_campaigns": [
                179
            ],
            "related_events": [
                166
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5871"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5871"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5871"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5871"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5871"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5736,
        "date": "2022-08-02T22:51:57",
        "date_gmt": "2022-08-02T22:51:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5736"
        },
        "modified": "2022-12-13T10:06:12",
        "modified_gmt": "2022-12-13T10:06:12",
        "slug": "community-programs-workshops-courses",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/community-programs-workshops-courses/",
        "title": {
            "rendered": "Community Programs, Workshops &#038; Courses"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            129
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Programs, courses and workshops for Physician Wellness in Vancouver.",
            "resource-introduction": "",
            "resource-text": "<a href=\"https://ubccpd.ca/collaborate/portfolios/cbt-skills#:~:text=The%20Cognitive%20Behavioural%20Therapy%20(CBT,%2Dbased%20self%2Dmanagement%20strategies\" target=\"_blank\" rel=\"noopener\">CBT Skills Physician Wellness Group Training</a> – Physician-only CBT Skills group offered in partnership by the CBT Skills Group Society and UBC Continuing Professional Development and the Shared Care Committee.\r\n\r\n<a href=\"https://cpa.ca/corona-virus/psychservices/\">Psychologists Giving Back to Front Line Service Providers</a> – Registered psychology practitioners are donating services\r\n\r\n<a href=\"https://oreo2.itracmediav4.com/v?uuid=546326c0-f1e5-49e2-9d63-90b64c239f5c\">YMCA’s Y Mind – Free, Online Mental Wellness Program for Youth &amp; Adults</a>\r\n\r\n<a href=\"https://www.coursera.org/learn/manage-health-covid-19\">Mind Control: Managing Your Mental Health During COVID-19 – Online Course</a> – University of Toronto\r\n\r\n<a href=\"https://online.bouncebackonline.ca/\">BounceBack Online Course</a> – CBT Modules – CMHA and PHSA",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                129
            ],
            "related_campaigns": [
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5736"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5736"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5736"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5736"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5736"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5730,
        "date": "2022-08-02T22:21:01",
        "date_gmt": "2022-08-02T22:21:01",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5730"
        },
        "modified": "2022-09-08T16:06:40",
        "modified_gmt": "2022-09-08T16:06:40",
        "slug": "pcn-family-physician-service-contracts",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/pcn-family-physician-service-contracts/",
        "title": {
            "rendered": "PCN FP Service Contracts"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            155,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Information on how we can support salaried service contract funded positions for family physicians.",
            "resource-introduction": "",
            "resource-text": "Welcome to Vancouver Division’s opportunities for family physician service contract  – access information on how we can support salaried service contract funded positions for family physicians as part of Vancouver’s Primary Care Network development. The Ministry of Health has announced a new initiative to help recruit family physicians in BC. They have created salaried service contract funded positions for family physicians interested in starting patient panels, who haven’t already had a permanent practice.  Vancouver has been allocated a pre-determined number of positions for full service family practice and we are currently identifying interested clinics and eligible candidates.\r\n\r\nThe salaried service contract positions for Vancouver are limited in number, and will be filled as mutual matches are made. The process will be the same as the current process for recruiting locums and permanent physicians to clinics through the Division. When clinics are looking for help recruiting a physician, they can reach out to our team. We post the opportunity on a variety of different platforms on their behalf, and circulate the opportunity to eligible physicians who might be a good fit. Based on physician preferences, we introduce clinics and physicians to determine if there is a mutual fit to explore. With support, physicians and clinics can together decide to move forward.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5730"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5730"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5730"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5730"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5730"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5729,
        "date": "2022-08-02T22:19:10",
        "date_gmt": "2022-08-02T22:19:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5729"
        },
        "modified": "2022-09-08T16:06:53",
        "modified_gmt": "2022-09-08T16:06:53",
        "slug": "pcn-nurse-practitioner-service-contracts",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/pcn-nurse-practitioner-service-contracts/",
        "title": {
            "rendered": "PCN NP Service Contracts"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Information on how we can support salaried service contract funded positions for Nurse Practitioners.",
            "resource-introduction": "",
            "resource-text": "Welcome to Vancouver Division’s opportunities for Nurse Practitioner service contracts – access information on how we can support salaried service contract funded positions for Nurse Practitioners as part of Vancouver’s Primary Care Network development. The Ministry of Health has announced a new initiative to help improve patient attachment in BC. They have created Nurse Practitioner (NP) funded positions for NPs interested in starting patient panels within Patient Medical Homes (PMH). Vancouver has been allocated a pre-determined number of positions for NPs in practice and we are currently identifying interested clinics.\r\n\r\nThe NP positions allocated for Vancouver are limited and will be filled as mutual matches are made. The process will be the same as the current process for recruiting physicians to clinics through the Division. When clinics are looking for help recruiting an NP, they can reach out to our team. We will post the opportunity on Health Match BC on their behalf, and circulate the opportunity to NPs who might be a good fit. Based on candidate preferences, we introduce clinics and NPs to determine if there is a fit to explore. With support, NPs and clinics can identify if a clinic-practitioner agreement is the best way to move forward.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5729"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5729"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5729"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5729"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5729"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5633,
        "date": "2022-08-02T20:50:51",
        "date_gmt": "2022-08-02T20:50:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5633"
        },
        "modified": "2022-08-02T20:50:51",
        "modified_gmt": "2022-08-02T20:50:51",
        "slug": "interprofessional-teams-ipt-one-pager",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/interprofessional-teams-ipt-one-pager/",
        "title": {
            "rendered": "Interprofessional Teams (IPT) One-Pager"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            153
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Vancouver Division of Family Practice and Vancouver Coastal Health (VCH) have partnered to implement IPTs.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nVancouver Division of Family Practice and Vancouver Coastal Health (VCH) have partnered to implement IPTs as part of the Primary Care Network (PCN) in your region.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/08/IPT_Poster-V6.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5633"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5633"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5633"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5633"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5633"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5624,
        "date": "2022-08-02T20:00:57",
        "date_gmt": "2022-08-02T20:00:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5624"
        },
        "modified": "2022-08-02T20:00:57",
        "modified_gmt": "2022-08-02T20:00:57",
        "slug": "primary-care-clinical-pharmacist-pccp-package",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/primary-care-clinical-pharmacist-pccp-package/",
        "title": {
            "rendered": "Primary Care Clinical Pharmacist (PCCP) Package"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            153
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "How a primary care clinic may choose to work with a PCCP & the processes involved in working in a team-based care environment",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 2\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThe Primary Care Clinical Pharmacist (PCCP) Package is intended to provide an overview of how a primary care clinic may choose to work with a PCCP, and the processes involved in working in a team-based care environment with a PCCP. The documents included intend to guide primary care providers to find the best way their clinic can collaborate with a PCCP to best support the needs of their patient population.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/08/Clinical-Pharmacist-Package-v7-2.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                153
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5624"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5624"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5624"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5624"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5624"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5622,
        "date": "2022-08-02T19:43:06",
        "date_gmt": "2022-08-02T19:43:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5622"
        },
        "modified": "2023-01-11T23:40:23",
        "modified_gmt": "2023-01-11T23:40:23",
        "slug": "existing-and-new-employee-contract-templates",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/existing-and-new-employee-contract-templates/",
        "title": {
            "rendered": "Existing and New Employee Contract Templates"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            151
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Legal contract templates serving clinic owners for new and existing clinic employees such as MOAs, and office managers.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nLegal contract templates serving clinic owners with a base document upon which they can build their own clinic contracts for new and existing clinic employees such as MOAs, and office managers.\r\n\r\nTo access these templates, please use this link to <a title=\"Request access to Existing and New Employee Contract Templates\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Existing%20And%20New%20Employee%20Contract%20Templates%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                150,
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5622"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5622"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5622"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5622"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5622"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5621,
        "date": "2022-08-02T19:42:02",
        "date_gmt": "2022-08-02T19:42:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5621"
        },
        "modified": "2023-01-11T23:41:28",
        "modified_gmt": "2023-01-11T23:41:28",
        "slug": "associate-and-locum-contract-templates",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/associate-and-locum-contract-templates/",
        "title": {
            "rendered": "Associate and Locum Contract Templates"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            151
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Legal contract templates serving clinic owners for physician associates and locums.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nLegal contract templates serving clinic owners with a base document upon which they can build their own clinic contracts for physician associates and locums.\r\n\r\nTo access these templates, please use this link to <a title=\"Request access to Associate and Locum Contract Templates\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Associate%20and%20Locum%20Contract%20Templates%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5621"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5621"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5621"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5621"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5621"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5620,
        "date": "2022-08-02T19:40:00",
        "date_gmt": "2022-08-02T19:40:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5620"
        },
        "modified": "2023-01-11T23:43:46",
        "modified_gmt": "2023-01-11T23:43:46",
        "slug": "patient-record-stewardship-legal-advisory-guide",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/patient-record-stewardship-legal-advisory-guide/",
        "title": {
            "rendered": "Patient Record Stewardship Legal Advisory Guide"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            151
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "An advisory guide to help inform clinics and clinic owners on the various acceptable paths towards patient record stewardship",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nAn advisory guide to help inform clinics and clinic owners on the various acceptable paths towards patient record stewardship as outlined by the CPSBC.\r\n\r\nTo access this guide, please use this link to <a title=\"Request access to Patient Record Stewardship Legal Advisory Guide\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Patient%20Record%20Stewardship%20Legal%20Advisory%20Guide%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                150,
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5620"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5620"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5620"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5620"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5620"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5619,
        "date": "2022-08-02T19:38:44",
        "date_gmt": "2022-08-02T19:38:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5619"
        },
        "modified": "2022-12-19T14:01:00",
        "modified_gmt": "2022-12-19T14:01:00",
        "slug": "patient-panel-calculator",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/patient-panel-calculator/",
        "title": {
            "rendered": "Patient Panel Calculator"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This tool serves physicians in all stages of their career to determine the ideal and balanced patient panel size.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis tool serves physicians in all stages of their career to determine the ideal and balanced patient panel size with consideration to their lifestyle, career preferences, and industry trends.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Patient Panel Calculator\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Patient%20Panel%20Calculator%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n<img class=\"alignnone size-full wp-image-8406\" src=\"http://van-division.yarko.dev/wp-content/uploads/2022/08/Screen-Shot-2022-12-19-at-2.55.55-PM.png\" alt=\"Patient Panel Calculator\" width=\"167\" height=\"182\" />\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5619"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5619"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5619"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5619"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5619"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5617,
        "date": "2022-08-02T19:35:43",
        "date_gmt": "2022-08-02T19:35:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5617"
        },
        "modified": "2023-01-11T23:05:47",
        "modified_gmt": "2023-01-11T23:05:47",
        "slug": "rn-lpn-business-case",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/rn-lpn-business-case/",
        "title": {
            "rendered": "RN/LPN Business Case"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This model aims to help weigh the business opportunity of integrating an RN or LPN into a family practice.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help weigh the business opportunity of integrating an RN or LPN into a family practice. The tool seeks to outline both the direct revenue and indirect value of such a position.\r\n\r\n</div>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to RN/LPN Business Case\" href=\"mailto:pcn@van-division.yarko.dev?Subject=RN/LPN%20Business%20Case%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                150,
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5617"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5617"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5617"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5617"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5617"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5616,
        "date": "2022-08-02T19:33:38",
        "date_gmt": "2022-08-02T19:33:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5616"
        },
        "modified": "2023-04-22T03:14:11",
        "modified_gmt": "2023-04-22T03:14:11",
        "slug": "moa-role-task-analysis",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/moa-role-task-analysis/",
        "title": {
            "rendered": "MOA Role &#038; Task Analysis"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "For physicians and clinics considering hiring new staff, to determine appropriate and competitive wages.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model seeks to support physicians employing staff and prospective clinics considering hiring new staff, to determine appropriate and competitive wages.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to MOA Role &amp; Task Analysis\" href=\"mailto:pcn@van-division.yarko.dev?Subject=MOA%20Role%20and%20Task%20Analysis%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5616"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5616"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5616"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5616"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5616"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5615,
        "date": "2022-08-02T19:30:15",
        "date_gmt": "2022-08-02T19:30:15",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5615"
        },
        "modified": "2023-01-11T23:11:54",
        "modified_gmt": "2023-01-11T23:11:54",
        "slug": "emr-comparison-tool",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/emr-comparison-tool/",
        "title": {
            "rendered": "EMR Comparison Tool"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "Supporting provider and clinic decisions related to implementing or switching their Electronic Medical Records (EMR) system.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to support provider and clinic decisions related to implementing or switching their Electronic Medical Records (EMR) system. This tool will allow interested physicians to compare commonly available EMRs based on start-up costs and ongoing financial commitments, as well as included and purchasable options.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to EMR Comparison Tool\" href=\"mailto:pcn@van-division.yarko.dev?Subject=EMR%20Comparison%20Tool%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5615"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5615"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5615"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5615"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5615"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5614,
        "date": "2022-08-02T19:28:05",
        "date_gmt": "2022-08-02T19:28:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5614"
        },
        "modified": "2023-01-11T23:30:26",
        "modified_gmt": "2023-01-11T23:30:26",
        "slug": "clinic-financial-driver-overview",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/clinic-financial-driver-overview/",
        "title": {
            "rendered": "Clinic Financial Driver Overview"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This model aims to facilitate financially informed and cognizant decision making.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to facilitate financially informed and cognizant decision making by supporting physicians to better understand the following areas:\r\n<ul>\r\n \t<li>Key financial drivers in their clinic</li>\r\n \t<li>Analysis and insight based on clinic financial performance</li>\r\n \t<li>The impact of different scenarios on future financial performance</li>\r\n</ul>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Clinic Financial Driver\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Clinic%20Financial%20Driver%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5614"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5614"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5614"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5614"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5614"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5613,
        "date": "2022-08-02T17:15:42",
        "date_gmt": "2022-08-02T17:15:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5613"
        },
        "modified": "2023-01-11T23:32:29",
        "modified_gmt": "2023-01-11T23:32:29",
        "slug": "capacity-potential-analysis-tool",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/capacity-potential-analysis-tool/",
        "title": {
            "rendered": "Capacity Potential Analysis Tool"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This model aims to help analyze a clinic’s current utilization of their space.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help analyze a clinic’s current utilization of their space. It also seeks to outline shifts that might result in suboptimal use of space. Clinics can decide if they want to seek better utilization, or appreciate the utility of the flexibility they might enjoy in their current state.\r\n\r\n</div>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Capacity Potential Analysis Tool\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Capacity%20Potential%20Analysis%20Tool%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                150,
                154
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5613"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5613"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5613"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5613"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5613"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5609,
        "date": "2022-07-28T17:08:58",
        "date_gmt": "2022-07-28T17:08:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5609"
        },
        "modified": "2022-07-28T17:08:58",
        "modified_gmt": "2022-07-28T17:08:58",
        "slug": "moa-guide-retirement",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/moa-guide-retirement/",
        "title": {
            "rendered": "MOA Guide &#8211; Retirement"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            128,
            72
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "A process outline for MOAs supporting a retiring physician.",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/MOA-Guide.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                154,
                152,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5609"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5609"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5609"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5609"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5609"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5607,
        "date": "2022-07-28T17:05:52",
        "date_gmt": "2022-07-28T17:05:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5607"
        },
        "modified": "2022-08-03T00:14:15",
        "modified_gmt": "2022-08-03T00:14:15",
        "slug": "paramedical-notification-letter",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/paramedical-notification-letter/",
        "title": {
            "rendered": "Paramedical Notification Letter"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A letter to inform paramedical services of a practice closure.",
            "resource-introduction": "",
            "resource-text": "A letter to inform paramedical services of a practice closure.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Paramedical-Services-Notification-Letter.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5607"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5607"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5607"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5607"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5607"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5605,
        "date": "2022-07-28T17:03:31",
        "date_gmt": "2022-07-28T17:03:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5605"
        },
        "modified": "2022-08-03T00:14:43",
        "modified_gmt": "2022-08-03T00:14:43",
        "slug": "colleague-notification-letter",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/colleague-notification-letter/",
        "title": {
            "rendered": "Colleague Notification Letter"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A form letter to colleagues informing them of your retirement.",
            "resource-introduction": "",
            "resource-text": "A form letter to colleagues informing them of your retirement.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Colleague-Notification-Letter.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152,
                165,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5605"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5605"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5605"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5605"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5605"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5603,
        "date": "2022-07-28T16:57:52",
        "date_gmt": "2022-07-28T16:57:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5603"
        },
        "modified": "2022-08-03T00:15:10",
        "modified_gmt": "2022-08-03T00:15:10",
        "slug": "takeover-notification-letter",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/takeover-notification-letter/",
        "title": {
            "rendered": "Takeover Notification Letter"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A form letter to inform patients of your leaving and introduce them to the physician taking over your practice.",
            "resource-introduction": "",
            "resource-text": "A form letter to inform patients of your leaving and introduce them to the physician taking over your practice.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Takeover-Notification-Letter.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152,
                165,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5603"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5603"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5603"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5603"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5603"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5598,
        "date": "2022-07-28T16:53:38",
        "date_gmt": "2022-07-28T16:53:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5598"
        },
        "modified": "2022-12-01T09:28:43",
        "modified_gmt": "2022-12-01T09:28:43",
        "slug": "retirement-notification-letter-template-outside-vancouver",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/retirement-notification-letter-template-outside-vancouver/",
        "title": {
            "rendered": "Retirement Notification Letter Template &#8211; Out of Vancouver Patients"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A letter used to notify patients of your retirement.",
            "resource-introduction": "",
            "resource-text": "This letter is personalized by and sent by the retiring physician. It is used to notify patients of their retirement. It also includes directions for patients to opt in to receive help finding a new healthcare provider and resources to search for care in their community.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/11/Out-of-Van-Patients-Notification-Letter.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152,
                165,
                164
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5598"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5598"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5598"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5598"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5598"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5566,
        "date": "2022-07-28T00:55:41",
        "date_gmt": "2022-07-28T00:55:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5566"
        },
        "modified": "2023-01-11T23:35:10",
        "modified_gmt": "2023-01-11T23:35:10",
        "slug": "associate-fee-structure",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/associate-fee-structure/",
        "title": {
            "rendered": "Associate Fee Structure"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            163
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This model helps providers and clinics, exploring a professional relationship, in identifying a suitable fee structure.",
            "resource-introduction": "",
            "resource-text": "<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help providers and clinics, exploring a professional relationship, in identifying a suitable fee structure. The tool allows providers and clinics to get a sense of the financial differences between available options and highlights some of the pros and cons of different fee structures.\r\n\r\nOne main goal of this tool is to facilitate transparency and to encourage full information for all parties to allow for better decision making. Both physicians and clinics can understand the key differences and similarities with different remuneration models, and weigh the pros and cons of each.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Associate Fee Structure\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Associate%20Fee%20Structure%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                163
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5566"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5566"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5566"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5566"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5566"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5568,
        "date": "2022-07-26T23:06:56",
        "date_gmt": "2022-07-26T23:06:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5568"
        },
        "modified": "2022-08-03T00:37:40",
        "modified_gmt": "2022-08-03T00:37:40",
        "slug": "accepting-provider-reminder-email",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/accepting-provider-reminder-email/",
        "title": {
            "rendered": "Accepting Provider Reminder Email"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            162
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "We will send two reminder emails to the accepting provider and their front desk staff.",
            "resource-introduction": "",
            "resource-text": "We will send two reminder emails to the accepting provider and their front desk staff one week before patients receive the reallocation email.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Email Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Accepting-Provider-Reminder-Emails.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                162
            ],
            "related_campaigns": [
                152,
                164
            ],
            "related_events": [
                156
            ]
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5568"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "event_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5568"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5568"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5568"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5568"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5785,
        "date": "2022-07-20T00:34:02",
        "date_gmt": "2022-07-20T00:34:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5785"
        },
        "modified": "2022-08-30T07:19:40",
        "modified_gmt": "2022-08-30T07:19:40",
        "slug": "fast-facts-july-20-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-july-20-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; July 20, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/54d00550d432/fast-facts-9042413",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                117,
                152,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5785"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5785"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5785"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5785"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5785"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5357,
        "date": "2022-07-18T12:28:27",
        "date_gmt": "2022-07-18T12:28:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5357"
        },
        "modified": "2022-07-18T12:29:18",
        "modified_gmt": "2022-07-18T12:29:18",
        "slug": "qualification-criteria-for-np-service-contracts",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/qualification-criteria-for-np-service-contracts/",
        "title": {
            "rendered": "Qualification Criteria for NP Service Contracts"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "See if you or your clinic is eligible to participate in the NP Service Contracts program.",
            "resource-introduction": "",
            "resource-text": "<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<div class=\"field-wrapper field field-node--field-lower-body field-name-field-lower-body field-type-text-long field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n\r\nThese contracts are one piece of the Primary Care Network development underway in Vancouver. Clinics and NPs interested in the contract opportunities must be willing to participate in Primary Care Network development in their local areas as they evolve.\r\n\r\nThe Ministry of Health has approved Community Health Areas (CHAs) 1 – 6 to start implementing NP contracted providers. Currently, CHA-1 and CHA-3 are full for NP positions but we are actively recruiting for CHA-2, 4, 5, and 6.\r\n\r\nThese criteria were put in place to identify clinics that will be a supportive environment for NPs to start a practice, with the goal of long-term attachment.\r\n<h3>Qualification Criteria for Clinics</h3>\r\n<ul>\r\n \t<li>EMR</li>\r\n \t<li>More than two physicians at the clinic</li>\r\n \t<li>Physical space to accommodate an NP</li>\r\n \t<li>Full service family practice</li>\r\n \t<li>Buy-in from other physicians at the clinic</li>\r\n \t<li>Practice must be willing to work toward the attributes of the Patient Medical home</li>\r\n \t<li>Practice must be willing to join the PCN once it is established</li>\r\n \t<li>Practice must commit to involvement in Vancouver Division’s<em> </em>PMH and PCN development</li>\r\n \t<li>No one clinic or clinic owner in a CHA can receive more than 40% of allocated NPs for the region <em>*any clinic granted more than one NP will be reviewed and confirmed eligible on a case by case basis </em></li>\r\n \t<li>To remain eligible for additional NPs, the clinic must maintain a 1:1 FTE FP/NP ratio</li>\r\n</ul>\r\n<h3>Qualification Criteria for Nurse Practitioners</h3>\r\n<ul>\r\n \t<li>NPs who currently do not have a patient panel</li>\r\n \t<li>NPs interested in providing primary care to a patient panel</li>\r\n \t<li>Commitment to attaching patients according to MoH schedule (details in <em>NP Backgrounder and FAQ</em> document)</li>\r\n \t<li>NP must be willing to work toward the attributes of the Patient Medical home</li>\r\n \t<li>NP must be willing to join the PCN once it is established</li>\r\n \t<li>NP must commit to involvement in Vancouver Division’s PMH and PCN development</li>\r\n</ul>\r\n<h3>Express Interest</h3>\r\nIf you are interested in integrating a Nurse Practitioner into your clinic, or you are a Nurse Practitioner looking to start a patient panel under this model, please <a title=\"NP opportunities\" href=\"mailto:recruitmentvan@divisionsbc.ca\" target=\"_blank\" rel=\"noopener\">email us.</a>\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                154,
                150,
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5357"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5357"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5357"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5357"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5357"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5356,
        "date": "2022-07-18T12:16:10",
        "date_gmt": "2022-07-18T12:16:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5356"
        },
        "modified": "2022-07-18T12:16:10",
        "modified_gmt": "2022-07-18T12:16:10",
        "slug": "easi-maternity-care-project-faq",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/easi-maternity-care-project-faq/",
        "title": {
            "rendered": "EASI Maternity Care Project FAQ"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            148,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.",
            "resource-introduction": "The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients passionate about making the maternity journey in Vancouver as effective and seamlessly integrated as possible. By surveying maternity patients and providers in Vancouver, there was a clear need for easy access to quality and evidence-based information (such as tip sheets, videos, webpages, etc.) that helps patients navigate their journey while not being overwhelming. A diverse set of voices & perspectives from patients and providers have helped to identify the best resources to share. Please contact Bella Hauner at bhauner@van-division.yarko.dev if you have any questions.",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": true,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": [
                {
                    "resource-acc-item-title": "What is the EASI Maternity Care Project?",
                    "resource-acc-item-content": "The EASI acronym stands for “effective and seamlessly integrated” and everyone involved in the EASI Maternity Care Project wants to make maternity care EASI – for patients and clinicians. We are a Vancouver-focused, multi-phase project focused on responding to gaps in patient preparedness along the various stages of their maternity care journey. In our current work, maternity providers from family physicians, obstetricians and midwives, along with all the key allied health involved in maternity care as well as patients are working to create a Vancouver-based online maternity information hub for patients, bringing together a curated list of all the best patient resources you can rely on. The initiative is funded by the Shared Care Committee, a joint collaborative committee of Doctors of BC and the Ministry of Health."
                },
                {
                    "resource-acc-item-title": "What is your role?",
                    "resource-acc-item-content": "Right now, we are seeking feedback on an initial wireframe for the new online hub. Please see “We Need Your Help” for the steps to provide feedback, along with a short video."
                },
                {
                    "resource-acc-item-title": "What is the time commitment of the Pop-up?",
                    "resource-acc-item-content": "Once onto Zoom, we hope you will spend between 5-10 minutes navigating the dynamic wireframe and narrate your feedback in real time via a recording."
                },
                {
                    "resource-acc-item-title": "Why should I be involved in this project?",
                    "resource-acc-item-content": "Just a handful of reasons why we think you’ll want to be involved:\r\n\r\n<li>You want to make the maternity care journey easier and more supported for patients in Vancouver;\r\n<li>You will use and find value in the online information hub (as a maternity provider, as someone considering or in a maternity journey, or you have a loved one that would value this resource)\r\nand want a sneak peek at what will be in it; and\r\n<.i>This is important work and your time will be recognized. (Note: We ask for your name and contact email when you upload a feedback video, so we can follow-up with a token of appreciation.)"
                }
            ],
            "related_resources": [
                148
            ],
            "related_campaigns": [
                79,
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5356"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5356"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5356"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5356"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5356"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5355,
        "date": "2022-07-18T11:47:44",
        "date_gmt": "2022-07-18T11:47:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5355"
        },
        "modified": "2022-08-03T00:39:06",
        "modified_gmt": "2022-08-03T00:39:06",
        "slug": "qualification-criteria-for-fp-service-contracts",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/qualification-criteria-for-fp-service-contracts/",
        "title": {
            "rendered": "Qualification Criteria for FP Service Contracts"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            155,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "See if you or your clinic is eligible to participate in the FP Service Contracts program.",
            "resource-introduction": "",
            "resource-text": "<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n\r\nThese contracts are one piece of the Primary Care Network development underway in Vancouver. Clinics and physicians interested in the salaried service contracts must be willing to participate in Primary Care Network development in their local areas as they evolve.\r\n\r\nAll six Community Health Areas (CHA) in Vancouver have been approved and there are positions all across the city for family physicians looking at these salaried contracts.\r\n\r\nTo browse available clinics in Vancouver, <a title=\"Practice In Vancouver\" href=\"/practice-in-vancouver/\">click here</a> to access our recruitment website.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n<div class=\"field-wrapper field field-node--field-lower-body field-name-field-lower-body field-type-text-long field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<h3>Qualification Criteria for Physicians</h3>\r\n<ul>\r\n \t<li>Family physician who currently does not have a patient panel</li>\r\n \t<li>Agreement to attach patients according to Ministry of Health schedule</li>\r\n \t<li>Physicians interested in the salaried service contract must be willing to participate in Primary Care Network development in their local areas as they evolve.</li>\r\n</ul>\r\n<h3>Helpful Information</h3>\r\n<ul>\r\n \t<li><a title=\"Health Match BC\" href=\"https://pcn.healthmatchbc.org/\" target=\"_blank\" rel=\"noopener\">Health Match BC PCN Information</a></li>\r\n \t<li><a href=\"https://van-division.yarko.dev/division/\" target=\"_blank\" rel=\"noopener\">Vancouver Division Home Page</a></li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "",
            "resource-button_link": "",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                154,
                150,
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5355"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5355"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5355"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5355"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5355"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 4460,
        "date": "2022-07-12T15:39:37",
        "date_gmt": "2022-07-12T15:39:37",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=4460"
        },
        "modified": "2022-08-02T23:15:28",
        "modified_gmt": "2022-08-02T23:15:28",
        "slug": "cbt-skills-group-one-pager",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cbt-skills-group-one-pager/",
        "title": {
            "rendered": "CBT Skills Group One-Pager"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            118,
            124,
            119
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Go beyond medication and help your patients build mental health self-management skills with CBT Skills Group.",
            "resource-introduction": "",
            "resource-text": "Go beyond medication and help your patients build mental health self-management skills with CBT Skills Group.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/VDFP_CBT-SKILLS_CNM-MEMO_20220627.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                118,
                119
            ],
            "related_campaigns": [
                79
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/4460"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4460"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=4460"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=4460"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=4460"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5782,
        "date": "2022-07-06T00:32:45",
        "date_gmt": "2022-07-06T00:32:45",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5782"
        },
        "modified": "2022-08-07T00:32:10",
        "modified_gmt": "2022-08-07T00:32:10",
        "slug": "fast-facts-july-6-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-july-6-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; July 6, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9039321",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                117,
                152,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5782"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5782"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5782"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5782"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5782"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 4000,
        "date": "2022-07-04T20:50:43",
        "date_gmt": "2022-07-04T20:50:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=4000"
        },
        "modified": "2022-08-03T00:41:50",
        "modified_gmt": "2022-08-03T00:41:50",
        "slug": "fp-backgrounder-and-faq",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fp-backgrounder-and-faq/",
        "title": {
            "rendered": "FP Backgrounder and FAQ"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            155,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "Additional background and questions answered regarding the Family Practice Service Contracts.",
            "resource-introduction": "",
            "resource-text": "Additional background and questions answered regarding the Family Practice Service Contracts.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/FAQs-New-to-Practice-FP-Contract.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/4000"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4000"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=4000"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=4000"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=4000"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3999,
        "date": "2022-07-04T20:47:27",
        "date_gmt": "2022-07-04T20:47:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3999"
        },
        "modified": "2022-08-03T00:40:32",
        "modified_gmt": "2022-08-03T00:40:32",
        "slug": "family-physician-contract-template",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/family-physician-contract-template/",
        "title": {
            "rendered": "Family Physician Contract Template"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            155
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A contract template for Family Physicians.",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Contract Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/N2P-Contract-Template_Revised.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3999"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3999"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3999"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3999"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3999"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3983,
        "date": "2022-07-04T20:42:04",
        "date_gmt": "2022-07-04T20:42:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3983"
        },
        "modified": "2022-08-03T00:42:07",
        "modified_gmt": "2022-08-03T00:42:07",
        "slug": "overview-of-new-n2p-contract",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/overview-of-new-n2p-contract/",
        "title": {
            "rendered": "Overview of New N2P Contract"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            155,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "An hours based contract for individual family physicians who do not have a patient panel.",
            "resource-introduction": "",
            "resource-text": "An hours based contract for individual family physicians who do not have a patient panel.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Individual-contract-for-new-to-practice-family-physicians-Guide.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                155
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3983"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3983"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3983"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3983"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3983"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3872,
        "date": "2022-07-04T18:18:49",
        "date_gmt": "2022-07-04T18:18:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3872"
        },
        "modified": "2022-08-03T00:45:30",
        "modified_gmt": "2022-08-03T00:45:30",
        "slug": "nurse-practitioner-overhead-guidelines-and-principles",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/nurse-practitioner-overhead-guidelines-and-principles/",
        "title": {
            "rendered": "Nurse Practitioner Overhead Guidelines and Principles"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "This document is provided as guidelines related to the NP overhead allocation provided within the NP service contracts.",
            "resource-introduction": "",
            "resource-text": "This document is provided as guidelines related to the NP overhead allocation provided within the NP service contracts.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/PCN_NP_Overhead_Principles_July_2019_Final.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3872"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3872"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3872"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3872"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3872"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3870,
        "date": "2022-07-04T18:13:19",
        "date_gmt": "2022-07-04T18:13:19",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3870"
        },
        "modified": "2022-08-03T00:46:19",
        "modified_gmt": "2022-08-03T00:46:19",
        "slug": "np-practice-agreement-template",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/np-practice-agreement-template/",
        "title": {
            "rendered": "NP Practice Agreement Template"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            149
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "This Agreement is a template intended to assist practitioners when a Contracted NP joins a practice.",
            "resource-introduction": "",
            "resource-text": "This Agreement is a template intended to assist practitioners when a Contracted NP joins a practice.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Contract Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Practice-Agreement-FINAL-181023.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3870"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3870"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3870"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3870"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3870"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3868,
        "date": "2022-07-04T18:07:12",
        "date_gmt": "2022-07-04T18:07:12",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3868"
        },
        "modified": "2022-08-03T00:46:59",
        "modified_gmt": "2022-08-03T00:46:59",
        "slug": "ministry-primary-care-np-template",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/ministry-primary-care-np-template/",
        "title": {
            "rendered": "Ministry Primary Care NP Template"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            149
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A template for a Primary Care Nurse Practitioner Contract.",
            "resource-introduction": "",
            "resource-text": "A template for a Primary Care Nurse Practitioner Contract.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Contract Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Primary-Care-NP-Template-FINAL-181023.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3868"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3868"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3868"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3868"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3868"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3866,
        "date": "2022-07-04T18:02:10",
        "date_gmt": "2022-07-04T18:02:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3866"
        },
        "modified": "2022-08-03T00:48:39",
        "modified_gmt": "2022-08-03T00:48:39",
        "slug": "np-primary-care-role-summary",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/np-primary-care-role-summary/",
        "title": {
            "rendered": "NP Primary Care Role Summary"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The Interdisciplinary Team Based Care Policy outlines the importance of patient-centred, relationship-based care.",
            "resource-introduction": "",
            "resource-text": "The Interdisciplinary Team Based Care Policy outlines the importance of patient-centred, relationship-based care.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Primary-Care-Role-Summary.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3866"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3866"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3866"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3866"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3866"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3864,
        "date": "2022-07-04T17:55:18",
        "date_gmt": "2022-07-04T17:55:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3864"
        },
        "modified": "2022-08-03T00:44:39",
        "modified_gmt": "2022-08-03T00:44:39",
        "slug": "np-backgrounder-and-faq",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/np-backgrounder-and-faq/",
        "title": {
            "rendered": "NP Backgrounder and FAQ"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124,
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The government of BC recently announced its vision for an integrated system of primary and community care across the province",
            "resource-introduction": "",
            "resource-text": "The government of BC recently announced its vision for an integrated system of primary and community care across the province.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Backgrounder-and-FAQ-Final-181023.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3864"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3864"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3864"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3864"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3864"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3862,
        "date": "2022-07-04T17:51:44",
        "date_gmt": "2022-07-04T17:51:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3862"
        },
        "modified": "2022-08-03T00:49:07",
        "modified_gmt": "2022-08-03T00:49:07",
        "slug": "what-to-expect-as-a-clinic-or-np",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/what-to-expect-as-a-clinic-or-np/",
        "title": {
            "rendered": "What to Expect as a Clinic or NP"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            149
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "What can the Nurse Practitioner and the Clinic expect?",
            "resource-introduction": "",
            "resource-text": "What can the Nurse Practitioner and the Clinic expect?",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Contract-Positions-NP-What-to-Expect.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                149
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3862"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3862"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3862"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3862"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3862"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3859,
        "date": "2022-07-04T17:13:32",
        "date_gmt": "2022-07-04T17:13:32",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3859"
        },
        "modified": "2022-07-04T17:14:18",
        "modified_gmt": "2022-07-04T17:14:18",
        "slug": "easi-maternity-care-project",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/easi-maternity-care-project/",
        "title": {
            "rendered": "EASI Maternity Care Project"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            148,
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.",
            "resource-introduction": "",
            "resource-text": "The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients passionate about making the maternity journey in Vancouver* as effective and seamlessly integrated as possible.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/Bare_PRGVAN-infog-08-17-21-1.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                148,
                124
            ],
            "related_campaigns": [
                91,
                90
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3859"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/124"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3859"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3859"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3859"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3859"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3419,
        "date": "2022-06-30T17:49:20",
        "date_gmt": "2022-06-30T17:49:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3419"
        },
        "modified": "2022-06-30T17:49:20",
        "modified_gmt": "2022-06-30T17:49:20",
        "slug": "fast-facts-may-11-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-may-11-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; May 11, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9020881",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3419"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3419"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3419"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3419"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3419"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3418,
        "date": "2022-06-30T17:48:42",
        "date_gmt": "2022-06-30T17:48:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3418"
        },
        "modified": "2022-07-27T01:20:25",
        "modified_gmt": "2022-07-27T01:20:25",
        "slug": "fast-facts-april-27-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-april-27-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; April 27, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/d9dddb44e7da/fast-facts-9017769",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                91,
                79,
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3418"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3418"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3418"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3418"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3418"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3417,
        "date": "2022-06-30T17:47:42",
        "date_gmt": "2022-06-30T17:47:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3417"
        },
        "modified": "2022-06-30T17:47:42",
        "modified_gmt": "2022-06-30T17:47:42",
        "slug": "fast-facts-april-13-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-april-13-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; April 13, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9009605",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3417"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3417"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3417"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3417"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3417"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 3258,
        "date": "2022-06-29T19:50:23",
        "date_gmt": "2022-06-29T19:50:23",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=3258"
        },
        "modified": "2022-09-26T16:37:01",
        "modified_gmt": "2022-09-26T16:37:01",
        "slug": "role-description-of-the-board-of-directors",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/role-description-of-the-board-of-directors/",
        "title": {
            "rendered": "Ways to Get Involved"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            124
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "To provide clarity for members interested in leadership opportunities, the Division has created the following table.",
            "resource-introduction": "",
            "resource-text": "<strong>Fiduciary Duty and Duty of Care:</strong>\r\n\r\nA board member (or Director) is a fiduciary for the Division, meaning a person who holds a legal and ethical responsibility to care for the money or other assets of the organization. A Director acts ethically, and in good faith with a view to the best interests of the Division and its members, and in so doing, supports the Division in fulfilling its mission and discharging its accountabilities. A Director exercises the care, diligence and skill that a reasonably prudent person would exercise in comparable circumstances. Directors with special skill and knowledge are expected to apply that skill and knowledge to matters that come before the Board.\r\n\r\n<strong>Responsibilities and Accountabilities as a Director:</strong>\r\n<ul>\r\n \t<li>Sets, maintains, and commits to the vision, mission and values of the organization.</li>\r\n \t<li>Develops strategy (e.g., long-term strategic plan). The 2019 strategic priorities can be found on the Division website by <a href=\"https://van-division.yarko.dev/static/e60f7edfa2007715d4297862a3a1f54f/Strat-Priorities-2021.pdf\">clicking here</a>;</li>\r\n \t<li>Keeps up to date with issues and trends that affect the organization;</li>\r\n \t<li>Adheres to the Carver Model of Governance;</li>\r\n \t<li>Understands and monitors the organization’s financial affairs;</li>\r\n \t<li>Avoids any potential conflicts of interests;</li>\r\n \t<li>Understands and maintains confidentiality;</li>\r\n \t<li>Does not represent the specific interests of any constituency or group;</li>\r\n \t<li>Acts and makes decisions that are in the best interest of the Division as a whole;</li>\r\n \t<li>Creates and/or approves the organization’s policies;</li>\r\n \t<li>Selects, manages, and supports the organization’s chief executive;</li>\r\n \t<li>Ensures compliance with governing documents (e.g. constitution and by-laws);</li>\r\n \t<li>Ensures accountability and compliance with laws and regulations;</li>\r\n \t<li>Attends and prepares adequately for regular board meetings; and,</li>\r\n \t<li>Attends committee meetings as a board liaison, as required and agreed upon.</li>\r\n</ul>\r\n<strong>Type of Board Members and Term Limits:</strong>\r\n\r\nFor all types of directors, there will be a limit of three (3) consecutive terms, after which a General Member is not eligible for re-election as a Director until they have ceased to be a Director for at least one (1) year.\r\n\r\nThere are two types of directors:\r\n<ol>\r\n \t<li><strong>FP Member Directors</strong> – General Members in good standing can serve as a FP Member Director, each term being two (2) years in length.</li>\r\n \t<li><strong>Resident Member Directors</strong> – Resident Members in good standing can serve as a Resident Member Director, each term being for one (1) year in length.</li>\r\n</ol>\r\nPlease note: Associate Members (e.g. retired members) are ineligible for nomination to the board and are ineligible to nominate a member for a board position.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "View the Table",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/06/Leadership-Table-2021.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/3258"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3258"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3258"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3258"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3258"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5780,
        "date": "2022-06-22T00:30:27",
        "date_gmt": "2022-06-22T00:30:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5780"
        },
        "modified": "2022-08-07T00:32:46",
        "modified_gmt": "2022-08-07T00:32:46",
        "slug": "fast-facts-june-22-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-june-22-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; June 22, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9033601",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                117,
                152,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5780"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5780"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5780"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5780"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5780"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2879,
        "date": "2022-06-16T03:49:33",
        "date_gmt": "2022-06-16T03:49:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=2879"
        },
        "modified": "2022-07-04T17:44:31",
        "modified_gmt": "2022-07-04T17:44:31",
        "slug": "cbt-skills-group-initiative-results",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cbt-skills-group-initiative-results/",
        "title": {
            "rendered": "CBT Skills Group Initiative Results"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            118,
            128,
            119,
            125
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "91% of physician wellness participants (64 of 69) would recommend program to colleagues.",
            "resource-introduction": "",
            "resource-text": "This summary presents evaluation findings from Jan-March 2022 of the CBT Skills Groups Initiative, which offers CBT Skills training to physicians and patients.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the PDF",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/06/CBTSkillsSummary_Q12022.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                118,
                119,
                125,
                128
            ],
            "related_campaigns": [
                79,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/2879"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/128"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2879"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2879"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2879"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2879"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2532,
        "date": "2022-06-15T08:12:30",
        "date_gmt": "2022-06-15T08:12:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=2532"
        },
        "modified": "2022-11-30T10:11:27",
        "modified_gmt": "2022-11-30T10:11:27",
        "slug": "notification-letter-template",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/notification-letter-template/",
        "title": {
            "rendered": "Notification Letter Template – Vancouver Patients"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A letter personalized by and sent by the retiring doctor to notify patients of their retirement.",
            "resource-introduction": "",
            "resource-text": "This letter is personalized by and sent by the retiring physician. It is used to notify patients of their retirement. It also includes directions for patients to opt in to receive help finding a new healthcare provider and resources to search for care in their community.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/In-Van-Patients-Notification-Letter.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                154,
                152,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/2532"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2532"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2532"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2532"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2532"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2530,
        "date": "2022-06-15T08:08:30",
        "date_gmt": "2022-06-15T08:08:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=2530"
        },
        "modified": "2022-07-28T16:54:50",
        "modified_gmt": "2022-07-28T16:54:50",
        "slug": "sample-reallocation-letter",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/sample-reallocation-letter/",
        "title": {
            "rendered": "Sample Reallocation Letter"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            127,
            162,
            72
        ],
        "resource_cat": [
            92
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2270,
            "post-excerpt": "A letter template to notify patients of a new provider.",
            "resource-introduction": "",
            "resource-text": "This letter template is sent by the Division to patients to notify them of their new healthcare provider. The information provided in this letter includes their new providers name and clinic contact information to book an appointment. In addition, where to access their medical record.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Letter Template",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/07/In-Van-Reallocation-Email.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152,
                154,
                150
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/2530"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2530"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2530"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2530"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2530"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2526,
        "date": "2022-06-15T07:44:55",
        "date_gmt": "2022-06-15T07:44:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=2526"
        },
        "modified": "2022-08-03T00:52:17",
        "modified_gmt": "2022-08-03T00:52:17",
        "slug": "cpsbc-guidelines",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/cpsbc-guidelines/",
        "title": {
            "rendered": "CPSBC Guidelines"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            72
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The CPSBC recommends that retiring physicians notify their patients and colleagues at least 3 months in advance.",
            "resource-introduction": "",
            "resource-text": "The CPSBC recommends that retiring physicians notify their patients and colleagues at least 3 months in advance of their departure. These CPSBC Guidelines outline several important considerations, such as patient medical record stewardship.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/06/PSG-Leaving-Practice.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/2526"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2526"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2526"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2526"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2526"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 2523,
        "date": "2022-06-15T07:42:27",
        "date_gmt": "2022-06-15T07:42:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=2523"
        },
        "modified": "2022-08-03T00:52:39",
        "modified_gmt": "2022-08-03T00:52:39",
        "slug": "how-to-retire-guide",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/how-to-retire-guide/",
        "title": {
            "rendered": "How to Retire Guide"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            72
        ],
        "resource_cat": [
            77
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "The Vancouver Division created this 52-page guide ​to help family doctors map out a plan for their retirement.",
            "resource-introduction": "",
            "resource-text": "The Vancouver Division created this 52-page guide ​to help family doctors map out a plan for their retirement.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Download the Guide",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/06/VDoFP_Retirement_FINAL.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                72
            ],
            "related_campaigns": [
                152
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/2523"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2523"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2523"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2523"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2523"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5779,
        "date": "2022-06-08T00:25:29",
        "date_gmt": "2022-06-08T00:25:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5779"
        },
        "modified": "2022-08-07T00:33:13",
        "modified_gmt": "2022-08-07T00:33:13",
        "slug": "fast-facts-june-8-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-june-8-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; June 8, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9030501",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                117,
                152,
                165
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5779"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5779"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5779"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5779"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5779"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 5777,
        "date": "2022-05-25T00:24:20",
        "date_gmt": "2022-05-25T00:24:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=5777"
        },
        "modified": "2022-08-07T00:33:24",
        "modified_gmt": "2022-08-07T00:33:24",
        "slug": "fast-facts-may-25-2022",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/fast-facts-may-25-2022/",
        "title": {
            "rendered": "Fast Facts &#8211; May 25, 2022"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            126
        ],
        "resource_cat": [
            76
        ],
        "catalogue": [],
        "acf": {
            "post-icon": 2242,
            "post-excerpt": "",
            "resource-introduction": "",
            "resource-text": "",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Read the Newsletter",
            "resource-button_link": "https://mailchi.mp/vancouverdivision.com/fast-facts-9025897",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                126
            ],
            "related_campaigns": [
                152,
                165,
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/5777"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"
                },
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5777"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5777"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5777"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5777"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7391,
        "date": "2022-01-15T23:06:45",
        "date_gmt": "2022-01-15T23:06:45",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=resource&#038;p=7391"
        },
        "modified": "2022-10-26T23:07:26",
        "modified_gmt": "2022-10-26T23:07:26",
        "slug": "mental-health-and-addictions-infographic",
        "status": "publish",
        "type": "resource",
        "link": "https://van-division.yarko.dev/resource/mental-health-and-addictions-infographic/",
        "title": {
            "rendered": "Mental Health and Addictions Infographic"
        },
        "featured_media": 0,
        "template": "",
        "resource_type": [
            119,
            125
        ],
        "resource_cat": [],
        "catalogue": [],
        "acf": {
            "post-icon": 2268,
            "post-excerpt": "An infographic synopsis of the White Paper on Mental Health and Addictions.",
            "resource-introduction": "",
            "resource-text": "The White Paper on Mental Health and Addictions is comprised of two parts. Through research, focus groups, and surveys from Vancouver Division family physicians, we developed a “current state” description of gaps within the system of mental health supports. In the second section we have suggested the myriad of opportunities to address the challenges with the system of mental health supports.",
            "resource-header_1": "",
            "resource-extended_information": "",
            "resource-extended_info_image": "",
            "resource-header_2": "",
            "resource-extended-info-2": "",
            "resource-content": "",
            "resource-button_text": "Browse the infographic",
            "resource-button_link": "http://van-division.yarko.dev/wp-content/uploads/2022/10/MAH-Infographic-V9.pdf",
            "resource-button_text_email": "",
            "resource-email_link": "",
            "resource-video_title": "",
            "resource-video": "",
            "resource-youtube-video": "",
            "resource-youtube_video_title": "",
            "resource-self_hosted_video": "",
            "resource-self_hosted_video_title": "",
            "resource-infographic": "",
            "resource-pdf_link": "",
            "resource-faq_accordion_activator": false,
            "resource-faq_header": "Frequently Asked Questions",
            "resource-faq_accordion_content": null,
            "related_resources": [
                119
            ],
            "related_campaigns": [
                117
            ],
            "related_events": []
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource/7391"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/resource"
                }
            ],
            "acf:term": [
                {
                    "embeddable": true,
                    "taxonomy": "campaign_topic",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"
                },
                {
                    "embeddable": true,
                    "taxonomy": "resource_type",
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7391"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "resource_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7391"
                },
                {
                    "taxonomy": "resource_cat",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7391"
                },
                {
                    "taxonomy": "catalogue",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7391"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export default database;


// WEBPACK FOOTER //
// ./src/databaseResources.js